// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.12.0
//   protoc               v6.32.1
// source: nova.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";

export const protobufPackage = "nova";

export interface Author {
  userId: string;
}

export interface BufferRange {
  distance: number;
  color: number;
  width: number;
}

export interface CogOrtho {
  createdAt: number;
  fileId: string;
  id: string;
  maxZoom: number;
  minZoom: number;
  maxLat: number;
  maxLng: number;
  minLng: number;
  minLat: number;
}

export interface ColorFinderImage {
  id: string;
  longitude: number;
  latitude: number;
  altitude?: number | undefined;
  height?: number | undefined;
  pitch?: number | undefined;
  yaw?: number | undefined;
  roll?: number | undefined;
  takenAt?: number | undefined;
  make?: string | undefined;
  focalLength?: number | undefined;
  size?: number | undefined;
  imageHeight?: number | undefined;
  imageWidth?: number | undefined;
  imageType?: number | undefined;
  colorData: Uint8Array;
  hasLowQuality?: boolean | undefined;
  fov: number[];
  uploadedAt?: number | undefined;
  model?: string | undefined;
  hasLRF?: boolean | undefined;
}

export interface ColorfinderImageBatch {
  entities: ColorFinderImage[];
}

export interface Coordinate {
  longitude: number;
  latitude: number;
}

export interface Filters {
  temperature?: MinMax | undefined;
  size?: MinMax | undefined;
  perimeter?: boolean | undefined;
}

export interface GenericLayer {
  id: string;
  createdAt: number;
  visible: boolean;
  name: string;
  index: string;
  parentId?: string | undefined;
  createdBy?: Author | undefined;
  demoId?: string | undefined;
  locked?: boolean | undefined;
  archivedTimestamp?: number | undefined;
}

export interface Group {
  id: string;
  createdAt: number;
  visible: boolean;
  name: string;
  index: string;
  parentId?: string | undefined;
  createdBy?: Author | undefined;
  groupType?: number | undefined;
  demoId?: string | undefined;
  locked?: boolean | undefined;
  archivedTimestamp?: number | undefined;
}

export interface Hotspot {
  id: string;
  createdAt: number;
  imageId: string;
  status: number;
  longitude: number;
  latitude: number;
  polygon: Coordinate[];
  perimeter: ImageCoordinate[];
  confidence: number;
  area?: number | undefined;
  temperature?: number | undefined;
  relativeImageCoordinates?: boolean | undefined;
}

export interface HotspotBatch {
  entities: Hotspot[];
}

export interface Icon {
  id: string;
  createdAt: number;
  visible: boolean;
  name: string;
  index: string;
  parentId?: string | undefined;
  url: string;
  longitude: number;
  latitude: number;
  color?: number | undefined;
  size: number;
  createdBy?: Author | undefined;
  demoId?: string | undefined;
  locked?: boolean | undefined;
  images: IconImage[];
  archivedTimestamp?: number | undefined;
  targetPayload?: string | undefined;
  outline?: number | undefined;
  width?: number | undefined;
}

export interface IconImage {
  altitude?: number | undefined;
  focalLength?: number | undefined;
  id: string;
  imageHeight?: number | undefined;
  imageWidth?: number | undefined;
  latitude?: number | undefined;
  longitude?: number | undefined;
  make?: string | undefined;
  size: number;
  takenAt?: number | undefined;
  index: string;
  fileName: string;
  hasThumbnail?: boolean | undefined;
}

export interface ImageColorFinderFlight {
  id: string;
  createdAt: number;
  visible: boolean;
  name: string;
  index: string;
  parentId?: string | undefined;
  images: ColorFinderImage[];
  createdBy?: Author | undefined;
  demoId?: string | undefined;
  processAfterUpload?: boolean | undefined;
  locked?: boolean | undefined;
  archivedTimestamp?: number | undefined;
  cumulativeColorIndex?: Uint8Array | undefined;
  anomalyPath?: string | undefined;
  colorDataPath?: string | undefined;
}

export interface ImageCoordinate {
  x: number;
  y: number;
  longitude: number;
  latitude: number;
}

export interface InfraredCompletePayload {
  minZoom: number;
  maxZoom: number;
  hotspots: Hotspot[];
  bbox: Coordinate[];
  area: number;
  scanArea: Coordinate[];
}

export interface InfraredFlight {
  id: string;
  createdAt: number;
  visible: boolean;
  name: string;
  index: string;
  parentId?: string | undefined;
  skippedProcessing?: boolean | undefined;
  orthoBoundingBox: Coordinate[];
  orthoGradient?: number | undefined;
  pointColor?: number | undefined;
  polyStroke?: number | undefined;
  polyFill?: number | undefined;
  pointType?: number | undefined;
  sensitivity?: number | undefined;
  job?: InfraredJob | undefined;
  images: InfraredImage[];
  hotspots: Hotspot[];
  perimeterDistance?: PerimeterDistance | undefined;
  createdBy?: Author | undefined;
  filters?: Filters | undefined;
  relativeSizeEnabled?: boolean | undefined;
  integrations?: string | undefined;
  mergeId?: string | undefined;
  demoId?: string | undefined;
  hexIsFlat?: boolean | undefined;
  processAfterUpload?: boolean | undefined;
  scanAreaFillColor?: number | undefined;
  scanAreaOutlineColor?: number | undefined;
  locked?: boolean | undefined;
  archivedTimestamp?: number | undefined;
  cogOrtho?: CogOrtho | undefined;
}

export interface InfraredImage {
  id: string;
  longitude: number;
  latitude: number;
  altitude?: number | undefined;
  height?: number | undefined;
  pitch?: number | undefined;
  yaw?: number | undefined;
  roll?: number | undefined;
  takenAt?: number | undefined;
  make?: string | undefined;
  focalLength?: number | undefined;
  size?: number | undefined;
  imageHeight?: number | undefined;
  imageWidth?: number | undefined;
  imageType?: number | undefined;
  fov: number[];
  model?: string | undefined;
  hasLowQuality?: boolean | undefined;
  hasLRF?: boolean | undefined;
}

export interface InfraredImageBatch {
  entities: InfraredImage[];
}

export interface InfraredJob {
  createdAt: number;
  deletedAt?: number | undefined;
  status: number;
  maxZoom?: number | undefined;
  extraFeatures?: string | undefined;
  progress?: number | undefined;
  updatedAt?: number | undefined;
  area?: number | undefined;
  minZoom?: number | undefined;
  error?: number | undefined;
  scanArea: Coordinate[];
  processingMode?: number | undefined;
}

export interface Layer {
  id: string;
  createdAt: number;
  visible: boolean;
  name: string;
  index: string;
  parentId?: string | undefined;
  demoId?: string | undefined;
  locked?: boolean | undefined;
  archivedTimestamp?: number | undefined;
}

export interface Line {
  id: string;
  createdAt: number;
  visible: boolean;
  name: string;
  index: string;
  parentId?: string | undefined;
  coordinates: Coordinate[];
  geometryType: number;
  width?: number | undefined;
  color?: number | undefined;
  outline?: number | undefined;
  fill?: number | undefined;
  stroke?: number | undefined;
  url?: string | undefined;
  polygonPattern?: string | undefined;
  holes: Polygon[];
  createdBy?: Author | undefined;
  demoId?: string | undefined;
  locked?: boolean | undefined;
  archivedTimestamp?: number | undefined;
}

export interface LiveVideoFlight {
  id: string;
  createdAt: number;
  visible: boolean;
  name: string;
  index: string;
  parentId?: string | undefined;
  createdBy: Author | undefined;
  live: boolean;
  recordingPrefix?: string | undefined;
  startedAt?: number | undefined;
  endedAt?: number | undefined;
  activated?: boolean | undefined;
  activatedAt?: number | undefined;
  code: number;
  recordingReady?: boolean | undefined;
  saveRecording: boolean;
  streamCreated?: boolean | undefined;
  demoId?: string | undefined;
  locked?: boolean | undefined;
  archivedTimestamp?: number | undefined;
  isMobile?: boolean | undefined;
  mp4Created?: boolean | undefined;
  pilotInitialCoordinate?: Coordinate | undefined;
  isMMA?: boolean | undefined;
  isAtlas?: boolean | undefined;
}

export interface MapComment {
  createdAt: number;
  createdBy: Author | undefined;
  id: string;
  latitude: number;
  longitude: number;
}

export interface MergedFlight {
  id: string;
  createdAt: number;
  visible: boolean;
  name: string;
  index: string;
  parentId?: string | undefined;
  createdBy?: Author | undefined;
  isSensitivitySynced?: boolean | undefined;
  demoId?: string | undefined;
  locked?: boolean | undefined;
  archivedTimestamp?: number | undefined;
}

export interface MinMax {
  min?: number | undefined;
  max?: number | undefined;
}

export interface NovaEntity {
  id: string;
  createdAt: number;
}

export interface OrthoCompletePayload {
  area: number;
  bbox: Coordinate[];
  maxZoom: number;
  minZoom: number;
  scanArea: Coordinate[];
}

export interface OrthoFlight {
  id: string;
  createdAt: number;
  visible: boolean;
  name: string;
  index: string;
  parentId?: string | undefined;
  orthoBoundingBox: Coordinate[];
  job?: OrthoJob | undefined;
  images: OrthoImage[];
  createdBy?: Author | undefined;
  integrations?: string | undefined;
  demoId?: string | undefined;
  scanAreaFillColor?: number | undefined;
  scanAreaOutlineColor?: number | undefined;
  processAfterUpload?: boolean | undefined;
  locked?: boolean | undefined;
  archivedTimestamp?: number | undefined;
  cogOrtho?: CogOrtho | undefined;
}

export interface OrthoImage {
  id: string;
  longitude: number;
  latitude: number;
  altitude?: number | undefined;
  height?: number | undefined;
  pitch?: number | undefined;
  yaw?: number | undefined;
  roll?: number | undefined;
  takenAt?: number | undefined;
  make?: string | undefined;
  focalLength?: number | undefined;
  size?: number | undefined;
  imageHeight?: number | undefined;
  imageWidth?: number | undefined;
  imageType?: number | undefined;
  fov: number[];
  model?: string | undefined;
  hasLowQuality?: boolean | undefined;
  hasLRF?: boolean | undefined;
}

export interface OrthoImageBatch {
  entities: OrthoImage[];
}

export interface OrthoJob {
  createdAt: number;
  deletedAt?: number | undefined;
  status: number;
  maxZoom?: number | undefined;
  extraFeatures?: string | undefined;
  progress?: number | undefined;
  updatedAt?: number | undefined;
  area?: number | undefined;
  minZoom?: number | undefined;
  error?: number | undefined;
  scanArea: Coordinate[];
  processingMode?: number | undefined;
}

export interface OrthoMask {
  createdAt: number;
  createdBy?: Author | undefined;
  enabled: boolean;
  flightId: string;
  id: string;
  parentId?: string | undefined;
  polygon: Polygon | undefined;
}

export interface PDFJob {
  createdAt: number;
  deletedAt?: number | undefined;
  status: number;
  id: string;
  name: string;
  hasPreview?: boolean | undefined;
  index: string;
  parentId?: string | undefined;
  pages?: number | undefined;
  createdBy?: Author | undefined;
  progress?: number | undefined;
  updatedAt?: number | undefined;
  hasEmbeddedNovaContext?: boolean | undefined;
  corners: Coordinate[];
}

export interface PDFRaster {
  id: string;
  createdAt: number;
  name: string;
  index: string;
  parentId?: string | undefined;
  filename: string;
  corners: Coordinate[];
  createdBy?: Author | undefined;
  archivedTimestamp?: number | undefined;
  tiled?: boolean | undefined;
}

export interface PanoramaFlight {
  id: string;
  createdAt: number;
  visible: boolean;
  name: string;
  index: string;
  parentId?: string | undefined;
  images: PanoramaImage[];
  createdBy?: Author | undefined;
  demoId?: string | undefined;
  locked?: boolean | undefined;
  archivedTimestamp?: number | undefined;
}

export interface PanoramaImage {
  id: string;
  longitude?: number | undefined;
  latitude?: number | undefined;
  altitude?: number | undefined;
  pitch?: number | undefined;
  yaw?: number | undefined;
  roll?: number | undefined;
  takenAt: number;
  flightPitch?: number | undefined;
  flightYaw?: number | undefined;
  flightRoll?: number | undefined;
  hasLowQuality?: boolean | undefined;
}

export interface Perimeter {
  id: string;
  createdAt: number;
  visible: boolean;
  name: string;
  index: string;
  parentId?: string | undefined;
  polygons: Polygon[];
  createdBy?: Author | undefined;
  outline?: number | undefined;
  width?: number | undefined;
  stroke?: number | undefined;
  buffers?: PerimeterBuffer | undefined;
  demoId?: string | undefined;
  locked?: boolean | undefined;
  archivedTimestamp?: number | undefined;
}

export interface PerimeterBuffer {
  range: BufferRange[];
  unit: string;
}

export interface PerimeterDistance {
  range: Range[];
  unit: string;
}

export interface Polygon {
  coordinates: Coordinate[];
}

export interface Project {
  infraredFlights: InfraredFlight[];
  orthoFlights: OrthoFlight[];
  videoFlights: VideoFlight[];
  videoColorFinderFlights: VideoColorFinderFlight[];
  imageColorFinderFlights: ImageColorFinderFlight[];
  panoramaFlights: PanoramaFlight[];
  icons: Icon[];
  lines: Line[];
  texts: Text[];
  perimeters: Perimeter[];
  PDFs: PDFJob[];
  groups: Group[];
  PDFRasters: PDFRaster[];
  lastUpdated: string;
  liveVideoFlights: LiveVideoFlight[];
  mergedFlights: MergedFlight[];
  rulers: Ruler[];
  orthoMasks: OrthoMask[];
  satelliteFlights: SatelliteFlight[];
  mapComments: MapComment[];
  userLocationShares: UserLocationShare[];
}

export interface Range {
  distance: number;
  color: number;
}

export interface Ruler {
  areaUnit: string;
  coordinates: Coordinate[];
  createdAt: number;
  createdBy?: Author | undefined;
  distanceUnit: string;
  geometryType: number;
  id: string;
  index: string;
  name: string;
  parentId?: string | undefined;
  visible: boolean;
  demoId?: string | undefined;
  locked?: boolean | undefined;
  archivedTimestamp?: number | undefined;
}

export interface SatelliteFlight {
  archivedTimestamp?: number | undefined;
  createdAt: number;
  createdBy?: Author | undefined;
  demoId?: string | undefined;
  id: string;
  index: string;
  job?: SatelliteJob | undefined;
  locked?: boolean | undefined;
  name: string;
  parentId?: string | undefined;
  region: Coordinate[];
  sensorType?: number | undefined;
  visible: boolean;
  cloudFree?: boolean | undefined;
  temporalBias?: string | undefined;
  dehaze?: boolean | undefined;
  mosaic: SatelliteMosaic[];
  temporalAnchor?: number | undefined;
}

export interface SatelliteJob {
  createdAt: number;
  deletedAt?: number | undefined;
  error?: number | undefined;
  progress?: number | undefined;
  status: number;
  updatedAt?: number | undefined;
}

export interface SatelliteMosaic {
  cogOrtho: CogOrtho | undefined;
  processingOptions: string[];
}

export interface Text {
  id: string;
  createdAt: number;
  visible: boolean;
  name: string;
  index: string;
  parentId?: string | undefined;
  longitude: number;
  latitude: number;
  text: string;
  rotation: number;
  baseFontSize: number;
  fontSize: number;
  color: number;
  bold: boolean;
  createdBy?: Author | undefined;
  demoId?: string | undefined;
  outlineColor?: number | undefined;
  outlineWidth?: number | undefined;
  locked?: boolean | undefined;
  archivedTimestamp?: number | undefined;
}

export interface UserLocationShare {
  archivedTimestamp?: number | undefined;
  createdAt: number;
  createdBy?: Author | undefined;
  demoId?: string | undefined;
  id: string;
  index: string;
  initialCoordinate?: Coordinate | undefined;
  live: boolean;
  locked?: boolean | undefined;
  name: string;
  parentId?: string | undefined;
  visible: boolean;
  endedAt?: number | undefined;
}

export interface VideoColorFinderFlight {
  id: string;
  createdAt: number;
  visible: boolean;
  name: string;
  index: string;
  parentId?: string | undefined;
  job?: VideoColorFinderJob | undefined;
  createdBy?: Author | undefined;
  isCreatedFromVideo?: boolean | undefined;
  referenceVideoId?: string | undefined;
  demoId?: string | undefined;
  locked?: boolean | undefined;
  archivedTimestamp?: number | undefined;
  startingPosition?: Coordinate | undefined;
}

export interface VideoColorFinderJob {
  createdAt: number;
  deletedAt?: number | undefined;
  status: number;
  metadataPath?: string | undefined;
  srtPath?: string | undefined;
  videoPath: string;
  resolutions: string[];
  colordataPath: string;
  cumulativeColorIndex?: Uint8Array | undefined;
  numFrames?: number | undefined;
  anomalyPath?: string | undefined;
}

export interface VideoFlight {
  id: string;
  createdAt: number;
  visible: boolean;
  name: string;
  index: string;
  parentId?: string | undefined;
  job?: VideoJob | undefined;
  createdBy?: Author | undefined;
  demoId?: string | undefined;
  startingPosition?: Coordinate | undefined;
  locked?: boolean | undefined;
  archivedTimestamp?: number | undefined;
}

export interface VideoJob {
  createdAt: number;
  deletedAt?: number | undefined;
  status: number;
  metadataPath?: string | undefined;
  srtPath?: string | undefined;
  videoPath: string;
  resolutions: string[];
}

function createBaseAuthor(): Author {
  return { userId: "" };
}

export const Author: MessageFns<Author> = {
  encode(message: Author, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.userId !== "") {
      writer.uint32(10).string(message.userId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Author {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAuthor();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.userId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Author {
    return { userId: isSet(object.userId) ? globalThis.String(object.userId) : "" };
  },

  toJSON(message: Author): unknown {
    const obj: any = {};
    if (message.userId !== "") {
      obj.userId = message.userId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Author>, I>>(base?: I): Author {
    return Author.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Author>, I>>(object: I): Author {
    const message = createBaseAuthor();
    message.userId = object.userId ?? "";
    return message;
  },
};

function createBaseBufferRange(): BufferRange {
  return { distance: 0, color: 0, width: 0 };
}

export const BufferRange: MessageFns<BufferRange> = {
  encode(message: BufferRange, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.distance !== 0) {
      writer.uint32(13).float(message.distance);
    }
    if (message.color !== 0) {
      writer.uint32(16).uint32(message.color);
    }
    if (message.width !== 0) {
      writer.uint32(24).int32(message.width);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BufferRange {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBufferRange();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 13) {
            break;
          }

          message.distance = reader.float();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.color = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.width = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BufferRange {
    return {
      distance: isSet(object.distance) ? globalThis.Number(object.distance) : 0,
      color: isSet(object.color) ? globalThis.Number(object.color) : 0,
      width: isSet(object.width) ? globalThis.Number(object.width) : 0,
    };
  },

  toJSON(message: BufferRange): unknown {
    const obj: any = {};
    if (message.distance !== 0) {
      obj.distance = message.distance;
    }
    if (message.color !== 0) {
      obj.color = Math.round(message.color);
    }
    if (message.width !== 0) {
      obj.width = Math.round(message.width);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BufferRange>, I>>(base?: I): BufferRange {
    return BufferRange.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BufferRange>, I>>(object: I): BufferRange {
    const message = createBaseBufferRange();
    message.distance = object.distance ?? 0;
    message.color = object.color ?? 0;
    message.width = object.width ?? 0;
    return message;
  },
};

function createBaseCogOrtho(): CogOrtho {
  return { createdAt: 0, fileId: "", id: "", maxZoom: 0, minZoom: 0, maxLat: 0, maxLng: 0, minLng: 0, minLat: 0 };
}

export const CogOrtho: MessageFns<CogOrtho> = {
  encode(message: CogOrtho, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.createdAt !== 0) {
      writer.uint32(8).uint32(message.createdAt);
    }
    if (message.fileId !== "") {
      writer.uint32(18).string(message.fileId);
    }
    if (message.id !== "") {
      writer.uint32(26).string(message.id);
    }
    if (message.maxZoom !== 0) {
      writer.uint32(32).int32(message.maxZoom);
    }
    if (message.minZoom !== 0) {
      writer.uint32(40).int32(message.minZoom);
    }
    if (message.maxLat !== 0) {
      writer.uint32(49).double(message.maxLat);
    }
    if (message.maxLng !== 0) {
      writer.uint32(57).double(message.maxLng);
    }
    if (message.minLng !== 0) {
      writer.uint32(65).double(message.minLng);
    }
    if (message.minLat !== 0) {
      writer.uint32(73).double(message.minLat);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CogOrtho {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCogOrtho();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.createdAt = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.fileId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.maxZoom = reader.int32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.minZoom = reader.int32();
          continue;
        }
        case 6: {
          if (tag !== 49) {
            break;
          }

          message.maxLat = reader.double();
          continue;
        }
        case 7: {
          if (tag !== 57) {
            break;
          }

          message.maxLng = reader.double();
          continue;
        }
        case 8: {
          if (tag !== 65) {
            break;
          }

          message.minLng = reader.double();
          continue;
        }
        case 9: {
          if (tag !== 73) {
            break;
          }

          message.minLat = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CogOrtho {
    return {
      createdAt: isSet(object.createdAt) ? globalThis.Number(object.createdAt) : 0,
      fileId: isSet(object.fileId) ? globalThis.String(object.fileId) : "",
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      maxZoom: isSet(object.maxZoom) ? globalThis.Number(object.maxZoom) : 0,
      minZoom: isSet(object.minZoom) ? globalThis.Number(object.minZoom) : 0,
      maxLat: isSet(object.maxLat) ? globalThis.Number(object.maxLat) : 0,
      maxLng: isSet(object.maxLng) ? globalThis.Number(object.maxLng) : 0,
      minLng: isSet(object.minLng) ? globalThis.Number(object.minLng) : 0,
      minLat: isSet(object.minLat) ? globalThis.Number(object.minLat) : 0,
    };
  },

  toJSON(message: CogOrtho): unknown {
    const obj: any = {};
    if (message.createdAt !== 0) {
      obj.createdAt = Math.round(message.createdAt);
    }
    if (message.fileId !== "") {
      obj.fileId = message.fileId;
    }
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.maxZoom !== 0) {
      obj.maxZoom = Math.round(message.maxZoom);
    }
    if (message.minZoom !== 0) {
      obj.minZoom = Math.round(message.minZoom);
    }
    if (message.maxLat !== 0) {
      obj.maxLat = message.maxLat;
    }
    if (message.maxLng !== 0) {
      obj.maxLng = message.maxLng;
    }
    if (message.minLng !== 0) {
      obj.minLng = message.minLng;
    }
    if (message.minLat !== 0) {
      obj.minLat = message.minLat;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CogOrtho>, I>>(base?: I): CogOrtho {
    return CogOrtho.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CogOrtho>, I>>(object: I): CogOrtho {
    const message = createBaseCogOrtho();
    message.createdAt = object.createdAt ?? 0;
    message.fileId = object.fileId ?? "";
    message.id = object.id ?? "";
    message.maxZoom = object.maxZoom ?? 0;
    message.minZoom = object.minZoom ?? 0;
    message.maxLat = object.maxLat ?? 0;
    message.maxLng = object.maxLng ?? 0;
    message.minLng = object.minLng ?? 0;
    message.minLat = object.minLat ?? 0;
    return message;
  },
};

function createBaseColorFinderImage(): ColorFinderImage {
  return {
    id: "",
    longitude: 0,
    latitude: 0,
    altitude: undefined,
    height: undefined,
    pitch: undefined,
    yaw: undefined,
    roll: undefined,
    takenAt: undefined,
    make: undefined,
    focalLength: undefined,
    size: undefined,
    imageHeight: undefined,
    imageWidth: undefined,
    imageType: undefined,
    colorData: new Uint8Array(0),
    hasLowQuality: undefined,
    fov: [],
    uploadedAt: undefined,
    model: undefined,
    hasLRF: undefined,
  };
}

export const ColorFinderImage: MessageFns<ColorFinderImage> = {
  encode(message: ColorFinderImage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.longitude !== 0) {
      writer.uint32(17).double(message.longitude);
    }
    if (message.latitude !== 0) {
      writer.uint32(25).double(message.latitude);
    }
    if (message.altitude !== undefined) {
      writer.uint32(37).float(message.altitude);
    }
    if (message.height !== undefined) {
      writer.uint32(45).float(message.height);
    }
    if (message.pitch !== undefined) {
      writer.uint32(53).float(message.pitch);
    }
    if (message.yaw !== undefined) {
      writer.uint32(61).float(message.yaw);
    }
    if (message.roll !== undefined) {
      writer.uint32(69).float(message.roll);
    }
    if (message.takenAt !== undefined) {
      writer.uint32(72).uint32(message.takenAt);
    }
    if (message.make !== undefined) {
      writer.uint32(82).string(message.make);
    }
    if (message.focalLength !== undefined) {
      writer.uint32(93).float(message.focalLength);
    }
    if (message.size !== undefined) {
      writer.uint32(96).uint32(message.size);
    }
    if (message.imageHeight !== undefined) {
      writer.uint32(104).uint32(message.imageHeight);
    }
    if (message.imageWidth !== undefined) {
      writer.uint32(112).uint32(message.imageWidth);
    }
    if (message.imageType !== undefined) {
      writer.uint32(120).int32(message.imageType);
    }
    if (message.colorData.length !== 0) {
      writer.uint32(130).bytes(message.colorData);
    }
    if (message.hasLowQuality !== undefined) {
      writer.uint32(136).bool(message.hasLowQuality);
    }
    writer.uint32(146).fork();
    for (const v of message.fov) {
      writer.float(v);
    }
    writer.join();
    if (message.uploadedAt !== undefined) {
      writer.uint32(152).uint32(message.uploadedAt);
    }
    if (message.model !== undefined) {
      writer.uint32(162).string(message.model);
    }
    if (message.hasLRF !== undefined) {
      writer.uint32(168).bool(message.hasLRF);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ColorFinderImage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseColorFinderImage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.longitude = reader.double();
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.latitude = reader.double();
          continue;
        }
        case 4: {
          if (tag !== 37) {
            break;
          }

          message.altitude = reader.float();
          continue;
        }
        case 5: {
          if (tag !== 45) {
            break;
          }

          message.height = reader.float();
          continue;
        }
        case 6: {
          if (tag !== 53) {
            break;
          }

          message.pitch = reader.float();
          continue;
        }
        case 7: {
          if (tag !== 61) {
            break;
          }

          message.yaw = reader.float();
          continue;
        }
        case 8: {
          if (tag !== 69) {
            break;
          }

          message.roll = reader.float();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.takenAt = reader.uint32();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.make = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 93) {
            break;
          }

          message.focalLength = reader.float();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.size = reader.uint32();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.imageHeight = reader.uint32();
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.imageWidth = reader.uint32();
          continue;
        }
        case 15: {
          if (tag !== 120) {
            break;
          }

          message.imageType = reader.int32();
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.colorData = reader.bytes();
          continue;
        }
        case 17: {
          if (tag !== 136) {
            break;
          }

          message.hasLowQuality = reader.bool();
          continue;
        }
        case 18: {
          if (tag === 149) {
            message.fov.push(reader.float());

            continue;
          }

          if (tag === 146) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.fov.push(reader.float());
            }

            continue;
          }

          break;
        }
        case 19: {
          if (tag !== 152) {
            break;
          }

          message.uploadedAt = reader.uint32();
          continue;
        }
        case 20: {
          if (tag !== 162) {
            break;
          }

          message.model = reader.string();
          continue;
        }
        case 21: {
          if (tag !== 168) {
            break;
          }

          message.hasLRF = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ColorFinderImage {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      longitude: isSet(object.longitude) ? globalThis.Number(object.longitude) : 0,
      latitude: isSet(object.latitude) ? globalThis.Number(object.latitude) : 0,
      altitude: isSet(object.altitude) ? globalThis.Number(object.altitude) : undefined,
      height: isSet(object.height) ? globalThis.Number(object.height) : undefined,
      pitch: isSet(object.pitch) ? globalThis.Number(object.pitch) : undefined,
      yaw: isSet(object.yaw) ? globalThis.Number(object.yaw) : undefined,
      roll: isSet(object.roll) ? globalThis.Number(object.roll) : undefined,
      takenAt: isSet(object.takenAt) ? globalThis.Number(object.takenAt) : undefined,
      make: isSet(object.make) ? globalThis.String(object.make) : undefined,
      focalLength: isSet(object.focalLength) ? globalThis.Number(object.focalLength) : undefined,
      size: isSet(object.size) ? globalThis.Number(object.size) : undefined,
      imageHeight: isSet(object.imageHeight) ? globalThis.Number(object.imageHeight) : undefined,
      imageWidth: isSet(object.imageWidth) ? globalThis.Number(object.imageWidth) : undefined,
      imageType: isSet(object.imageType) ? globalThis.Number(object.imageType) : undefined,
      colorData: isSet(object.colorData) ? bytesFromBase64(object.colorData) : new Uint8Array(0),
      hasLowQuality: isSet(object.hasLowQuality) ? globalThis.Boolean(object.hasLowQuality) : undefined,
      fov: globalThis.Array.isArray(object?.fov) ? object.fov.map((e: any) => globalThis.Number(e)) : [],
      uploadedAt: isSet(object.uploadedAt) ? globalThis.Number(object.uploadedAt) : undefined,
      model: isSet(object.model) ? globalThis.String(object.model) : undefined,
      hasLRF: isSet(object.hasLRF) ? globalThis.Boolean(object.hasLRF) : undefined,
    };
  },

  toJSON(message: ColorFinderImage): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.longitude !== 0) {
      obj.longitude = message.longitude;
    }
    if (message.latitude !== 0) {
      obj.latitude = message.latitude;
    }
    if (message.altitude !== undefined) {
      obj.altitude = message.altitude;
    }
    if (message.height !== undefined) {
      obj.height = message.height;
    }
    if (message.pitch !== undefined) {
      obj.pitch = message.pitch;
    }
    if (message.yaw !== undefined) {
      obj.yaw = message.yaw;
    }
    if (message.roll !== undefined) {
      obj.roll = message.roll;
    }
    if (message.takenAt !== undefined) {
      obj.takenAt = Math.round(message.takenAt);
    }
    if (message.make !== undefined) {
      obj.make = message.make;
    }
    if (message.focalLength !== undefined) {
      obj.focalLength = message.focalLength;
    }
    if (message.size !== undefined) {
      obj.size = Math.round(message.size);
    }
    if (message.imageHeight !== undefined) {
      obj.imageHeight = Math.round(message.imageHeight);
    }
    if (message.imageWidth !== undefined) {
      obj.imageWidth = Math.round(message.imageWidth);
    }
    if (message.imageType !== undefined) {
      obj.imageType = Math.round(message.imageType);
    }
    if (message.colorData.length !== 0) {
      obj.colorData = base64FromBytes(message.colorData);
    }
    if (message.hasLowQuality !== undefined) {
      obj.hasLowQuality = message.hasLowQuality;
    }
    if (message.fov?.length) {
      obj.fov = message.fov;
    }
    if (message.uploadedAt !== undefined) {
      obj.uploadedAt = Math.round(message.uploadedAt);
    }
    if (message.model !== undefined) {
      obj.model = message.model;
    }
    if (message.hasLRF !== undefined) {
      obj.hasLRF = message.hasLRF;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ColorFinderImage>, I>>(base?: I): ColorFinderImage {
    return ColorFinderImage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ColorFinderImage>, I>>(object: I): ColorFinderImage {
    const message = createBaseColorFinderImage();
    message.id = object.id ?? "";
    message.longitude = object.longitude ?? 0;
    message.latitude = object.latitude ?? 0;
    message.altitude = object.altitude ?? undefined;
    message.height = object.height ?? undefined;
    message.pitch = object.pitch ?? undefined;
    message.yaw = object.yaw ?? undefined;
    message.roll = object.roll ?? undefined;
    message.takenAt = object.takenAt ?? undefined;
    message.make = object.make ?? undefined;
    message.focalLength = object.focalLength ?? undefined;
    message.size = object.size ?? undefined;
    message.imageHeight = object.imageHeight ?? undefined;
    message.imageWidth = object.imageWidth ?? undefined;
    message.imageType = object.imageType ?? undefined;
    message.colorData = object.colorData ?? new Uint8Array(0);
    message.hasLowQuality = object.hasLowQuality ?? undefined;
    message.fov = object.fov?.map((e) => e) || [];
    message.uploadedAt = object.uploadedAt ?? undefined;
    message.model = object.model ?? undefined;
    message.hasLRF = object.hasLRF ?? undefined;
    return message;
  },
};

function createBaseColorfinderImageBatch(): ColorfinderImageBatch {
  return { entities: [] };
}

export const ColorfinderImageBatch: MessageFns<ColorfinderImageBatch> = {
  encode(message: ColorfinderImageBatch, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.entities) {
      ColorFinderImage.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ColorfinderImageBatch {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseColorfinderImageBatch();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.entities.push(ColorFinderImage.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ColorfinderImageBatch {
    return {
      entities: globalThis.Array.isArray(object?.entities)
        ? object.entities.map((e: any) => ColorFinderImage.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ColorfinderImageBatch): unknown {
    const obj: any = {};
    if (message.entities?.length) {
      obj.entities = message.entities.map((e) => ColorFinderImage.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ColorfinderImageBatch>, I>>(base?: I): ColorfinderImageBatch {
    return ColorfinderImageBatch.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ColorfinderImageBatch>, I>>(object: I): ColorfinderImageBatch {
    const message = createBaseColorfinderImageBatch();
    message.entities = object.entities?.map((e) => ColorFinderImage.fromPartial(e)) || [];
    return message;
  },
};

function createBaseCoordinate(): Coordinate {
  return { longitude: 0, latitude: 0 };
}

export const Coordinate: MessageFns<Coordinate> = {
  encode(message: Coordinate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.longitude !== 0) {
      writer.uint32(9).double(message.longitude);
    }
    if (message.latitude !== 0) {
      writer.uint32(17).double(message.latitude);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Coordinate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCoordinate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 9) {
            break;
          }

          message.longitude = reader.double();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.latitude = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Coordinate {
    return {
      longitude: isSet(object.longitude) ? globalThis.Number(object.longitude) : 0,
      latitude: isSet(object.latitude) ? globalThis.Number(object.latitude) : 0,
    };
  },

  toJSON(message: Coordinate): unknown {
    const obj: any = {};
    if (message.longitude !== 0) {
      obj.longitude = message.longitude;
    }
    if (message.latitude !== 0) {
      obj.latitude = message.latitude;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Coordinate>, I>>(base?: I): Coordinate {
    return Coordinate.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Coordinate>, I>>(object: I): Coordinate {
    const message = createBaseCoordinate();
    message.longitude = object.longitude ?? 0;
    message.latitude = object.latitude ?? 0;
    return message;
  },
};

function createBaseFilters(): Filters {
  return { temperature: undefined, size: undefined, perimeter: undefined };
}

export const Filters: MessageFns<Filters> = {
  encode(message: Filters, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.temperature !== undefined) {
      MinMax.encode(message.temperature, writer.uint32(10).fork()).join();
    }
    if (message.size !== undefined) {
      MinMax.encode(message.size, writer.uint32(18).fork()).join();
    }
    if (message.perimeter !== undefined) {
      writer.uint32(24).bool(message.perimeter);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Filters {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFilters();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.temperature = MinMax.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.size = MinMax.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.perimeter = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Filters {
    return {
      temperature: isSet(object.temperature) ? MinMax.fromJSON(object.temperature) : undefined,
      size: isSet(object.size) ? MinMax.fromJSON(object.size) : undefined,
      perimeter: isSet(object.perimeter) ? globalThis.Boolean(object.perimeter) : undefined,
    };
  },

  toJSON(message: Filters): unknown {
    const obj: any = {};
    if (message.temperature !== undefined) {
      obj.temperature = MinMax.toJSON(message.temperature);
    }
    if (message.size !== undefined) {
      obj.size = MinMax.toJSON(message.size);
    }
    if (message.perimeter !== undefined) {
      obj.perimeter = message.perimeter;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Filters>, I>>(base?: I): Filters {
    return Filters.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Filters>, I>>(object: I): Filters {
    const message = createBaseFilters();
    message.temperature = (object.temperature !== undefined && object.temperature !== null)
      ? MinMax.fromPartial(object.temperature)
      : undefined;
    message.size = (object.size !== undefined && object.size !== null) ? MinMax.fromPartial(object.size) : undefined;
    message.perimeter = object.perimeter ?? undefined;
    return message;
  },
};

function createBaseGenericLayer(): GenericLayer {
  return {
    id: "",
    createdAt: 0,
    visible: false,
    name: "",
    index: "",
    parentId: undefined,
    createdBy: undefined,
    demoId: undefined,
    locked: undefined,
    archivedTimestamp: undefined,
  };
}

export const GenericLayer: MessageFns<GenericLayer> = {
  encode(message: GenericLayer, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.createdAt !== 0) {
      writer.uint32(16).uint32(message.createdAt);
    }
    if (message.visible !== false) {
      writer.uint32(24).bool(message.visible);
    }
    if (message.name !== "") {
      writer.uint32(34).string(message.name);
    }
    if (message.index !== "") {
      writer.uint32(42).string(message.index);
    }
    if (message.parentId !== undefined) {
      writer.uint32(50).string(message.parentId);
    }
    if (message.createdBy !== undefined) {
      Author.encode(message.createdBy, writer.uint32(58).fork()).join();
    }
    if (message.demoId !== undefined) {
      writer.uint32(66).string(message.demoId);
    }
    if (message.locked !== undefined) {
      writer.uint32(72).bool(message.locked);
    }
    if (message.archivedTimestamp !== undefined) {
      writer.uint32(80).uint32(message.archivedTimestamp);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GenericLayer {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGenericLayer();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.createdAt = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.visible = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.index = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.parentId = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.createdBy = Author.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.demoId = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.locked = reader.bool();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.archivedTimestamp = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GenericLayer {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      createdAt: isSet(object.createdAt) ? globalThis.Number(object.createdAt) : 0,
      visible: isSet(object.visible) ? globalThis.Boolean(object.visible) : false,
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      index: isSet(object.index) ? globalThis.String(object.index) : "",
      parentId: isSet(object.parentId) ? globalThis.String(object.parentId) : undefined,
      createdBy: isSet(object.createdBy) ? Author.fromJSON(object.createdBy) : undefined,
      demoId: isSet(object.demoId) ? globalThis.String(object.demoId) : undefined,
      locked: isSet(object.locked) ? globalThis.Boolean(object.locked) : undefined,
      archivedTimestamp: isSet(object.archivedTimestamp) ? globalThis.Number(object.archivedTimestamp) : undefined,
    };
  },

  toJSON(message: GenericLayer): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.createdAt !== 0) {
      obj.createdAt = Math.round(message.createdAt);
    }
    if (message.visible !== false) {
      obj.visible = message.visible;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.index !== "") {
      obj.index = message.index;
    }
    if (message.parentId !== undefined) {
      obj.parentId = message.parentId;
    }
    if (message.createdBy !== undefined) {
      obj.createdBy = Author.toJSON(message.createdBy);
    }
    if (message.demoId !== undefined) {
      obj.demoId = message.demoId;
    }
    if (message.locked !== undefined) {
      obj.locked = message.locked;
    }
    if (message.archivedTimestamp !== undefined) {
      obj.archivedTimestamp = Math.round(message.archivedTimestamp);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GenericLayer>, I>>(base?: I): GenericLayer {
    return GenericLayer.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GenericLayer>, I>>(object: I): GenericLayer {
    const message = createBaseGenericLayer();
    message.id = object.id ?? "";
    message.createdAt = object.createdAt ?? 0;
    message.visible = object.visible ?? false;
    message.name = object.name ?? "";
    message.index = object.index ?? "";
    message.parentId = object.parentId ?? undefined;
    message.createdBy = (object.createdBy !== undefined && object.createdBy !== null)
      ? Author.fromPartial(object.createdBy)
      : undefined;
    message.demoId = object.demoId ?? undefined;
    message.locked = object.locked ?? undefined;
    message.archivedTimestamp = object.archivedTimestamp ?? undefined;
    return message;
  },
};

function createBaseGroup(): Group {
  return {
    id: "",
    createdAt: 0,
    visible: false,
    name: "",
    index: "",
    parentId: undefined,
    createdBy: undefined,
    groupType: undefined,
    demoId: undefined,
    locked: undefined,
    archivedTimestamp: undefined,
  };
}

export const Group: MessageFns<Group> = {
  encode(message: Group, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.createdAt !== 0) {
      writer.uint32(16).uint32(message.createdAt);
    }
    if (message.visible !== false) {
      writer.uint32(24).bool(message.visible);
    }
    if (message.name !== "") {
      writer.uint32(34).string(message.name);
    }
    if (message.index !== "") {
      writer.uint32(42).string(message.index);
    }
    if (message.parentId !== undefined) {
      writer.uint32(50).string(message.parentId);
    }
    if (message.createdBy !== undefined) {
      Author.encode(message.createdBy, writer.uint32(58).fork()).join();
    }
    if (message.groupType !== undefined) {
      writer.uint32(64).int32(message.groupType);
    }
    if (message.demoId !== undefined) {
      writer.uint32(74).string(message.demoId);
    }
    if (message.locked !== undefined) {
      writer.uint32(80).bool(message.locked);
    }
    if (message.archivedTimestamp !== undefined) {
      writer.uint32(88).uint32(message.archivedTimestamp);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Group {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGroup();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.createdAt = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.visible = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.index = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.parentId = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.createdBy = Author.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.groupType = reader.int32();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.demoId = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.locked = reader.bool();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.archivedTimestamp = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Group {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      createdAt: isSet(object.createdAt) ? globalThis.Number(object.createdAt) : 0,
      visible: isSet(object.visible) ? globalThis.Boolean(object.visible) : false,
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      index: isSet(object.index) ? globalThis.String(object.index) : "",
      parentId: isSet(object.parentId) ? globalThis.String(object.parentId) : undefined,
      createdBy: isSet(object.createdBy) ? Author.fromJSON(object.createdBy) : undefined,
      groupType: isSet(object.groupType) ? globalThis.Number(object.groupType) : undefined,
      demoId: isSet(object.demoId) ? globalThis.String(object.demoId) : undefined,
      locked: isSet(object.locked) ? globalThis.Boolean(object.locked) : undefined,
      archivedTimestamp: isSet(object.archivedTimestamp) ? globalThis.Number(object.archivedTimestamp) : undefined,
    };
  },

  toJSON(message: Group): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.createdAt !== 0) {
      obj.createdAt = Math.round(message.createdAt);
    }
    if (message.visible !== false) {
      obj.visible = message.visible;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.index !== "") {
      obj.index = message.index;
    }
    if (message.parentId !== undefined) {
      obj.parentId = message.parentId;
    }
    if (message.createdBy !== undefined) {
      obj.createdBy = Author.toJSON(message.createdBy);
    }
    if (message.groupType !== undefined) {
      obj.groupType = Math.round(message.groupType);
    }
    if (message.demoId !== undefined) {
      obj.demoId = message.demoId;
    }
    if (message.locked !== undefined) {
      obj.locked = message.locked;
    }
    if (message.archivedTimestamp !== undefined) {
      obj.archivedTimestamp = Math.round(message.archivedTimestamp);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Group>, I>>(base?: I): Group {
    return Group.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Group>, I>>(object: I): Group {
    const message = createBaseGroup();
    message.id = object.id ?? "";
    message.createdAt = object.createdAt ?? 0;
    message.visible = object.visible ?? false;
    message.name = object.name ?? "";
    message.index = object.index ?? "";
    message.parentId = object.parentId ?? undefined;
    message.createdBy = (object.createdBy !== undefined && object.createdBy !== null)
      ? Author.fromPartial(object.createdBy)
      : undefined;
    message.groupType = object.groupType ?? undefined;
    message.demoId = object.demoId ?? undefined;
    message.locked = object.locked ?? undefined;
    message.archivedTimestamp = object.archivedTimestamp ?? undefined;
    return message;
  },
};

function createBaseHotspot(): Hotspot {
  return {
    id: "",
    createdAt: 0,
    imageId: "",
    status: 0,
    longitude: 0,
    latitude: 0,
    polygon: [],
    perimeter: [],
    confidence: 0,
    area: undefined,
    temperature: undefined,
    relativeImageCoordinates: undefined,
  };
}

export const Hotspot: MessageFns<Hotspot> = {
  encode(message: Hotspot, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.createdAt !== 0) {
      writer.uint32(16).uint32(message.createdAt);
    }
    if (message.imageId !== "") {
      writer.uint32(26).string(message.imageId);
    }
    if (message.status !== 0) {
      writer.uint32(32).int32(message.status);
    }
    if (message.longitude !== 0) {
      writer.uint32(41).double(message.longitude);
    }
    if (message.latitude !== 0) {
      writer.uint32(49).double(message.latitude);
    }
    for (const v of message.polygon) {
      Coordinate.encode(v!, writer.uint32(58).fork()).join();
    }
    for (const v of message.perimeter) {
      ImageCoordinate.encode(v!, writer.uint32(66).fork()).join();
    }
    if (message.confidence !== 0) {
      writer.uint32(77).float(message.confidence);
    }
    if (message.area !== undefined) {
      writer.uint32(85).float(message.area);
    }
    if (message.temperature !== undefined) {
      writer.uint32(93).float(message.temperature);
    }
    if (message.relativeImageCoordinates !== undefined) {
      writer.uint32(96).bool(message.relativeImageCoordinates);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Hotspot {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHotspot();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.createdAt = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.imageId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.status = reader.int32();
          continue;
        }
        case 5: {
          if (tag !== 41) {
            break;
          }

          message.longitude = reader.double();
          continue;
        }
        case 6: {
          if (tag !== 49) {
            break;
          }

          message.latitude = reader.double();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.polygon.push(Coordinate.decode(reader, reader.uint32()));
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.perimeter.push(ImageCoordinate.decode(reader, reader.uint32()));
          continue;
        }
        case 9: {
          if (tag !== 77) {
            break;
          }

          message.confidence = reader.float();
          continue;
        }
        case 10: {
          if (tag !== 85) {
            break;
          }

          message.area = reader.float();
          continue;
        }
        case 11: {
          if (tag !== 93) {
            break;
          }

          message.temperature = reader.float();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.relativeImageCoordinates = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Hotspot {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      createdAt: isSet(object.createdAt) ? globalThis.Number(object.createdAt) : 0,
      imageId: isSet(object.imageId) ? globalThis.String(object.imageId) : "",
      status: isSet(object.status) ? globalThis.Number(object.status) : 0,
      longitude: isSet(object.longitude) ? globalThis.Number(object.longitude) : 0,
      latitude: isSet(object.latitude) ? globalThis.Number(object.latitude) : 0,
      polygon: globalThis.Array.isArray(object?.polygon) ? object.polygon.map((e: any) => Coordinate.fromJSON(e)) : [],
      perimeter: globalThis.Array.isArray(object?.perimeter)
        ? object.perimeter.map((e: any) => ImageCoordinate.fromJSON(e))
        : [],
      confidence: isSet(object.confidence) ? globalThis.Number(object.confidence) : 0,
      area: isSet(object.area) ? globalThis.Number(object.area) : undefined,
      temperature: isSet(object.temperature) ? globalThis.Number(object.temperature) : undefined,
      relativeImageCoordinates: isSet(object.relativeImageCoordinates)
        ? globalThis.Boolean(object.relativeImageCoordinates)
        : undefined,
    };
  },

  toJSON(message: Hotspot): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.createdAt !== 0) {
      obj.createdAt = Math.round(message.createdAt);
    }
    if (message.imageId !== "") {
      obj.imageId = message.imageId;
    }
    if (message.status !== 0) {
      obj.status = Math.round(message.status);
    }
    if (message.longitude !== 0) {
      obj.longitude = message.longitude;
    }
    if (message.latitude !== 0) {
      obj.latitude = message.latitude;
    }
    if (message.polygon?.length) {
      obj.polygon = message.polygon.map((e) => Coordinate.toJSON(e));
    }
    if (message.perimeter?.length) {
      obj.perimeter = message.perimeter.map((e) => ImageCoordinate.toJSON(e));
    }
    if (message.confidence !== 0) {
      obj.confidence = message.confidence;
    }
    if (message.area !== undefined) {
      obj.area = message.area;
    }
    if (message.temperature !== undefined) {
      obj.temperature = message.temperature;
    }
    if (message.relativeImageCoordinates !== undefined) {
      obj.relativeImageCoordinates = message.relativeImageCoordinates;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Hotspot>, I>>(base?: I): Hotspot {
    return Hotspot.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Hotspot>, I>>(object: I): Hotspot {
    const message = createBaseHotspot();
    message.id = object.id ?? "";
    message.createdAt = object.createdAt ?? 0;
    message.imageId = object.imageId ?? "";
    message.status = object.status ?? 0;
    message.longitude = object.longitude ?? 0;
    message.latitude = object.latitude ?? 0;
    message.polygon = object.polygon?.map((e) => Coordinate.fromPartial(e)) || [];
    message.perimeter = object.perimeter?.map((e) => ImageCoordinate.fromPartial(e)) || [];
    message.confidence = object.confidence ?? 0;
    message.area = object.area ?? undefined;
    message.temperature = object.temperature ?? undefined;
    message.relativeImageCoordinates = object.relativeImageCoordinates ?? undefined;
    return message;
  },
};

function createBaseHotspotBatch(): HotspotBatch {
  return { entities: [] };
}

export const HotspotBatch: MessageFns<HotspotBatch> = {
  encode(message: HotspotBatch, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.entities) {
      Hotspot.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HotspotBatch {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHotspotBatch();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.entities.push(Hotspot.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): HotspotBatch {
    return {
      entities: globalThis.Array.isArray(object?.entities) ? object.entities.map((e: any) => Hotspot.fromJSON(e)) : [],
    };
  },

  toJSON(message: HotspotBatch): unknown {
    const obj: any = {};
    if (message.entities?.length) {
      obj.entities = message.entities.map((e) => Hotspot.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<HotspotBatch>, I>>(base?: I): HotspotBatch {
    return HotspotBatch.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<HotspotBatch>, I>>(object: I): HotspotBatch {
    const message = createBaseHotspotBatch();
    message.entities = object.entities?.map((e) => Hotspot.fromPartial(e)) || [];
    return message;
  },
};

function createBaseIcon(): Icon {
  return {
    id: "",
    createdAt: 0,
    visible: false,
    name: "",
    index: "",
    parentId: undefined,
    url: "",
    longitude: 0,
    latitude: 0,
    color: undefined,
    size: 0,
    createdBy: undefined,
    demoId: undefined,
    locked: undefined,
    images: [],
    archivedTimestamp: undefined,
    targetPayload: undefined,
    outline: undefined,
    width: undefined,
  };
}

export const Icon: MessageFns<Icon> = {
  encode(message: Icon, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.createdAt !== 0) {
      writer.uint32(16).uint32(message.createdAt);
    }
    if (message.visible !== false) {
      writer.uint32(24).bool(message.visible);
    }
    if (message.name !== "") {
      writer.uint32(34).string(message.name);
    }
    if (message.index !== "") {
      writer.uint32(42).string(message.index);
    }
    if (message.parentId !== undefined) {
      writer.uint32(50).string(message.parentId);
    }
    if (message.url !== "") {
      writer.uint32(58).string(message.url);
    }
    if (message.longitude !== 0) {
      writer.uint32(65).double(message.longitude);
    }
    if (message.latitude !== 0) {
      writer.uint32(73).double(message.latitude);
    }
    if (message.color !== undefined) {
      writer.uint32(80).uint32(message.color);
    }
    if (message.size !== 0) {
      writer.uint32(88).int32(message.size);
    }
    if (message.createdBy !== undefined) {
      Author.encode(message.createdBy, writer.uint32(98).fork()).join();
    }
    if (message.demoId !== undefined) {
      writer.uint32(106).string(message.demoId);
    }
    if (message.locked !== undefined) {
      writer.uint32(112).bool(message.locked);
    }
    for (const v of message.images) {
      IconImage.encode(v!, writer.uint32(122).fork()).join();
    }
    if (message.archivedTimestamp !== undefined) {
      writer.uint32(128).uint32(message.archivedTimestamp);
    }
    if (message.targetPayload !== undefined) {
      writer.uint32(138).string(message.targetPayload);
    }
    if (message.outline !== undefined) {
      writer.uint32(144).uint32(message.outline);
    }
    if (message.width !== undefined) {
      writer.uint32(152).int32(message.width);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Icon {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIcon();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.createdAt = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.visible = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.index = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.parentId = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.url = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 65) {
            break;
          }

          message.longitude = reader.double();
          continue;
        }
        case 9: {
          if (tag !== 73) {
            break;
          }

          message.latitude = reader.double();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.color = reader.uint32();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.size = reader.int32();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.createdBy = Author.decode(reader, reader.uint32());
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.demoId = reader.string();
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.locked = reader.bool();
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.images.push(IconImage.decode(reader, reader.uint32()));
          continue;
        }
        case 16: {
          if (tag !== 128) {
            break;
          }

          message.archivedTimestamp = reader.uint32();
          continue;
        }
        case 17: {
          if (tag !== 138) {
            break;
          }

          message.targetPayload = reader.string();
          continue;
        }
        case 18: {
          if (tag !== 144) {
            break;
          }

          message.outline = reader.uint32();
          continue;
        }
        case 19: {
          if (tag !== 152) {
            break;
          }

          message.width = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Icon {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      createdAt: isSet(object.createdAt) ? globalThis.Number(object.createdAt) : 0,
      visible: isSet(object.visible) ? globalThis.Boolean(object.visible) : false,
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      index: isSet(object.index) ? globalThis.String(object.index) : "",
      parentId: isSet(object.parentId) ? globalThis.String(object.parentId) : undefined,
      url: isSet(object.url) ? globalThis.String(object.url) : "",
      longitude: isSet(object.longitude) ? globalThis.Number(object.longitude) : 0,
      latitude: isSet(object.latitude) ? globalThis.Number(object.latitude) : 0,
      color: isSet(object.color) ? globalThis.Number(object.color) : undefined,
      size: isSet(object.size) ? globalThis.Number(object.size) : 0,
      createdBy: isSet(object.createdBy) ? Author.fromJSON(object.createdBy) : undefined,
      demoId: isSet(object.demoId) ? globalThis.String(object.demoId) : undefined,
      locked: isSet(object.locked) ? globalThis.Boolean(object.locked) : undefined,
      images: globalThis.Array.isArray(object?.images) ? object.images.map((e: any) => IconImage.fromJSON(e)) : [],
      archivedTimestamp: isSet(object.archivedTimestamp) ? globalThis.Number(object.archivedTimestamp) : undefined,
      targetPayload: isSet(object.targetPayload) ? globalThis.String(object.targetPayload) : undefined,
      outline: isSet(object.outline) ? globalThis.Number(object.outline) : undefined,
      width: isSet(object.width) ? globalThis.Number(object.width) : undefined,
    };
  },

  toJSON(message: Icon): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.createdAt !== 0) {
      obj.createdAt = Math.round(message.createdAt);
    }
    if (message.visible !== false) {
      obj.visible = message.visible;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.index !== "") {
      obj.index = message.index;
    }
    if (message.parentId !== undefined) {
      obj.parentId = message.parentId;
    }
    if (message.url !== "") {
      obj.url = message.url;
    }
    if (message.longitude !== 0) {
      obj.longitude = message.longitude;
    }
    if (message.latitude !== 0) {
      obj.latitude = message.latitude;
    }
    if (message.color !== undefined) {
      obj.color = Math.round(message.color);
    }
    if (message.size !== 0) {
      obj.size = Math.round(message.size);
    }
    if (message.createdBy !== undefined) {
      obj.createdBy = Author.toJSON(message.createdBy);
    }
    if (message.demoId !== undefined) {
      obj.demoId = message.demoId;
    }
    if (message.locked !== undefined) {
      obj.locked = message.locked;
    }
    if (message.images?.length) {
      obj.images = message.images.map((e) => IconImage.toJSON(e));
    }
    if (message.archivedTimestamp !== undefined) {
      obj.archivedTimestamp = Math.round(message.archivedTimestamp);
    }
    if (message.targetPayload !== undefined) {
      obj.targetPayload = message.targetPayload;
    }
    if (message.outline !== undefined) {
      obj.outline = Math.round(message.outline);
    }
    if (message.width !== undefined) {
      obj.width = Math.round(message.width);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Icon>, I>>(base?: I): Icon {
    return Icon.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Icon>, I>>(object: I): Icon {
    const message = createBaseIcon();
    message.id = object.id ?? "";
    message.createdAt = object.createdAt ?? 0;
    message.visible = object.visible ?? false;
    message.name = object.name ?? "";
    message.index = object.index ?? "";
    message.parentId = object.parentId ?? undefined;
    message.url = object.url ?? "";
    message.longitude = object.longitude ?? 0;
    message.latitude = object.latitude ?? 0;
    message.color = object.color ?? undefined;
    message.size = object.size ?? 0;
    message.createdBy = (object.createdBy !== undefined && object.createdBy !== null)
      ? Author.fromPartial(object.createdBy)
      : undefined;
    message.demoId = object.demoId ?? undefined;
    message.locked = object.locked ?? undefined;
    message.images = object.images?.map((e) => IconImage.fromPartial(e)) || [];
    message.archivedTimestamp = object.archivedTimestamp ?? undefined;
    message.targetPayload = object.targetPayload ?? undefined;
    message.outline = object.outline ?? undefined;
    message.width = object.width ?? undefined;
    return message;
  },
};

function createBaseIconImage(): IconImage {
  return {
    altitude: undefined,
    focalLength: undefined,
    id: "",
    imageHeight: undefined,
    imageWidth: undefined,
    latitude: undefined,
    longitude: undefined,
    make: undefined,
    size: 0,
    takenAt: undefined,
    index: "",
    fileName: "",
    hasThumbnail: undefined,
  };
}

export const IconImage: MessageFns<IconImage> = {
  encode(message: IconImage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.altitude !== undefined) {
      writer.uint32(13).float(message.altitude);
    }
    if (message.focalLength !== undefined) {
      writer.uint32(21).float(message.focalLength);
    }
    if (message.id !== "") {
      writer.uint32(26).string(message.id);
    }
    if (message.imageHeight !== undefined) {
      writer.uint32(32).uint32(message.imageHeight);
    }
    if (message.imageWidth !== undefined) {
      writer.uint32(40).uint32(message.imageWidth);
    }
    if (message.latitude !== undefined) {
      writer.uint32(49).double(message.latitude);
    }
    if (message.longitude !== undefined) {
      writer.uint32(57).double(message.longitude);
    }
    if (message.make !== undefined) {
      writer.uint32(66).string(message.make);
    }
    if (message.size !== 0) {
      writer.uint32(72).uint32(message.size);
    }
    if (message.takenAt !== undefined) {
      writer.uint32(80).uint32(message.takenAt);
    }
    if (message.index !== "") {
      writer.uint32(90).string(message.index);
    }
    if (message.fileName !== "") {
      writer.uint32(98).string(message.fileName);
    }
    if (message.hasThumbnail !== undefined) {
      writer.uint32(104).bool(message.hasThumbnail);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): IconImage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIconImage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 13) {
            break;
          }

          message.altitude = reader.float();
          continue;
        }
        case 2: {
          if (tag !== 21) {
            break;
          }

          message.focalLength = reader.float();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.imageHeight = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.imageWidth = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 49) {
            break;
          }

          message.latitude = reader.double();
          continue;
        }
        case 7: {
          if (tag !== 57) {
            break;
          }

          message.longitude = reader.double();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.make = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.size = reader.uint32();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.takenAt = reader.uint32();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.index = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.fileName = reader.string();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.hasThumbnail = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): IconImage {
    return {
      altitude: isSet(object.altitude) ? globalThis.Number(object.altitude) : undefined,
      focalLength: isSet(object.focalLength) ? globalThis.Number(object.focalLength) : undefined,
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      imageHeight: isSet(object.imageHeight) ? globalThis.Number(object.imageHeight) : undefined,
      imageWidth: isSet(object.imageWidth) ? globalThis.Number(object.imageWidth) : undefined,
      latitude: isSet(object.latitude) ? globalThis.Number(object.latitude) : undefined,
      longitude: isSet(object.longitude) ? globalThis.Number(object.longitude) : undefined,
      make: isSet(object.make) ? globalThis.String(object.make) : undefined,
      size: isSet(object.size) ? globalThis.Number(object.size) : 0,
      takenAt: isSet(object.takenAt) ? globalThis.Number(object.takenAt) : undefined,
      index: isSet(object.index) ? globalThis.String(object.index) : "",
      fileName: isSet(object.fileName) ? globalThis.String(object.fileName) : "",
      hasThumbnail: isSet(object.hasThumbnail) ? globalThis.Boolean(object.hasThumbnail) : undefined,
    };
  },

  toJSON(message: IconImage): unknown {
    const obj: any = {};
    if (message.altitude !== undefined) {
      obj.altitude = message.altitude;
    }
    if (message.focalLength !== undefined) {
      obj.focalLength = message.focalLength;
    }
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.imageHeight !== undefined) {
      obj.imageHeight = Math.round(message.imageHeight);
    }
    if (message.imageWidth !== undefined) {
      obj.imageWidth = Math.round(message.imageWidth);
    }
    if (message.latitude !== undefined) {
      obj.latitude = message.latitude;
    }
    if (message.longitude !== undefined) {
      obj.longitude = message.longitude;
    }
    if (message.make !== undefined) {
      obj.make = message.make;
    }
    if (message.size !== 0) {
      obj.size = Math.round(message.size);
    }
    if (message.takenAt !== undefined) {
      obj.takenAt = Math.round(message.takenAt);
    }
    if (message.index !== "") {
      obj.index = message.index;
    }
    if (message.fileName !== "") {
      obj.fileName = message.fileName;
    }
    if (message.hasThumbnail !== undefined) {
      obj.hasThumbnail = message.hasThumbnail;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<IconImage>, I>>(base?: I): IconImage {
    return IconImage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<IconImage>, I>>(object: I): IconImage {
    const message = createBaseIconImage();
    message.altitude = object.altitude ?? undefined;
    message.focalLength = object.focalLength ?? undefined;
    message.id = object.id ?? "";
    message.imageHeight = object.imageHeight ?? undefined;
    message.imageWidth = object.imageWidth ?? undefined;
    message.latitude = object.latitude ?? undefined;
    message.longitude = object.longitude ?? undefined;
    message.make = object.make ?? undefined;
    message.size = object.size ?? 0;
    message.takenAt = object.takenAt ?? undefined;
    message.index = object.index ?? "";
    message.fileName = object.fileName ?? "";
    message.hasThumbnail = object.hasThumbnail ?? undefined;
    return message;
  },
};

function createBaseImageColorFinderFlight(): ImageColorFinderFlight {
  return {
    id: "",
    createdAt: 0,
    visible: false,
    name: "",
    index: "",
    parentId: undefined,
    images: [],
    createdBy: undefined,
    demoId: undefined,
    processAfterUpload: undefined,
    locked: undefined,
    archivedTimestamp: undefined,
    cumulativeColorIndex: undefined,
    anomalyPath: undefined,
    colorDataPath: undefined,
  };
}

export const ImageColorFinderFlight: MessageFns<ImageColorFinderFlight> = {
  encode(message: ImageColorFinderFlight, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.createdAt !== 0) {
      writer.uint32(16).uint32(message.createdAt);
    }
    if (message.visible !== false) {
      writer.uint32(24).bool(message.visible);
    }
    if (message.name !== "") {
      writer.uint32(34).string(message.name);
    }
    if (message.index !== "") {
      writer.uint32(42).string(message.index);
    }
    if (message.parentId !== undefined) {
      writer.uint32(50).string(message.parentId);
    }
    for (const v of message.images) {
      ColorFinderImage.encode(v!, writer.uint32(58).fork()).join();
    }
    if (message.createdBy !== undefined) {
      Author.encode(message.createdBy, writer.uint32(66).fork()).join();
    }
    if (message.demoId !== undefined) {
      writer.uint32(74).string(message.demoId);
    }
    if (message.processAfterUpload !== undefined) {
      writer.uint32(80).bool(message.processAfterUpload);
    }
    if (message.locked !== undefined) {
      writer.uint32(88).bool(message.locked);
    }
    if (message.archivedTimestamp !== undefined) {
      writer.uint32(96).uint32(message.archivedTimestamp);
    }
    if (message.cumulativeColorIndex !== undefined) {
      writer.uint32(106).bytes(message.cumulativeColorIndex);
    }
    if (message.anomalyPath !== undefined) {
      writer.uint32(114).string(message.anomalyPath);
    }
    if (message.colorDataPath !== undefined) {
      writer.uint32(122).string(message.colorDataPath);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ImageColorFinderFlight {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseImageColorFinderFlight();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.createdAt = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.visible = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.index = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.parentId = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.images.push(ColorFinderImage.decode(reader, reader.uint32()));
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.createdBy = Author.decode(reader, reader.uint32());
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.demoId = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.processAfterUpload = reader.bool();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.locked = reader.bool();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.archivedTimestamp = reader.uint32();
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.cumulativeColorIndex = reader.bytes();
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.anomalyPath = reader.string();
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.colorDataPath = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ImageColorFinderFlight {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      createdAt: isSet(object.createdAt) ? globalThis.Number(object.createdAt) : 0,
      visible: isSet(object.visible) ? globalThis.Boolean(object.visible) : false,
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      index: isSet(object.index) ? globalThis.String(object.index) : "",
      parentId: isSet(object.parentId) ? globalThis.String(object.parentId) : undefined,
      images: globalThis.Array.isArray(object?.images)
        ? object.images.map((e: any) => ColorFinderImage.fromJSON(e))
        : [],
      createdBy: isSet(object.createdBy) ? Author.fromJSON(object.createdBy) : undefined,
      demoId: isSet(object.demoId) ? globalThis.String(object.demoId) : undefined,
      processAfterUpload: isSet(object.processAfterUpload) ? globalThis.Boolean(object.processAfterUpload) : undefined,
      locked: isSet(object.locked) ? globalThis.Boolean(object.locked) : undefined,
      archivedTimestamp: isSet(object.archivedTimestamp) ? globalThis.Number(object.archivedTimestamp) : undefined,
      cumulativeColorIndex: isSet(object.cumulativeColorIndex)
        ? bytesFromBase64(object.cumulativeColorIndex)
        : undefined,
      anomalyPath: isSet(object.anomalyPath) ? globalThis.String(object.anomalyPath) : undefined,
      colorDataPath: isSet(object.colorDataPath) ? globalThis.String(object.colorDataPath) : undefined,
    };
  },

  toJSON(message: ImageColorFinderFlight): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.createdAt !== 0) {
      obj.createdAt = Math.round(message.createdAt);
    }
    if (message.visible !== false) {
      obj.visible = message.visible;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.index !== "") {
      obj.index = message.index;
    }
    if (message.parentId !== undefined) {
      obj.parentId = message.parentId;
    }
    if (message.images?.length) {
      obj.images = message.images.map((e) => ColorFinderImage.toJSON(e));
    }
    if (message.createdBy !== undefined) {
      obj.createdBy = Author.toJSON(message.createdBy);
    }
    if (message.demoId !== undefined) {
      obj.demoId = message.demoId;
    }
    if (message.processAfterUpload !== undefined) {
      obj.processAfterUpload = message.processAfterUpload;
    }
    if (message.locked !== undefined) {
      obj.locked = message.locked;
    }
    if (message.archivedTimestamp !== undefined) {
      obj.archivedTimestamp = Math.round(message.archivedTimestamp);
    }
    if (message.cumulativeColorIndex !== undefined) {
      obj.cumulativeColorIndex = base64FromBytes(message.cumulativeColorIndex);
    }
    if (message.anomalyPath !== undefined) {
      obj.anomalyPath = message.anomalyPath;
    }
    if (message.colorDataPath !== undefined) {
      obj.colorDataPath = message.colorDataPath;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ImageColorFinderFlight>, I>>(base?: I): ImageColorFinderFlight {
    return ImageColorFinderFlight.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ImageColorFinderFlight>, I>>(object: I): ImageColorFinderFlight {
    const message = createBaseImageColorFinderFlight();
    message.id = object.id ?? "";
    message.createdAt = object.createdAt ?? 0;
    message.visible = object.visible ?? false;
    message.name = object.name ?? "";
    message.index = object.index ?? "";
    message.parentId = object.parentId ?? undefined;
    message.images = object.images?.map((e) => ColorFinderImage.fromPartial(e)) || [];
    message.createdBy = (object.createdBy !== undefined && object.createdBy !== null)
      ? Author.fromPartial(object.createdBy)
      : undefined;
    message.demoId = object.demoId ?? undefined;
    message.processAfterUpload = object.processAfterUpload ?? undefined;
    message.locked = object.locked ?? undefined;
    message.archivedTimestamp = object.archivedTimestamp ?? undefined;
    message.cumulativeColorIndex = object.cumulativeColorIndex ?? undefined;
    message.anomalyPath = object.anomalyPath ?? undefined;
    message.colorDataPath = object.colorDataPath ?? undefined;
    return message;
  },
};

function createBaseImageCoordinate(): ImageCoordinate {
  return { x: 0, y: 0, longitude: 0, latitude: 0 };
}

export const ImageCoordinate: MessageFns<ImageCoordinate> = {
  encode(message: ImageCoordinate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.x !== 0) {
      writer.uint32(8).int32(message.x);
    }
    if (message.y !== 0) {
      writer.uint32(16).int32(message.y);
    }
    if (message.longitude !== 0) {
      writer.uint32(25).double(message.longitude);
    }
    if (message.latitude !== 0) {
      writer.uint32(33).double(message.latitude);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ImageCoordinate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseImageCoordinate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.x = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.y = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.longitude = reader.double();
          continue;
        }
        case 4: {
          if (tag !== 33) {
            break;
          }

          message.latitude = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ImageCoordinate {
    return {
      x: isSet(object.x) ? globalThis.Number(object.x) : 0,
      y: isSet(object.y) ? globalThis.Number(object.y) : 0,
      longitude: isSet(object.longitude) ? globalThis.Number(object.longitude) : 0,
      latitude: isSet(object.latitude) ? globalThis.Number(object.latitude) : 0,
    };
  },

  toJSON(message: ImageCoordinate): unknown {
    const obj: any = {};
    if (message.x !== 0) {
      obj.x = Math.round(message.x);
    }
    if (message.y !== 0) {
      obj.y = Math.round(message.y);
    }
    if (message.longitude !== 0) {
      obj.longitude = message.longitude;
    }
    if (message.latitude !== 0) {
      obj.latitude = message.latitude;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ImageCoordinate>, I>>(base?: I): ImageCoordinate {
    return ImageCoordinate.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ImageCoordinate>, I>>(object: I): ImageCoordinate {
    const message = createBaseImageCoordinate();
    message.x = object.x ?? 0;
    message.y = object.y ?? 0;
    message.longitude = object.longitude ?? 0;
    message.latitude = object.latitude ?? 0;
    return message;
  },
};

function createBaseInfraredCompletePayload(): InfraredCompletePayload {
  return { minZoom: 0, maxZoom: 0, hotspots: [], bbox: [], area: 0, scanArea: [] };
}

export const InfraredCompletePayload: MessageFns<InfraredCompletePayload> = {
  encode(message: InfraredCompletePayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.minZoom !== 0) {
      writer.uint32(8).int32(message.minZoom);
    }
    if (message.maxZoom !== 0) {
      writer.uint32(16).int32(message.maxZoom);
    }
    for (const v of message.hotspots) {
      Hotspot.encode(v!, writer.uint32(26).fork()).join();
    }
    for (const v of message.bbox) {
      Coordinate.encode(v!, writer.uint32(34).fork()).join();
    }
    if (message.area !== 0) {
      writer.uint32(45).float(message.area);
    }
    for (const v of message.scanArea) {
      Coordinate.encode(v!, writer.uint32(50).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): InfraredCompletePayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInfraredCompletePayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.minZoom = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.maxZoom = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.hotspots.push(Hotspot.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.bbox.push(Coordinate.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 45) {
            break;
          }

          message.area = reader.float();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.scanArea.push(Coordinate.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): InfraredCompletePayload {
    return {
      minZoom: isSet(object.minZoom) ? globalThis.Number(object.minZoom) : 0,
      maxZoom: isSet(object.maxZoom) ? globalThis.Number(object.maxZoom) : 0,
      hotspots: globalThis.Array.isArray(object?.hotspots) ? object.hotspots.map((e: any) => Hotspot.fromJSON(e)) : [],
      bbox: globalThis.Array.isArray(object?.bbox) ? object.bbox.map((e: any) => Coordinate.fromJSON(e)) : [],
      area: isSet(object.area) ? globalThis.Number(object.area) : 0,
      scanArea: globalThis.Array.isArray(object?.scanArea)
        ? object.scanArea.map((e: any) => Coordinate.fromJSON(e))
        : [],
    };
  },

  toJSON(message: InfraredCompletePayload): unknown {
    const obj: any = {};
    if (message.minZoom !== 0) {
      obj.minZoom = Math.round(message.minZoom);
    }
    if (message.maxZoom !== 0) {
      obj.maxZoom = Math.round(message.maxZoom);
    }
    if (message.hotspots?.length) {
      obj.hotspots = message.hotspots.map((e) => Hotspot.toJSON(e));
    }
    if (message.bbox?.length) {
      obj.bbox = message.bbox.map((e) => Coordinate.toJSON(e));
    }
    if (message.area !== 0) {
      obj.area = message.area;
    }
    if (message.scanArea?.length) {
      obj.scanArea = message.scanArea.map((e) => Coordinate.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<InfraredCompletePayload>, I>>(base?: I): InfraredCompletePayload {
    return InfraredCompletePayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<InfraredCompletePayload>, I>>(object: I): InfraredCompletePayload {
    const message = createBaseInfraredCompletePayload();
    message.minZoom = object.minZoom ?? 0;
    message.maxZoom = object.maxZoom ?? 0;
    message.hotspots = object.hotspots?.map((e) => Hotspot.fromPartial(e)) || [];
    message.bbox = object.bbox?.map((e) => Coordinate.fromPartial(e)) || [];
    message.area = object.area ?? 0;
    message.scanArea = object.scanArea?.map((e) => Coordinate.fromPartial(e)) || [];
    return message;
  },
};

function createBaseInfraredFlight(): InfraredFlight {
  return {
    id: "",
    createdAt: 0,
    visible: false,
    name: "",
    index: "",
    parentId: undefined,
    skippedProcessing: undefined,
    orthoBoundingBox: [],
    orthoGradient: undefined,
    pointColor: undefined,
    polyStroke: undefined,
    polyFill: undefined,
    pointType: undefined,
    sensitivity: undefined,
    job: undefined,
    images: [],
    hotspots: [],
    perimeterDistance: undefined,
    createdBy: undefined,
    filters: undefined,
    relativeSizeEnabled: undefined,
    integrations: undefined,
    mergeId: undefined,
    demoId: undefined,
    hexIsFlat: undefined,
    processAfterUpload: undefined,
    scanAreaFillColor: undefined,
    scanAreaOutlineColor: undefined,
    locked: undefined,
    archivedTimestamp: undefined,
    cogOrtho: undefined,
  };
}

export const InfraredFlight: MessageFns<InfraredFlight> = {
  encode(message: InfraredFlight, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.createdAt !== 0) {
      writer.uint32(16).uint32(message.createdAt);
    }
    if (message.visible !== false) {
      writer.uint32(24).bool(message.visible);
    }
    if (message.name !== "") {
      writer.uint32(34).string(message.name);
    }
    if (message.index !== "") {
      writer.uint32(42).string(message.index);
    }
    if (message.parentId !== undefined) {
      writer.uint32(50).string(message.parentId);
    }
    if (message.skippedProcessing !== undefined) {
      writer.uint32(56).bool(message.skippedProcessing);
    }
    for (const v of message.orthoBoundingBox) {
      Coordinate.encode(v!, writer.uint32(66).fork()).join();
    }
    if (message.orthoGradient !== undefined) {
      writer.uint32(72).int32(message.orthoGradient);
    }
    if (message.pointColor !== undefined) {
      writer.uint32(80).uint32(message.pointColor);
    }
    if (message.polyStroke !== undefined) {
      writer.uint32(88).uint32(message.polyStroke);
    }
    if (message.polyFill !== undefined) {
      writer.uint32(96).uint32(message.polyFill);
    }
    if (message.pointType !== undefined) {
      writer.uint32(104).int32(message.pointType);
    }
    if (message.sensitivity !== undefined) {
      writer.uint32(117).float(message.sensitivity);
    }
    if (message.job !== undefined) {
      InfraredJob.encode(message.job, writer.uint32(122).fork()).join();
    }
    for (const v of message.images) {
      InfraredImage.encode(v!, writer.uint32(130).fork()).join();
    }
    for (const v of message.hotspots) {
      Hotspot.encode(v!, writer.uint32(138).fork()).join();
    }
    if (message.perimeterDistance !== undefined) {
      PerimeterDistance.encode(message.perimeterDistance, writer.uint32(146).fork()).join();
    }
    if (message.createdBy !== undefined) {
      Author.encode(message.createdBy, writer.uint32(154).fork()).join();
    }
    if (message.filters !== undefined) {
      Filters.encode(message.filters, writer.uint32(162).fork()).join();
    }
    if (message.relativeSizeEnabled !== undefined) {
      writer.uint32(168).bool(message.relativeSizeEnabled);
    }
    if (message.integrations !== undefined) {
      writer.uint32(178).string(message.integrations);
    }
    if (message.mergeId !== undefined) {
      writer.uint32(186).string(message.mergeId);
    }
    if (message.demoId !== undefined) {
      writer.uint32(194).string(message.demoId);
    }
    if (message.hexIsFlat !== undefined) {
      writer.uint32(200).bool(message.hexIsFlat);
    }
    if (message.processAfterUpload !== undefined) {
      writer.uint32(208).bool(message.processAfterUpload);
    }
    if (message.scanAreaFillColor !== undefined) {
      writer.uint32(216).uint32(message.scanAreaFillColor);
    }
    if (message.scanAreaOutlineColor !== undefined) {
      writer.uint32(224).uint32(message.scanAreaOutlineColor);
    }
    if (message.locked !== undefined) {
      writer.uint32(232).bool(message.locked);
    }
    if (message.archivedTimestamp !== undefined) {
      writer.uint32(240).uint32(message.archivedTimestamp);
    }
    if (message.cogOrtho !== undefined) {
      CogOrtho.encode(message.cogOrtho, writer.uint32(250).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): InfraredFlight {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInfraredFlight();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.createdAt = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.visible = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.index = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.parentId = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.skippedProcessing = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.orthoBoundingBox.push(Coordinate.decode(reader, reader.uint32()));
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.orthoGradient = reader.int32();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.pointColor = reader.uint32();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.polyStroke = reader.uint32();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.polyFill = reader.uint32();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.pointType = reader.int32();
          continue;
        }
        case 14: {
          if (tag !== 117) {
            break;
          }

          message.sensitivity = reader.float();
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.job = InfraredJob.decode(reader, reader.uint32());
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.images.push(InfraredImage.decode(reader, reader.uint32()));
          continue;
        }
        case 17: {
          if (tag !== 138) {
            break;
          }

          message.hotspots.push(Hotspot.decode(reader, reader.uint32()));
          continue;
        }
        case 18: {
          if (tag !== 146) {
            break;
          }

          message.perimeterDistance = PerimeterDistance.decode(reader, reader.uint32());
          continue;
        }
        case 19: {
          if (tag !== 154) {
            break;
          }

          message.createdBy = Author.decode(reader, reader.uint32());
          continue;
        }
        case 20: {
          if (tag !== 162) {
            break;
          }

          message.filters = Filters.decode(reader, reader.uint32());
          continue;
        }
        case 21: {
          if (tag !== 168) {
            break;
          }

          message.relativeSizeEnabled = reader.bool();
          continue;
        }
        case 22: {
          if (tag !== 178) {
            break;
          }

          message.integrations = reader.string();
          continue;
        }
        case 23: {
          if (tag !== 186) {
            break;
          }

          message.mergeId = reader.string();
          continue;
        }
        case 24: {
          if (tag !== 194) {
            break;
          }

          message.demoId = reader.string();
          continue;
        }
        case 25: {
          if (tag !== 200) {
            break;
          }

          message.hexIsFlat = reader.bool();
          continue;
        }
        case 26: {
          if (tag !== 208) {
            break;
          }

          message.processAfterUpload = reader.bool();
          continue;
        }
        case 27: {
          if (tag !== 216) {
            break;
          }

          message.scanAreaFillColor = reader.uint32();
          continue;
        }
        case 28: {
          if (tag !== 224) {
            break;
          }

          message.scanAreaOutlineColor = reader.uint32();
          continue;
        }
        case 29: {
          if (tag !== 232) {
            break;
          }

          message.locked = reader.bool();
          continue;
        }
        case 30: {
          if (tag !== 240) {
            break;
          }

          message.archivedTimestamp = reader.uint32();
          continue;
        }
        case 31: {
          if (tag !== 250) {
            break;
          }

          message.cogOrtho = CogOrtho.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): InfraredFlight {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      createdAt: isSet(object.createdAt) ? globalThis.Number(object.createdAt) : 0,
      visible: isSet(object.visible) ? globalThis.Boolean(object.visible) : false,
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      index: isSet(object.index) ? globalThis.String(object.index) : "",
      parentId: isSet(object.parentId) ? globalThis.String(object.parentId) : undefined,
      skippedProcessing: isSet(object.skippedProcessing) ? globalThis.Boolean(object.skippedProcessing) : undefined,
      orthoBoundingBox: globalThis.Array.isArray(object?.orthoBoundingBox)
        ? object.orthoBoundingBox.map((e: any) => Coordinate.fromJSON(e))
        : [],
      orthoGradient: isSet(object.orthoGradient) ? globalThis.Number(object.orthoGradient) : undefined,
      pointColor: isSet(object.pointColor) ? globalThis.Number(object.pointColor) : undefined,
      polyStroke: isSet(object.polyStroke) ? globalThis.Number(object.polyStroke) : undefined,
      polyFill: isSet(object.polyFill) ? globalThis.Number(object.polyFill) : undefined,
      pointType: isSet(object.pointType) ? globalThis.Number(object.pointType) : undefined,
      sensitivity: isSet(object.sensitivity) ? globalThis.Number(object.sensitivity) : undefined,
      job: isSet(object.job) ? InfraredJob.fromJSON(object.job) : undefined,
      images: globalThis.Array.isArray(object?.images) ? object.images.map((e: any) => InfraredImage.fromJSON(e)) : [],
      hotspots: globalThis.Array.isArray(object?.hotspots) ? object.hotspots.map((e: any) => Hotspot.fromJSON(e)) : [],
      perimeterDistance: isSet(object.perimeterDistance)
        ? PerimeterDistance.fromJSON(object.perimeterDistance)
        : undefined,
      createdBy: isSet(object.createdBy) ? Author.fromJSON(object.createdBy) : undefined,
      filters: isSet(object.filters) ? Filters.fromJSON(object.filters) : undefined,
      relativeSizeEnabled: isSet(object.relativeSizeEnabled)
        ? globalThis.Boolean(object.relativeSizeEnabled)
        : undefined,
      integrations: isSet(object.integrations) ? globalThis.String(object.integrations) : undefined,
      mergeId: isSet(object.mergeId) ? globalThis.String(object.mergeId) : undefined,
      demoId: isSet(object.demoId) ? globalThis.String(object.demoId) : undefined,
      hexIsFlat: isSet(object.hexIsFlat) ? globalThis.Boolean(object.hexIsFlat) : undefined,
      processAfterUpload: isSet(object.processAfterUpload) ? globalThis.Boolean(object.processAfterUpload) : undefined,
      scanAreaFillColor: isSet(object.scanAreaFillColor) ? globalThis.Number(object.scanAreaFillColor) : undefined,
      scanAreaOutlineColor: isSet(object.scanAreaOutlineColor)
        ? globalThis.Number(object.scanAreaOutlineColor)
        : undefined,
      locked: isSet(object.locked) ? globalThis.Boolean(object.locked) : undefined,
      archivedTimestamp: isSet(object.archivedTimestamp) ? globalThis.Number(object.archivedTimestamp) : undefined,
      cogOrtho: isSet(object.cogOrtho) ? CogOrtho.fromJSON(object.cogOrtho) : undefined,
    };
  },

  toJSON(message: InfraredFlight): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.createdAt !== 0) {
      obj.createdAt = Math.round(message.createdAt);
    }
    if (message.visible !== false) {
      obj.visible = message.visible;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.index !== "") {
      obj.index = message.index;
    }
    if (message.parentId !== undefined) {
      obj.parentId = message.parentId;
    }
    if (message.skippedProcessing !== undefined) {
      obj.skippedProcessing = message.skippedProcessing;
    }
    if (message.orthoBoundingBox?.length) {
      obj.orthoBoundingBox = message.orthoBoundingBox.map((e) => Coordinate.toJSON(e));
    }
    if (message.orthoGradient !== undefined) {
      obj.orthoGradient = Math.round(message.orthoGradient);
    }
    if (message.pointColor !== undefined) {
      obj.pointColor = Math.round(message.pointColor);
    }
    if (message.polyStroke !== undefined) {
      obj.polyStroke = Math.round(message.polyStroke);
    }
    if (message.polyFill !== undefined) {
      obj.polyFill = Math.round(message.polyFill);
    }
    if (message.pointType !== undefined) {
      obj.pointType = Math.round(message.pointType);
    }
    if (message.sensitivity !== undefined) {
      obj.sensitivity = message.sensitivity;
    }
    if (message.job !== undefined) {
      obj.job = InfraredJob.toJSON(message.job);
    }
    if (message.images?.length) {
      obj.images = message.images.map((e) => InfraredImage.toJSON(e));
    }
    if (message.hotspots?.length) {
      obj.hotspots = message.hotspots.map((e) => Hotspot.toJSON(e));
    }
    if (message.perimeterDistance !== undefined) {
      obj.perimeterDistance = PerimeterDistance.toJSON(message.perimeterDistance);
    }
    if (message.createdBy !== undefined) {
      obj.createdBy = Author.toJSON(message.createdBy);
    }
    if (message.filters !== undefined) {
      obj.filters = Filters.toJSON(message.filters);
    }
    if (message.relativeSizeEnabled !== undefined) {
      obj.relativeSizeEnabled = message.relativeSizeEnabled;
    }
    if (message.integrations !== undefined) {
      obj.integrations = message.integrations;
    }
    if (message.mergeId !== undefined) {
      obj.mergeId = message.mergeId;
    }
    if (message.demoId !== undefined) {
      obj.demoId = message.demoId;
    }
    if (message.hexIsFlat !== undefined) {
      obj.hexIsFlat = message.hexIsFlat;
    }
    if (message.processAfterUpload !== undefined) {
      obj.processAfterUpload = message.processAfterUpload;
    }
    if (message.scanAreaFillColor !== undefined) {
      obj.scanAreaFillColor = Math.round(message.scanAreaFillColor);
    }
    if (message.scanAreaOutlineColor !== undefined) {
      obj.scanAreaOutlineColor = Math.round(message.scanAreaOutlineColor);
    }
    if (message.locked !== undefined) {
      obj.locked = message.locked;
    }
    if (message.archivedTimestamp !== undefined) {
      obj.archivedTimestamp = Math.round(message.archivedTimestamp);
    }
    if (message.cogOrtho !== undefined) {
      obj.cogOrtho = CogOrtho.toJSON(message.cogOrtho);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<InfraredFlight>, I>>(base?: I): InfraredFlight {
    return InfraredFlight.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<InfraredFlight>, I>>(object: I): InfraredFlight {
    const message = createBaseInfraredFlight();
    message.id = object.id ?? "";
    message.createdAt = object.createdAt ?? 0;
    message.visible = object.visible ?? false;
    message.name = object.name ?? "";
    message.index = object.index ?? "";
    message.parentId = object.parentId ?? undefined;
    message.skippedProcessing = object.skippedProcessing ?? undefined;
    message.orthoBoundingBox = object.orthoBoundingBox?.map((e) => Coordinate.fromPartial(e)) || [];
    message.orthoGradient = object.orthoGradient ?? undefined;
    message.pointColor = object.pointColor ?? undefined;
    message.polyStroke = object.polyStroke ?? undefined;
    message.polyFill = object.polyFill ?? undefined;
    message.pointType = object.pointType ?? undefined;
    message.sensitivity = object.sensitivity ?? undefined;
    message.job = (object.job !== undefined && object.job !== null) ? InfraredJob.fromPartial(object.job) : undefined;
    message.images = object.images?.map((e) => InfraredImage.fromPartial(e)) || [];
    message.hotspots = object.hotspots?.map((e) => Hotspot.fromPartial(e)) || [];
    message.perimeterDistance = (object.perimeterDistance !== undefined && object.perimeterDistance !== null)
      ? PerimeterDistance.fromPartial(object.perimeterDistance)
      : undefined;
    message.createdBy = (object.createdBy !== undefined && object.createdBy !== null)
      ? Author.fromPartial(object.createdBy)
      : undefined;
    message.filters = (object.filters !== undefined && object.filters !== null)
      ? Filters.fromPartial(object.filters)
      : undefined;
    message.relativeSizeEnabled = object.relativeSizeEnabled ?? undefined;
    message.integrations = object.integrations ?? undefined;
    message.mergeId = object.mergeId ?? undefined;
    message.demoId = object.demoId ?? undefined;
    message.hexIsFlat = object.hexIsFlat ?? undefined;
    message.processAfterUpload = object.processAfterUpload ?? undefined;
    message.scanAreaFillColor = object.scanAreaFillColor ?? undefined;
    message.scanAreaOutlineColor = object.scanAreaOutlineColor ?? undefined;
    message.locked = object.locked ?? undefined;
    message.archivedTimestamp = object.archivedTimestamp ?? undefined;
    message.cogOrtho = (object.cogOrtho !== undefined && object.cogOrtho !== null)
      ? CogOrtho.fromPartial(object.cogOrtho)
      : undefined;
    return message;
  },
};

function createBaseInfraredImage(): InfraredImage {
  return {
    id: "",
    longitude: 0,
    latitude: 0,
    altitude: undefined,
    height: undefined,
    pitch: undefined,
    yaw: undefined,
    roll: undefined,
    takenAt: undefined,
    make: undefined,
    focalLength: undefined,
    size: undefined,
    imageHeight: undefined,
    imageWidth: undefined,
    imageType: undefined,
    fov: [],
    model: undefined,
    hasLowQuality: undefined,
    hasLRF: undefined,
  };
}

export const InfraredImage: MessageFns<InfraredImage> = {
  encode(message: InfraredImage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.longitude !== 0) {
      writer.uint32(17).double(message.longitude);
    }
    if (message.latitude !== 0) {
      writer.uint32(25).double(message.latitude);
    }
    if (message.altitude !== undefined) {
      writer.uint32(37).float(message.altitude);
    }
    if (message.height !== undefined) {
      writer.uint32(45).float(message.height);
    }
    if (message.pitch !== undefined) {
      writer.uint32(53).float(message.pitch);
    }
    if (message.yaw !== undefined) {
      writer.uint32(61).float(message.yaw);
    }
    if (message.roll !== undefined) {
      writer.uint32(69).float(message.roll);
    }
    if (message.takenAt !== undefined) {
      writer.uint32(72).uint32(message.takenAt);
    }
    if (message.make !== undefined) {
      writer.uint32(82).string(message.make);
    }
    if (message.focalLength !== undefined) {
      writer.uint32(93).float(message.focalLength);
    }
    if (message.size !== undefined) {
      writer.uint32(96).uint32(message.size);
    }
    if (message.imageHeight !== undefined) {
      writer.uint32(104).uint32(message.imageHeight);
    }
    if (message.imageWidth !== undefined) {
      writer.uint32(112).uint32(message.imageWidth);
    }
    if (message.imageType !== undefined) {
      writer.uint32(120).int32(message.imageType);
    }
    writer.uint32(130).fork();
    for (const v of message.fov) {
      writer.float(v);
    }
    writer.join();
    if (message.model !== undefined) {
      writer.uint32(138).string(message.model);
    }
    if (message.hasLowQuality !== undefined) {
      writer.uint32(144).bool(message.hasLowQuality);
    }
    if (message.hasLRF !== undefined) {
      writer.uint32(152).bool(message.hasLRF);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): InfraredImage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInfraredImage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.longitude = reader.double();
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.latitude = reader.double();
          continue;
        }
        case 4: {
          if (tag !== 37) {
            break;
          }

          message.altitude = reader.float();
          continue;
        }
        case 5: {
          if (tag !== 45) {
            break;
          }

          message.height = reader.float();
          continue;
        }
        case 6: {
          if (tag !== 53) {
            break;
          }

          message.pitch = reader.float();
          continue;
        }
        case 7: {
          if (tag !== 61) {
            break;
          }

          message.yaw = reader.float();
          continue;
        }
        case 8: {
          if (tag !== 69) {
            break;
          }

          message.roll = reader.float();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.takenAt = reader.uint32();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.make = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 93) {
            break;
          }

          message.focalLength = reader.float();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.size = reader.uint32();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.imageHeight = reader.uint32();
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.imageWidth = reader.uint32();
          continue;
        }
        case 15: {
          if (tag !== 120) {
            break;
          }

          message.imageType = reader.int32();
          continue;
        }
        case 16: {
          if (tag === 133) {
            message.fov.push(reader.float());

            continue;
          }

          if (tag === 130) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.fov.push(reader.float());
            }

            continue;
          }

          break;
        }
        case 17: {
          if (tag !== 138) {
            break;
          }

          message.model = reader.string();
          continue;
        }
        case 18: {
          if (tag !== 144) {
            break;
          }

          message.hasLowQuality = reader.bool();
          continue;
        }
        case 19: {
          if (tag !== 152) {
            break;
          }

          message.hasLRF = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): InfraredImage {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      longitude: isSet(object.longitude) ? globalThis.Number(object.longitude) : 0,
      latitude: isSet(object.latitude) ? globalThis.Number(object.latitude) : 0,
      altitude: isSet(object.altitude) ? globalThis.Number(object.altitude) : undefined,
      height: isSet(object.height) ? globalThis.Number(object.height) : undefined,
      pitch: isSet(object.pitch) ? globalThis.Number(object.pitch) : undefined,
      yaw: isSet(object.yaw) ? globalThis.Number(object.yaw) : undefined,
      roll: isSet(object.roll) ? globalThis.Number(object.roll) : undefined,
      takenAt: isSet(object.takenAt) ? globalThis.Number(object.takenAt) : undefined,
      make: isSet(object.make) ? globalThis.String(object.make) : undefined,
      focalLength: isSet(object.focalLength) ? globalThis.Number(object.focalLength) : undefined,
      size: isSet(object.size) ? globalThis.Number(object.size) : undefined,
      imageHeight: isSet(object.imageHeight) ? globalThis.Number(object.imageHeight) : undefined,
      imageWidth: isSet(object.imageWidth) ? globalThis.Number(object.imageWidth) : undefined,
      imageType: isSet(object.imageType) ? globalThis.Number(object.imageType) : undefined,
      fov: globalThis.Array.isArray(object?.fov) ? object.fov.map((e: any) => globalThis.Number(e)) : [],
      model: isSet(object.model) ? globalThis.String(object.model) : undefined,
      hasLowQuality: isSet(object.hasLowQuality) ? globalThis.Boolean(object.hasLowQuality) : undefined,
      hasLRF: isSet(object.hasLRF) ? globalThis.Boolean(object.hasLRF) : undefined,
    };
  },

  toJSON(message: InfraredImage): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.longitude !== 0) {
      obj.longitude = message.longitude;
    }
    if (message.latitude !== 0) {
      obj.latitude = message.latitude;
    }
    if (message.altitude !== undefined) {
      obj.altitude = message.altitude;
    }
    if (message.height !== undefined) {
      obj.height = message.height;
    }
    if (message.pitch !== undefined) {
      obj.pitch = message.pitch;
    }
    if (message.yaw !== undefined) {
      obj.yaw = message.yaw;
    }
    if (message.roll !== undefined) {
      obj.roll = message.roll;
    }
    if (message.takenAt !== undefined) {
      obj.takenAt = Math.round(message.takenAt);
    }
    if (message.make !== undefined) {
      obj.make = message.make;
    }
    if (message.focalLength !== undefined) {
      obj.focalLength = message.focalLength;
    }
    if (message.size !== undefined) {
      obj.size = Math.round(message.size);
    }
    if (message.imageHeight !== undefined) {
      obj.imageHeight = Math.round(message.imageHeight);
    }
    if (message.imageWidth !== undefined) {
      obj.imageWidth = Math.round(message.imageWidth);
    }
    if (message.imageType !== undefined) {
      obj.imageType = Math.round(message.imageType);
    }
    if (message.fov?.length) {
      obj.fov = message.fov;
    }
    if (message.model !== undefined) {
      obj.model = message.model;
    }
    if (message.hasLowQuality !== undefined) {
      obj.hasLowQuality = message.hasLowQuality;
    }
    if (message.hasLRF !== undefined) {
      obj.hasLRF = message.hasLRF;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<InfraredImage>, I>>(base?: I): InfraredImage {
    return InfraredImage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<InfraredImage>, I>>(object: I): InfraredImage {
    const message = createBaseInfraredImage();
    message.id = object.id ?? "";
    message.longitude = object.longitude ?? 0;
    message.latitude = object.latitude ?? 0;
    message.altitude = object.altitude ?? undefined;
    message.height = object.height ?? undefined;
    message.pitch = object.pitch ?? undefined;
    message.yaw = object.yaw ?? undefined;
    message.roll = object.roll ?? undefined;
    message.takenAt = object.takenAt ?? undefined;
    message.make = object.make ?? undefined;
    message.focalLength = object.focalLength ?? undefined;
    message.size = object.size ?? undefined;
    message.imageHeight = object.imageHeight ?? undefined;
    message.imageWidth = object.imageWidth ?? undefined;
    message.imageType = object.imageType ?? undefined;
    message.fov = object.fov?.map((e) => e) || [];
    message.model = object.model ?? undefined;
    message.hasLowQuality = object.hasLowQuality ?? undefined;
    message.hasLRF = object.hasLRF ?? undefined;
    return message;
  },
};

function createBaseInfraredImageBatch(): InfraredImageBatch {
  return { entities: [] };
}

export const InfraredImageBatch: MessageFns<InfraredImageBatch> = {
  encode(message: InfraredImageBatch, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.entities) {
      InfraredImage.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): InfraredImageBatch {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInfraredImageBatch();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.entities.push(InfraredImage.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): InfraredImageBatch {
    return {
      entities: globalThis.Array.isArray(object?.entities)
        ? object.entities.map((e: any) => InfraredImage.fromJSON(e))
        : [],
    };
  },

  toJSON(message: InfraredImageBatch): unknown {
    const obj: any = {};
    if (message.entities?.length) {
      obj.entities = message.entities.map((e) => InfraredImage.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<InfraredImageBatch>, I>>(base?: I): InfraredImageBatch {
    return InfraredImageBatch.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<InfraredImageBatch>, I>>(object: I): InfraredImageBatch {
    const message = createBaseInfraredImageBatch();
    message.entities = object.entities?.map((e) => InfraredImage.fromPartial(e)) || [];
    return message;
  },
};

function createBaseInfraredJob(): InfraredJob {
  return {
    createdAt: 0,
    deletedAt: undefined,
    status: 0,
    maxZoom: undefined,
    extraFeatures: undefined,
    progress: undefined,
    updatedAt: undefined,
    area: undefined,
    minZoom: undefined,
    error: undefined,
    scanArea: [],
    processingMode: undefined,
  };
}

export const InfraredJob: MessageFns<InfraredJob> = {
  encode(message: InfraredJob, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.createdAt !== 0) {
      writer.uint32(8).uint32(message.createdAt);
    }
    if (message.deletedAt !== undefined) {
      writer.uint32(16).uint32(message.deletedAt);
    }
    if (message.status !== 0) {
      writer.uint32(24).int32(message.status);
    }
    if (message.maxZoom !== undefined) {
      writer.uint32(32).int32(message.maxZoom);
    }
    if (message.extraFeatures !== undefined) {
      writer.uint32(42).string(message.extraFeatures);
    }
    if (message.progress !== undefined) {
      writer.uint32(48).int32(message.progress);
    }
    if (message.updatedAt !== undefined) {
      writer.uint32(56).uint32(message.updatedAt);
    }
    if (message.area !== undefined) {
      writer.uint32(69).float(message.area);
    }
    if (message.minZoom !== undefined) {
      writer.uint32(72).int32(message.minZoom);
    }
    if (message.error !== undefined) {
      writer.uint32(80).int32(message.error);
    }
    for (const v of message.scanArea) {
      Coordinate.encode(v!, writer.uint32(90).fork()).join();
    }
    if (message.processingMode !== undefined) {
      writer.uint32(96).int32(message.processingMode);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): InfraredJob {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInfraredJob();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.createdAt = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.deletedAt = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.status = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.maxZoom = reader.int32();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.extraFeatures = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.progress = reader.int32();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.updatedAt = reader.uint32();
          continue;
        }
        case 8: {
          if (tag !== 69) {
            break;
          }

          message.area = reader.float();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.minZoom = reader.int32();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.error = reader.int32();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.scanArea.push(Coordinate.decode(reader, reader.uint32()));
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.processingMode = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): InfraredJob {
    return {
      createdAt: isSet(object.createdAt) ? globalThis.Number(object.createdAt) : 0,
      deletedAt: isSet(object.deletedAt) ? globalThis.Number(object.deletedAt) : undefined,
      status: isSet(object.status) ? globalThis.Number(object.status) : 0,
      maxZoom: isSet(object.maxZoom) ? globalThis.Number(object.maxZoom) : undefined,
      extraFeatures: isSet(object.extraFeatures) ? globalThis.String(object.extraFeatures) : undefined,
      progress: isSet(object.progress) ? globalThis.Number(object.progress) : undefined,
      updatedAt: isSet(object.updatedAt) ? globalThis.Number(object.updatedAt) : undefined,
      area: isSet(object.area) ? globalThis.Number(object.area) : undefined,
      minZoom: isSet(object.minZoom) ? globalThis.Number(object.minZoom) : undefined,
      error: isSet(object.error) ? globalThis.Number(object.error) : undefined,
      scanArea: globalThis.Array.isArray(object?.scanArea)
        ? object.scanArea.map((e: any) => Coordinate.fromJSON(e))
        : [],
      processingMode: isSet(object.processingMode) ? globalThis.Number(object.processingMode) : undefined,
    };
  },

  toJSON(message: InfraredJob): unknown {
    const obj: any = {};
    if (message.createdAt !== 0) {
      obj.createdAt = Math.round(message.createdAt);
    }
    if (message.deletedAt !== undefined) {
      obj.deletedAt = Math.round(message.deletedAt);
    }
    if (message.status !== 0) {
      obj.status = Math.round(message.status);
    }
    if (message.maxZoom !== undefined) {
      obj.maxZoom = Math.round(message.maxZoom);
    }
    if (message.extraFeatures !== undefined) {
      obj.extraFeatures = message.extraFeatures;
    }
    if (message.progress !== undefined) {
      obj.progress = Math.round(message.progress);
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = Math.round(message.updatedAt);
    }
    if (message.area !== undefined) {
      obj.area = message.area;
    }
    if (message.minZoom !== undefined) {
      obj.minZoom = Math.round(message.minZoom);
    }
    if (message.error !== undefined) {
      obj.error = Math.round(message.error);
    }
    if (message.scanArea?.length) {
      obj.scanArea = message.scanArea.map((e) => Coordinate.toJSON(e));
    }
    if (message.processingMode !== undefined) {
      obj.processingMode = Math.round(message.processingMode);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<InfraredJob>, I>>(base?: I): InfraredJob {
    return InfraredJob.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<InfraredJob>, I>>(object: I): InfraredJob {
    const message = createBaseInfraredJob();
    message.createdAt = object.createdAt ?? 0;
    message.deletedAt = object.deletedAt ?? undefined;
    message.status = object.status ?? 0;
    message.maxZoom = object.maxZoom ?? undefined;
    message.extraFeatures = object.extraFeatures ?? undefined;
    message.progress = object.progress ?? undefined;
    message.updatedAt = object.updatedAt ?? undefined;
    message.area = object.area ?? undefined;
    message.minZoom = object.minZoom ?? undefined;
    message.error = object.error ?? undefined;
    message.scanArea = object.scanArea?.map((e) => Coordinate.fromPartial(e)) || [];
    message.processingMode = object.processingMode ?? undefined;
    return message;
  },
};

function createBaseLayer(): Layer {
  return {
    id: "",
    createdAt: 0,
    visible: false,
    name: "",
    index: "",
    parentId: undefined,
    demoId: undefined,
    locked: undefined,
    archivedTimestamp: undefined,
  };
}

export const Layer: MessageFns<Layer> = {
  encode(message: Layer, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.createdAt !== 0) {
      writer.uint32(16).uint32(message.createdAt);
    }
    if (message.visible !== false) {
      writer.uint32(24).bool(message.visible);
    }
    if (message.name !== "") {
      writer.uint32(34).string(message.name);
    }
    if (message.index !== "") {
      writer.uint32(42).string(message.index);
    }
    if (message.parentId !== undefined) {
      writer.uint32(50).string(message.parentId);
    }
    if (message.demoId !== undefined) {
      writer.uint32(58).string(message.demoId);
    }
    if (message.locked !== undefined) {
      writer.uint32(64).bool(message.locked);
    }
    if (message.archivedTimestamp !== undefined) {
      writer.uint32(72).uint32(message.archivedTimestamp);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Layer {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLayer();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.createdAt = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.visible = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.index = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.parentId = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.demoId = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.locked = reader.bool();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.archivedTimestamp = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Layer {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      createdAt: isSet(object.createdAt) ? globalThis.Number(object.createdAt) : 0,
      visible: isSet(object.visible) ? globalThis.Boolean(object.visible) : false,
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      index: isSet(object.index) ? globalThis.String(object.index) : "",
      parentId: isSet(object.parentId) ? globalThis.String(object.parentId) : undefined,
      demoId: isSet(object.demoId) ? globalThis.String(object.demoId) : undefined,
      locked: isSet(object.locked) ? globalThis.Boolean(object.locked) : undefined,
      archivedTimestamp: isSet(object.archivedTimestamp) ? globalThis.Number(object.archivedTimestamp) : undefined,
    };
  },

  toJSON(message: Layer): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.createdAt !== 0) {
      obj.createdAt = Math.round(message.createdAt);
    }
    if (message.visible !== false) {
      obj.visible = message.visible;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.index !== "") {
      obj.index = message.index;
    }
    if (message.parentId !== undefined) {
      obj.parentId = message.parentId;
    }
    if (message.demoId !== undefined) {
      obj.demoId = message.demoId;
    }
    if (message.locked !== undefined) {
      obj.locked = message.locked;
    }
    if (message.archivedTimestamp !== undefined) {
      obj.archivedTimestamp = Math.round(message.archivedTimestamp);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Layer>, I>>(base?: I): Layer {
    return Layer.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Layer>, I>>(object: I): Layer {
    const message = createBaseLayer();
    message.id = object.id ?? "";
    message.createdAt = object.createdAt ?? 0;
    message.visible = object.visible ?? false;
    message.name = object.name ?? "";
    message.index = object.index ?? "";
    message.parentId = object.parentId ?? undefined;
    message.demoId = object.demoId ?? undefined;
    message.locked = object.locked ?? undefined;
    message.archivedTimestamp = object.archivedTimestamp ?? undefined;
    return message;
  },
};

function createBaseLine(): Line {
  return {
    id: "",
    createdAt: 0,
    visible: false,
    name: "",
    index: "",
    parentId: undefined,
    coordinates: [],
    geometryType: 0,
    width: undefined,
    color: undefined,
    outline: undefined,
    fill: undefined,
    stroke: undefined,
    url: undefined,
    polygonPattern: undefined,
    holes: [],
    createdBy: undefined,
    demoId: undefined,
    locked: undefined,
    archivedTimestamp: undefined,
  };
}

export const Line: MessageFns<Line> = {
  encode(message: Line, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.createdAt !== 0) {
      writer.uint32(16).uint32(message.createdAt);
    }
    if (message.visible !== false) {
      writer.uint32(24).bool(message.visible);
    }
    if (message.name !== "") {
      writer.uint32(34).string(message.name);
    }
    if (message.index !== "") {
      writer.uint32(42).string(message.index);
    }
    if (message.parentId !== undefined) {
      writer.uint32(50).string(message.parentId);
    }
    for (const v of message.coordinates) {
      Coordinate.encode(v!, writer.uint32(58).fork()).join();
    }
    if (message.geometryType !== 0) {
      writer.uint32(64).int32(message.geometryType);
    }
    if (message.width !== undefined) {
      writer.uint32(72).int32(message.width);
    }
    if (message.color !== undefined) {
      writer.uint32(80).uint32(message.color);
    }
    if (message.outline !== undefined) {
      writer.uint32(88).uint32(message.outline);
    }
    if (message.fill !== undefined) {
      writer.uint32(96).uint32(message.fill);
    }
    if (message.stroke !== undefined) {
      writer.uint32(104).int32(message.stroke);
    }
    if (message.url !== undefined) {
      writer.uint32(114).string(message.url);
    }
    if (message.polygonPattern !== undefined) {
      writer.uint32(122).string(message.polygonPattern);
    }
    for (const v of message.holes) {
      Polygon.encode(v!, writer.uint32(130).fork()).join();
    }
    if (message.createdBy !== undefined) {
      Author.encode(message.createdBy, writer.uint32(138).fork()).join();
    }
    if (message.demoId !== undefined) {
      writer.uint32(146).string(message.demoId);
    }
    if (message.locked !== undefined) {
      writer.uint32(152).bool(message.locked);
    }
    if (message.archivedTimestamp !== undefined) {
      writer.uint32(160).uint32(message.archivedTimestamp);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Line {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLine();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.createdAt = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.visible = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.index = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.parentId = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.coordinates.push(Coordinate.decode(reader, reader.uint32()));
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.geometryType = reader.int32();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.width = reader.int32();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.color = reader.uint32();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.outline = reader.uint32();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.fill = reader.uint32();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.stroke = reader.int32();
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.url = reader.string();
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.polygonPattern = reader.string();
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.holes.push(Polygon.decode(reader, reader.uint32()));
          continue;
        }
        case 17: {
          if (tag !== 138) {
            break;
          }

          message.createdBy = Author.decode(reader, reader.uint32());
          continue;
        }
        case 18: {
          if (tag !== 146) {
            break;
          }

          message.demoId = reader.string();
          continue;
        }
        case 19: {
          if (tag !== 152) {
            break;
          }

          message.locked = reader.bool();
          continue;
        }
        case 20: {
          if (tag !== 160) {
            break;
          }

          message.archivedTimestamp = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Line {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      createdAt: isSet(object.createdAt) ? globalThis.Number(object.createdAt) : 0,
      visible: isSet(object.visible) ? globalThis.Boolean(object.visible) : false,
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      index: isSet(object.index) ? globalThis.String(object.index) : "",
      parentId: isSet(object.parentId) ? globalThis.String(object.parentId) : undefined,
      coordinates: globalThis.Array.isArray(object?.coordinates)
        ? object.coordinates.map((e: any) => Coordinate.fromJSON(e))
        : [],
      geometryType: isSet(object.geometryType) ? globalThis.Number(object.geometryType) : 0,
      width: isSet(object.width) ? globalThis.Number(object.width) : undefined,
      color: isSet(object.color) ? globalThis.Number(object.color) : undefined,
      outline: isSet(object.outline) ? globalThis.Number(object.outline) : undefined,
      fill: isSet(object.fill) ? globalThis.Number(object.fill) : undefined,
      stroke: isSet(object.stroke) ? globalThis.Number(object.stroke) : undefined,
      url: isSet(object.url) ? globalThis.String(object.url) : undefined,
      polygonPattern: isSet(object.polygonPattern) ? globalThis.String(object.polygonPattern) : undefined,
      holes: globalThis.Array.isArray(object?.holes) ? object.holes.map((e: any) => Polygon.fromJSON(e)) : [],
      createdBy: isSet(object.createdBy) ? Author.fromJSON(object.createdBy) : undefined,
      demoId: isSet(object.demoId) ? globalThis.String(object.demoId) : undefined,
      locked: isSet(object.locked) ? globalThis.Boolean(object.locked) : undefined,
      archivedTimestamp: isSet(object.archivedTimestamp) ? globalThis.Number(object.archivedTimestamp) : undefined,
    };
  },

  toJSON(message: Line): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.createdAt !== 0) {
      obj.createdAt = Math.round(message.createdAt);
    }
    if (message.visible !== false) {
      obj.visible = message.visible;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.index !== "") {
      obj.index = message.index;
    }
    if (message.parentId !== undefined) {
      obj.parentId = message.parentId;
    }
    if (message.coordinates?.length) {
      obj.coordinates = message.coordinates.map((e) => Coordinate.toJSON(e));
    }
    if (message.geometryType !== 0) {
      obj.geometryType = Math.round(message.geometryType);
    }
    if (message.width !== undefined) {
      obj.width = Math.round(message.width);
    }
    if (message.color !== undefined) {
      obj.color = Math.round(message.color);
    }
    if (message.outline !== undefined) {
      obj.outline = Math.round(message.outline);
    }
    if (message.fill !== undefined) {
      obj.fill = Math.round(message.fill);
    }
    if (message.stroke !== undefined) {
      obj.stroke = Math.round(message.stroke);
    }
    if (message.url !== undefined) {
      obj.url = message.url;
    }
    if (message.polygonPattern !== undefined) {
      obj.polygonPattern = message.polygonPattern;
    }
    if (message.holes?.length) {
      obj.holes = message.holes.map((e) => Polygon.toJSON(e));
    }
    if (message.createdBy !== undefined) {
      obj.createdBy = Author.toJSON(message.createdBy);
    }
    if (message.demoId !== undefined) {
      obj.demoId = message.demoId;
    }
    if (message.locked !== undefined) {
      obj.locked = message.locked;
    }
    if (message.archivedTimestamp !== undefined) {
      obj.archivedTimestamp = Math.round(message.archivedTimestamp);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Line>, I>>(base?: I): Line {
    return Line.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Line>, I>>(object: I): Line {
    const message = createBaseLine();
    message.id = object.id ?? "";
    message.createdAt = object.createdAt ?? 0;
    message.visible = object.visible ?? false;
    message.name = object.name ?? "";
    message.index = object.index ?? "";
    message.parentId = object.parentId ?? undefined;
    message.coordinates = object.coordinates?.map((e) => Coordinate.fromPartial(e)) || [];
    message.geometryType = object.geometryType ?? 0;
    message.width = object.width ?? undefined;
    message.color = object.color ?? undefined;
    message.outline = object.outline ?? undefined;
    message.fill = object.fill ?? undefined;
    message.stroke = object.stroke ?? undefined;
    message.url = object.url ?? undefined;
    message.polygonPattern = object.polygonPattern ?? undefined;
    message.holes = object.holes?.map((e) => Polygon.fromPartial(e)) || [];
    message.createdBy = (object.createdBy !== undefined && object.createdBy !== null)
      ? Author.fromPartial(object.createdBy)
      : undefined;
    message.demoId = object.demoId ?? undefined;
    message.locked = object.locked ?? undefined;
    message.archivedTimestamp = object.archivedTimestamp ?? undefined;
    return message;
  },
};

function createBaseLiveVideoFlight(): LiveVideoFlight {
  return {
    id: "",
    createdAt: 0,
    visible: false,
    name: "",
    index: "",
    parentId: undefined,
    createdBy: undefined,
    live: false,
    recordingPrefix: undefined,
    startedAt: undefined,
    endedAt: undefined,
    activated: undefined,
    activatedAt: undefined,
    code: 0,
    recordingReady: undefined,
    saveRecording: false,
    streamCreated: undefined,
    demoId: undefined,
    locked: undefined,
    archivedTimestamp: undefined,
    isMobile: undefined,
    mp4Created: undefined,
    pilotInitialCoordinate: undefined,
    isMMA: undefined,
    isAtlas: undefined,
  };
}

export const LiveVideoFlight: MessageFns<LiveVideoFlight> = {
  encode(message: LiveVideoFlight, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.createdAt !== 0) {
      writer.uint32(16).uint32(message.createdAt);
    }
    if (message.visible !== false) {
      writer.uint32(24).bool(message.visible);
    }
    if (message.name !== "") {
      writer.uint32(34).string(message.name);
    }
    if (message.index !== "") {
      writer.uint32(42).string(message.index);
    }
    if (message.parentId !== undefined) {
      writer.uint32(50).string(message.parentId);
    }
    if (message.createdBy !== undefined) {
      Author.encode(message.createdBy, writer.uint32(58).fork()).join();
    }
    if (message.live !== false) {
      writer.uint32(64).bool(message.live);
    }
    if (message.recordingPrefix !== undefined) {
      writer.uint32(74).string(message.recordingPrefix);
    }
    if (message.startedAt !== undefined) {
      writer.uint32(80).uint32(message.startedAt);
    }
    if (message.endedAt !== undefined) {
      writer.uint32(88).uint32(message.endedAt);
    }
    if (message.activated !== undefined) {
      writer.uint32(96).bool(message.activated);
    }
    if (message.activatedAt !== undefined) {
      writer.uint32(104).uint32(message.activatedAt);
    }
    if (message.code !== 0) {
      writer.uint32(112).int32(message.code);
    }
    if (message.recordingReady !== undefined) {
      writer.uint32(120).bool(message.recordingReady);
    }
    if (message.saveRecording !== false) {
      writer.uint32(128).bool(message.saveRecording);
    }
    if (message.streamCreated !== undefined) {
      writer.uint32(136).bool(message.streamCreated);
    }
    if (message.demoId !== undefined) {
      writer.uint32(146).string(message.demoId);
    }
    if (message.locked !== undefined) {
      writer.uint32(152).bool(message.locked);
    }
    if (message.archivedTimestamp !== undefined) {
      writer.uint32(160).uint32(message.archivedTimestamp);
    }
    if (message.isMobile !== undefined) {
      writer.uint32(168).bool(message.isMobile);
    }
    if (message.mp4Created !== undefined) {
      writer.uint32(176).bool(message.mp4Created);
    }
    if (message.pilotInitialCoordinate !== undefined) {
      Coordinate.encode(message.pilotInitialCoordinate, writer.uint32(186).fork()).join();
    }
    if (message.isMMA !== undefined) {
      writer.uint32(192).bool(message.isMMA);
    }
    if (message.isAtlas !== undefined) {
      writer.uint32(200).bool(message.isAtlas);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LiveVideoFlight {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLiveVideoFlight();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.createdAt = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.visible = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.index = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.parentId = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.createdBy = Author.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.live = reader.bool();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.recordingPrefix = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.startedAt = reader.uint32();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.endedAt = reader.uint32();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.activated = reader.bool();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.activatedAt = reader.uint32();
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.code = reader.int32();
          continue;
        }
        case 15: {
          if (tag !== 120) {
            break;
          }

          message.recordingReady = reader.bool();
          continue;
        }
        case 16: {
          if (tag !== 128) {
            break;
          }

          message.saveRecording = reader.bool();
          continue;
        }
        case 17: {
          if (tag !== 136) {
            break;
          }

          message.streamCreated = reader.bool();
          continue;
        }
        case 18: {
          if (tag !== 146) {
            break;
          }

          message.demoId = reader.string();
          continue;
        }
        case 19: {
          if (tag !== 152) {
            break;
          }

          message.locked = reader.bool();
          continue;
        }
        case 20: {
          if (tag !== 160) {
            break;
          }

          message.archivedTimestamp = reader.uint32();
          continue;
        }
        case 21: {
          if (tag !== 168) {
            break;
          }

          message.isMobile = reader.bool();
          continue;
        }
        case 22: {
          if (tag !== 176) {
            break;
          }

          message.mp4Created = reader.bool();
          continue;
        }
        case 23: {
          if (tag !== 186) {
            break;
          }

          message.pilotInitialCoordinate = Coordinate.decode(reader, reader.uint32());
          continue;
        }
        case 24: {
          if (tag !== 192) {
            break;
          }

          message.isMMA = reader.bool();
          continue;
        }
        case 25: {
          if (tag !== 200) {
            break;
          }

          message.isAtlas = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LiveVideoFlight {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      createdAt: isSet(object.createdAt) ? globalThis.Number(object.createdAt) : 0,
      visible: isSet(object.visible) ? globalThis.Boolean(object.visible) : false,
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      index: isSet(object.index) ? globalThis.String(object.index) : "",
      parentId: isSet(object.parentId) ? globalThis.String(object.parentId) : undefined,
      createdBy: isSet(object.createdBy) ? Author.fromJSON(object.createdBy) : undefined,
      live: isSet(object.live) ? globalThis.Boolean(object.live) : false,
      recordingPrefix: isSet(object.recordingPrefix) ? globalThis.String(object.recordingPrefix) : undefined,
      startedAt: isSet(object.startedAt) ? globalThis.Number(object.startedAt) : undefined,
      endedAt: isSet(object.endedAt) ? globalThis.Number(object.endedAt) : undefined,
      activated: isSet(object.activated) ? globalThis.Boolean(object.activated) : undefined,
      activatedAt: isSet(object.activatedAt) ? globalThis.Number(object.activatedAt) : undefined,
      code: isSet(object.code) ? globalThis.Number(object.code) : 0,
      recordingReady: isSet(object.recordingReady) ? globalThis.Boolean(object.recordingReady) : undefined,
      saveRecording: isSet(object.saveRecording) ? globalThis.Boolean(object.saveRecording) : false,
      streamCreated: isSet(object.streamCreated) ? globalThis.Boolean(object.streamCreated) : undefined,
      demoId: isSet(object.demoId) ? globalThis.String(object.demoId) : undefined,
      locked: isSet(object.locked) ? globalThis.Boolean(object.locked) : undefined,
      archivedTimestamp: isSet(object.archivedTimestamp) ? globalThis.Number(object.archivedTimestamp) : undefined,
      isMobile: isSet(object.isMobile) ? globalThis.Boolean(object.isMobile) : undefined,
      mp4Created: isSet(object.mp4Created) ? globalThis.Boolean(object.mp4Created) : undefined,
      pilotInitialCoordinate: isSet(object.pilotInitialCoordinate)
        ? Coordinate.fromJSON(object.pilotInitialCoordinate)
        : undefined,
      isMMA: isSet(object.isMMA) ? globalThis.Boolean(object.isMMA) : undefined,
      isAtlas: isSet(object.isAtlas) ? globalThis.Boolean(object.isAtlas) : undefined,
    };
  },

  toJSON(message: LiveVideoFlight): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.createdAt !== 0) {
      obj.createdAt = Math.round(message.createdAt);
    }
    if (message.visible !== false) {
      obj.visible = message.visible;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.index !== "") {
      obj.index = message.index;
    }
    if (message.parentId !== undefined) {
      obj.parentId = message.parentId;
    }
    if (message.createdBy !== undefined) {
      obj.createdBy = Author.toJSON(message.createdBy);
    }
    if (message.live !== false) {
      obj.live = message.live;
    }
    if (message.recordingPrefix !== undefined) {
      obj.recordingPrefix = message.recordingPrefix;
    }
    if (message.startedAt !== undefined) {
      obj.startedAt = Math.round(message.startedAt);
    }
    if (message.endedAt !== undefined) {
      obj.endedAt = Math.round(message.endedAt);
    }
    if (message.activated !== undefined) {
      obj.activated = message.activated;
    }
    if (message.activatedAt !== undefined) {
      obj.activatedAt = Math.round(message.activatedAt);
    }
    if (message.code !== 0) {
      obj.code = Math.round(message.code);
    }
    if (message.recordingReady !== undefined) {
      obj.recordingReady = message.recordingReady;
    }
    if (message.saveRecording !== false) {
      obj.saveRecording = message.saveRecording;
    }
    if (message.streamCreated !== undefined) {
      obj.streamCreated = message.streamCreated;
    }
    if (message.demoId !== undefined) {
      obj.demoId = message.demoId;
    }
    if (message.locked !== undefined) {
      obj.locked = message.locked;
    }
    if (message.archivedTimestamp !== undefined) {
      obj.archivedTimestamp = Math.round(message.archivedTimestamp);
    }
    if (message.isMobile !== undefined) {
      obj.isMobile = message.isMobile;
    }
    if (message.mp4Created !== undefined) {
      obj.mp4Created = message.mp4Created;
    }
    if (message.pilotInitialCoordinate !== undefined) {
      obj.pilotInitialCoordinate = Coordinate.toJSON(message.pilotInitialCoordinate);
    }
    if (message.isMMA !== undefined) {
      obj.isMMA = message.isMMA;
    }
    if (message.isAtlas !== undefined) {
      obj.isAtlas = message.isAtlas;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LiveVideoFlight>, I>>(base?: I): LiveVideoFlight {
    return LiveVideoFlight.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LiveVideoFlight>, I>>(object: I): LiveVideoFlight {
    const message = createBaseLiveVideoFlight();
    message.id = object.id ?? "";
    message.createdAt = object.createdAt ?? 0;
    message.visible = object.visible ?? false;
    message.name = object.name ?? "";
    message.index = object.index ?? "";
    message.parentId = object.parentId ?? undefined;
    message.createdBy = (object.createdBy !== undefined && object.createdBy !== null)
      ? Author.fromPartial(object.createdBy)
      : undefined;
    message.live = object.live ?? false;
    message.recordingPrefix = object.recordingPrefix ?? undefined;
    message.startedAt = object.startedAt ?? undefined;
    message.endedAt = object.endedAt ?? undefined;
    message.activated = object.activated ?? undefined;
    message.activatedAt = object.activatedAt ?? undefined;
    message.code = object.code ?? 0;
    message.recordingReady = object.recordingReady ?? undefined;
    message.saveRecording = object.saveRecording ?? false;
    message.streamCreated = object.streamCreated ?? undefined;
    message.demoId = object.demoId ?? undefined;
    message.locked = object.locked ?? undefined;
    message.archivedTimestamp = object.archivedTimestamp ?? undefined;
    message.isMobile = object.isMobile ?? undefined;
    message.mp4Created = object.mp4Created ?? undefined;
    message.pilotInitialCoordinate =
      (object.pilotInitialCoordinate !== undefined && object.pilotInitialCoordinate !== null)
        ? Coordinate.fromPartial(object.pilotInitialCoordinate)
        : undefined;
    message.isMMA = object.isMMA ?? undefined;
    message.isAtlas = object.isAtlas ?? undefined;
    return message;
  },
};

function createBaseMapComment(): MapComment {
  return { createdAt: 0, createdBy: undefined, id: "", latitude: 0, longitude: 0 };
}

export const MapComment: MessageFns<MapComment> = {
  encode(message: MapComment, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.createdAt !== 0) {
      writer.uint32(8).uint32(message.createdAt);
    }
    if (message.createdBy !== undefined) {
      Author.encode(message.createdBy, writer.uint32(18).fork()).join();
    }
    if (message.id !== "") {
      writer.uint32(26).string(message.id);
    }
    if (message.latitude !== 0) {
      writer.uint32(33).double(message.latitude);
    }
    if (message.longitude !== 0) {
      writer.uint32(41).double(message.longitude);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MapComment {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMapComment();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.createdAt = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.createdBy = Author.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 33) {
            break;
          }

          message.latitude = reader.double();
          continue;
        }
        case 5: {
          if (tag !== 41) {
            break;
          }

          message.longitude = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MapComment {
    return {
      createdAt: isSet(object.createdAt) ? globalThis.Number(object.createdAt) : 0,
      createdBy: isSet(object.createdBy) ? Author.fromJSON(object.createdBy) : undefined,
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      latitude: isSet(object.latitude) ? globalThis.Number(object.latitude) : 0,
      longitude: isSet(object.longitude) ? globalThis.Number(object.longitude) : 0,
    };
  },

  toJSON(message: MapComment): unknown {
    const obj: any = {};
    if (message.createdAt !== 0) {
      obj.createdAt = Math.round(message.createdAt);
    }
    if (message.createdBy !== undefined) {
      obj.createdBy = Author.toJSON(message.createdBy);
    }
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.latitude !== 0) {
      obj.latitude = message.latitude;
    }
    if (message.longitude !== 0) {
      obj.longitude = message.longitude;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MapComment>, I>>(base?: I): MapComment {
    return MapComment.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MapComment>, I>>(object: I): MapComment {
    const message = createBaseMapComment();
    message.createdAt = object.createdAt ?? 0;
    message.createdBy = (object.createdBy !== undefined && object.createdBy !== null)
      ? Author.fromPartial(object.createdBy)
      : undefined;
    message.id = object.id ?? "";
    message.latitude = object.latitude ?? 0;
    message.longitude = object.longitude ?? 0;
    return message;
  },
};

function createBaseMergedFlight(): MergedFlight {
  return {
    id: "",
    createdAt: 0,
    visible: false,
    name: "",
    index: "",
    parentId: undefined,
    createdBy: undefined,
    isSensitivitySynced: undefined,
    demoId: undefined,
    locked: undefined,
    archivedTimestamp: undefined,
  };
}

export const MergedFlight: MessageFns<MergedFlight> = {
  encode(message: MergedFlight, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.createdAt !== 0) {
      writer.uint32(16).uint32(message.createdAt);
    }
    if (message.visible !== false) {
      writer.uint32(24).bool(message.visible);
    }
    if (message.name !== "") {
      writer.uint32(34).string(message.name);
    }
    if (message.index !== "") {
      writer.uint32(42).string(message.index);
    }
    if (message.parentId !== undefined) {
      writer.uint32(50).string(message.parentId);
    }
    if (message.createdBy !== undefined) {
      Author.encode(message.createdBy, writer.uint32(58).fork()).join();
    }
    if (message.isSensitivitySynced !== undefined) {
      writer.uint32(64).bool(message.isSensitivitySynced);
    }
    if (message.demoId !== undefined) {
      writer.uint32(74).string(message.demoId);
    }
    if (message.locked !== undefined) {
      writer.uint32(80).bool(message.locked);
    }
    if (message.archivedTimestamp !== undefined) {
      writer.uint32(88).uint32(message.archivedTimestamp);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MergedFlight {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMergedFlight();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.createdAt = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.visible = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.index = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.parentId = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.createdBy = Author.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.isSensitivitySynced = reader.bool();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.demoId = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.locked = reader.bool();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.archivedTimestamp = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MergedFlight {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      createdAt: isSet(object.createdAt) ? globalThis.Number(object.createdAt) : 0,
      visible: isSet(object.visible) ? globalThis.Boolean(object.visible) : false,
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      index: isSet(object.index) ? globalThis.String(object.index) : "",
      parentId: isSet(object.parentId) ? globalThis.String(object.parentId) : undefined,
      createdBy: isSet(object.createdBy) ? Author.fromJSON(object.createdBy) : undefined,
      isSensitivitySynced: isSet(object.isSensitivitySynced)
        ? globalThis.Boolean(object.isSensitivitySynced)
        : undefined,
      demoId: isSet(object.demoId) ? globalThis.String(object.demoId) : undefined,
      locked: isSet(object.locked) ? globalThis.Boolean(object.locked) : undefined,
      archivedTimestamp: isSet(object.archivedTimestamp) ? globalThis.Number(object.archivedTimestamp) : undefined,
    };
  },

  toJSON(message: MergedFlight): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.createdAt !== 0) {
      obj.createdAt = Math.round(message.createdAt);
    }
    if (message.visible !== false) {
      obj.visible = message.visible;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.index !== "") {
      obj.index = message.index;
    }
    if (message.parentId !== undefined) {
      obj.parentId = message.parentId;
    }
    if (message.createdBy !== undefined) {
      obj.createdBy = Author.toJSON(message.createdBy);
    }
    if (message.isSensitivitySynced !== undefined) {
      obj.isSensitivitySynced = message.isSensitivitySynced;
    }
    if (message.demoId !== undefined) {
      obj.demoId = message.demoId;
    }
    if (message.locked !== undefined) {
      obj.locked = message.locked;
    }
    if (message.archivedTimestamp !== undefined) {
      obj.archivedTimestamp = Math.round(message.archivedTimestamp);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MergedFlight>, I>>(base?: I): MergedFlight {
    return MergedFlight.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MergedFlight>, I>>(object: I): MergedFlight {
    const message = createBaseMergedFlight();
    message.id = object.id ?? "";
    message.createdAt = object.createdAt ?? 0;
    message.visible = object.visible ?? false;
    message.name = object.name ?? "";
    message.index = object.index ?? "";
    message.parentId = object.parentId ?? undefined;
    message.createdBy = (object.createdBy !== undefined && object.createdBy !== null)
      ? Author.fromPartial(object.createdBy)
      : undefined;
    message.isSensitivitySynced = object.isSensitivitySynced ?? undefined;
    message.demoId = object.demoId ?? undefined;
    message.locked = object.locked ?? undefined;
    message.archivedTimestamp = object.archivedTimestamp ?? undefined;
    return message;
  },
};

function createBaseMinMax(): MinMax {
  return { min: undefined, max: undefined };
}

export const MinMax: MessageFns<MinMax> = {
  encode(message: MinMax, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.min !== undefined) {
      writer.uint32(13).float(message.min);
    }
    if (message.max !== undefined) {
      writer.uint32(21).float(message.max);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MinMax {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMinMax();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 13) {
            break;
          }

          message.min = reader.float();
          continue;
        }
        case 2: {
          if (tag !== 21) {
            break;
          }

          message.max = reader.float();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MinMax {
    return {
      min: isSet(object.min) ? globalThis.Number(object.min) : undefined,
      max: isSet(object.max) ? globalThis.Number(object.max) : undefined,
    };
  },

  toJSON(message: MinMax): unknown {
    const obj: any = {};
    if (message.min !== undefined) {
      obj.min = message.min;
    }
    if (message.max !== undefined) {
      obj.max = message.max;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MinMax>, I>>(base?: I): MinMax {
    return MinMax.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MinMax>, I>>(object: I): MinMax {
    const message = createBaseMinMax();
    message.min = object.min ?? undefined;
    message.max = object.max ?? undefined;
    return message;
  },
};

function createBaseNovaEntity(): NovaEntity {
  return { id: "", createdAt: 0 };
}

export const NovaEntity: MessageFns<NovaEntity> = {
  encode(message: NovaEntity, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.createdAt !== 0) {
      writer.uint32(16).uint32(message.createdAt);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): NovaEntity {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNovaEntity();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.createdAt = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): NovaEntity {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      createdAt: isSet(object.createdAt) ? globalThis.Number(object.createdAt) : 0,
    };
  },

  toJSON(message: NovaEntity): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.createdAt !== 0) {
      obj.createdAt = Math.round(message.createdAt);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<NovaEntity>, I>>(base?: I): NovaEntity {
    return NovaEntity.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<NovaEntity>, I>>(object: I): NovaEntity {
    const message = createBaseNovaEntity();
    message.id = object.id ?? "";
    message.createdAt = object.createdAt ?? 0;
    return message;
  },
};

function createBaseOrthoCompletePayload(): OrthoCompletePayload {
  return { area: 0, bbox: [], maxZoom: 0, minZoom: 0, scanArea: [] };
}

export const OrthoCompletePayload: MessageFns<OrthoCompletePayload> = {
  encode(message: OrthoCompletePayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.area !== 0) {
      writer.uint32(13).float(message.area);
    }
    for (const v of message.bbox) {
      Coordinate.encode(v!, writer.uint32(18).fork()).join();
    }
    if (message.maxZoom !== 0) {
      writer.uint32(24).int32(message.maxZoom);
    }
    if (message.minZoom !== 0) {
      writer.uint32(32).int32(message.minZoom);
    }
    for (const v of message.scanArea) {
      Coordinate.encode(v!, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OrthoCompletePayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOrthoCompletePayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 13) {
            break;
          }

          message.area = reader.float();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.bbox.push(Coordinate.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.maxZoom = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.minZoom = reader.int32();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.scanArea.push(Coordinate.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OrthoCompletePayload {
    return {
      area: isSet(object.area) ? globalThis.Number(object.area) : 0,
      bbox: globalThis.Array.isArray(object?.bbox) ? object.bbox.map((e: any) => Coordinate.fromJSON(e)) : [],
      maxZoom: isSet(object.maxZoom) ? globalThis.Number(object.maxZoom) : 0,
      minZoom: isSet(object.minZoom) ? globalThis.Number(object.minZoom) : 0,
      scanArea: globalThis.Array.isArray(object?.scanArea)
        ? object.scanArea.map((e: any) => Coordinate.fromJSON(e))
        : [],
    };
  },

  toJSON(message: OrthoCompletePayload): unknown {
    const obj: any = {};
    if (message.area !== 0) {
      obj.area = message.area;
    }
    if (message.bbox?.length) {
      obj.bbox = message.bbox.map((e) => Coordinate.toJSON(e));
    }
    if (message.maxZoom !== 0) {
      obj.maxZoom = Math.round(message.maxZoom);
    }
    if (message.minZoom !== 0) {
      obj.minZoom = Math.round(message.minZoom);
    }
    if (message.scanArea?.length) {
      obj.scanArea = message.scanArea.map((e) => Coordinate.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OrthoCompletePayload>, I>>(base?: I): OrthoCompletePayload {
    return OrthoCompletePayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OrthoCompletePayload>, I>>(object: I): OrthoCompletePayload {
    const message = createBaseOrthoCompletePayload();
    message.area = object.area ?? 0;
    message.bbox = object.bbox?.map((e) => Coordinate.fromPartial(e)) || [];
    message.maxZoom = object.maxZoom ?? 0;
    message.minZoom = object.minZoom ?? 0;
    message.scanArea = object.scanArea?.map((e) => Coordinate.fromPartial(e)) || [];
    return message;
  },
};

function createBaseOrthoFlight(): OrthoFlight {
  return {
    id: "",
    createdAt: 0,
    visible: false,
    name: "",
    index: "",
    parentId: undefined,
    orthoBoundingBox: [],
    job: undefined,
    images: [],
    createdBy: undefined,
    integrations: undefined,
    demoId: undefined,
    scanAreaFillColor: undefined,
    scanAreaOutlineColor: undefined,
    processAfterUpload: undefined,
    locked: undefined,
    archivedTimestamp: undefined,
    cogOrtho: undefined,
  };
}

export const OrthoFlight: MessageFns<OrthoFlight> = {
  encode(message: OrthoFlight, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.createdAt !== 0) {
      writer.uint32(16).uint32(message.createdAt);
    }
    if (message.visible !== false) {
      writer.uint32(24).bool(message.visible);
    }
    if (message.name !== "") {
      writer.uint32(34).string(message.name);
    }
    if (message.index !== "") {
      writer.uint32(42).string(message.index);
    }
    if (message.parentId !== undefined) {
      writer.uint32(50).string(message.parentId);
    }
    for (const v of message.orthoBoundingBox) {
      Coordinate.encode(v!, writer.uint32(58).fork()).join();
    }
    if (message.job !== undefined) {
      OrthoJob.encode(message.job, writer.uint32(66).fork()).join();
    }
    for (const v of message.images) {
      OrthoImage.encode(v!, writer.uint32(74).fork()).join();
    }
    if (message.createdBy !== undefined) {
      Author.encode(message.createdBy, writer.uint32(82).fork()).join();
    }
    if (message.integrations !== undefined) {
      writer.uint32(90).string(message.integrations);
    }
    if (message.demoId !== undefined) {
      writer.uint32(98).string(message.demoId);
    }
    if (message.scanAreaFillColor !== undefined) {
      writer.uint32(104).uint32(message.scanAreaFillColor);
    }
    if (message.scanAreaOutlineColor !== undefined) {
      writer.uint32(112).uint32(message.scanAreaOutlineColor);
    }
    if (message.processAfterUpload !== undefined) {
      writer.uint32(120).bool(message.processAfterUpload);
    }
    if (message.locked !== undefined) {
      writer.uint32(128).bool(message.locked);
    }
    if (message.archivedTimestamp !== undefined) {
      writer.uint32(136).uint32(message.archivedTimestamp);
    }
    if (message.cogOrtho !== undefined) {
      CogOrtho.encode(message.cogOrtho, writer.uint32(146).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OrthoFlight {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOrthoFlight();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.createdAt = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.visible = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.index = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.parentId = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.orthoBoundingBox.push(Coordinate.decode(reader, reader.uint32()));
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.job = OrthoJob.decode(reader, reader.uint32());
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.images.push(OrthoImage.decode(reader, reader.uint32()));
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.createdBy = Author.decode(reader, reader.uint32());
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.integrations = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.demoId = reader.string();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.scanAreaFillColor = reader.uint32();
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.scanAreaOutlineColor = reader.uint32();
          continue;
        }
        case 15: {
          if (tag !== 120) {
            break;
          }

          message.processAfterUpload = reader.bool();
          continue;
        }
        case 16: {
          if (tag !== 128) {
            break;
          }

          message.locked = reader.bool();
          continue;
        }
        case 17: {
          if (tag !== 136) {
            break;
          }

          message.archivedTimestamp = reader.uint32();
          continue;
        }
        case 18: {
          if (tag !== 146) {
            break;
          }

          message.cogOrtho = CogOrtho.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OrthoFlight {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      createdAt: isSet(object.createdAt) ? globalThis.Number(object.createdAt) : 0,
      visible: isSet(object.visible) ? globalThis.Boolean(object.visible) : false,
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      index: isSet(object.index) ? globalThis.String(object.index) : "",
      parentId: isSet(object.parentId) ? globalThis.String(object.parentId) : undefined,
      orthoBoundingBox: globalThis.Array.isArray(object?.orthoBoundingBox)
        ? object.orthoBoundingBox.map((e: any) => Coordinate.fromJSON(e))
        : [],
      job: isSet(object.job) ? OrthoJob.fromJSON(object.job) : undefined,
      images: globalThis.Array.isArray(object?.images) ? object.images.map((e: any) => OrthoImage.fromJSON(e)) : [],
      createdBy: isSet(object.createdBy) ? Author.fromJSON(object.createdBy) : undefined,
      integrations: isSet(object.integrations) ? globalThis.String(object.integrations) : undefined,
      demoId: isSet(object.demoId) ? globalThis.String(object.demoId) : undefined,
      scanAreaFillColor: isSet(object.scanAreaFillColor) ? globalThis.Number(object.scanAreaFillColor) : undefined,
      scanAreaOutlineColor: isSet(object.scanAreaOutlineColor)
        ? globalThis.Number(object.scanAreaOutlineColor)
        : undefined,
      processAfterUpload: isSet(object.processAfterUpload) ? globalThis.Boolean(object.processAfterUpload) : undefined,
      locked: isSet(object.locked) ? globalThis.Boolean(object.locked) : undefined,
      archivedTimestamp: isSet(object.archivedTimestamp) ? globalThis.Number(object.archivedTimestamp) : undefined,
      cogOrtho: isSet(object.cogOrtho) ? CogOrtho.fromJSON(object.cogOrtho) : undefined,
    };
  },

  toJSON(message: OrthoFlight): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.createdAt !== 0) {
      obj.createdAt = Math.round(message.createdAt);
    }
    if (message.visible !== false) {
      obj.visible = message.visible;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.index !== "") {
      obj.index = message.index;
    }
    if (message.parentId !== undefined) {
      obj.parentId = message.parentId;
    }
    if (message.orthoBoundingBox?.length) {
      obj.orthoBoundingBox = message.orthoBoundingBox.map((e) => Coordinate.toJSON(e));
    }
    if (message.job !== undefined) {
      obj.job = OrthoJob.toJSON(message.job);
    }
    if (message.images?.length) {
      obj.images = message.images.map((e) => OrthoImage.toJSON(e));
    }
    if (message.createdBy !== undefined) {
      obj.createdBy = Author.toJSON(message.createdBy);
    }
    if (message.integrations !== undefined) {
      obj.integrations = message.integrations;
    }
    if (message.demoId !== undefined) {
      obj.demoId = message.demoId;
    }
    if (message.scanAreaFillColor !== undefined) {
      obj.scanAreaFillColor = Math.round(message.scanAreaFillColor);
    }
    if (message.scanAreaOutlineColor !== undefined) {
      obj.scanAreaOutlineColor = Math.round(message.scanAreaOutlineColor);
    }
    if (message.processAfterUpload !== undefined) {
      obj.processAfterUpload = message.processAfterUpload;
    }
    if (message.locked !== undefined) {
      obj.locked = message.locked;
    }
    if (message.archivedTimestamp !== undefined) {
      obj.archivedTimestamp = Math.round(message.archivedTimestamp);
    }
    if (message.cogOrtho !== undefined) {
      obj.cogOrtho = CogOrtho.toJSON(message.cogOrtho);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OrthoFlight>, I>>(base?: I): OrthoFlight {
    return OrthoFlight.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OrthoFlight>, I>>(object: I): OrthoFlight {
    const message = createBaseOrthoFlight();
    message.id = object.id ?? "";
    message.createdAt = object.createdAt ?? 0;
    message.visible = object.visible ?? false;
    message.name = object.name ?? "";
    message.index = object.index ?? "";
    message.parentId = object.parentId ?? undefined;
    message.orthoBoundingBox = object.orthoBoundingBox?.map((e) => Coordinate.fromPartial(e)) || [];
    message.job = (object.job !== undefined && object.job !== null) ? OrthoJob.fromPartial(object.job) : undefined;
    message.images = object.images?.map((e) => OrthoImage.fromPartial(e)) || [];
    message.createdBy = (object.createdBy !== undefined && object.createdBy !== null)
      ? Author.fromPartial(object.createdBy)
      : undefined;
    message.integrations = object.integrations ?? undefined;
    message.demoId = object.demoId ?? undefined;
    message.scanAreaFillColor = object.scanAreaFillColor ?? undefined;
    message.scanAreaOutlineColor = object.scanAreaOutlineColor ?? undefined;
    message.processAfterUpload = object.processAfterUpload ?? undefined;
    message.locked = object.locked ?? undefined;
    message.archivedTimestamp = object.archivedTimestamp ?? undefined;
    message.cogOrtho = (object.cogOrtho !== undefined && object.cogOrtho !== null)
      ? CogOrtho.fromPartial(object.cogOrtho)
      : undefined;
    return message;
  },
};

function createBaseOrthoImage(): OrthoImage {
  return {
    id: "",
    longitude: 0,
    latitude: 0,
    altitude: undefined,
    height: undefined,
    pitch: undefined,
    yaw: undefined,
    roll: undefined,
    takenAt: undefined,
    make: undefined,
    focalLength: undefined,
    size: undefined,
    imageHeight: undefined,
    imageWidth: undefined,
    imageType: undefined,
    fov: [],
    model: undefined,
    hasLowQuality: undefined,
    hasLRF: undefined,
  };
}

export const OrthoImage: MessageFns<OrthoImage> = {
  encode(message: OrthoImage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.longitude !== 0) {
      writer.uint32(17).double(message.longitude);
    }
    if (message.latitude !== 0) {
      writer.uint32(25).double(message.latitude);
    }
    if (message.altitude !== undefined) {
      writer.uint32(37).float(message.altitude);
    }
    if (message.height !== undefined) {
      writer.uint32(45).float(message.height);
    }
    if (message.pitch !== undefined) {
      writer.uint32(53).float(message.pitch);
    }
    if (message.yaw !== undefined) {
      writer.uint32(61).float(message.yaw);
    }
    if (message.roll !== undefined) {
      writer.uint32(69).float(message.roll);
    }
    if (message.takenAt !== undefined) {
      writer.uint32(72).uint32(message.takenAt);
    }
    if (message.make !== undefined) {
      writer.uint32(82).string(message.make);
    }
    if (message.focalLength !== undefined) {
      writer.uint32(93).float(message.focalLength);
    }
    if (message.size !== undefined) {
      writer.uint32(96).uint32(message.size);
    }
    if (message.imageHeight !== undefined) {
      writer.uint32(104).uint32(message.imageHeight);
    }
    if (message.imageWidth !== undefined) {
      writer.uint32(112).uint32(message.imageWidth);
    }
    if (message.imageType !== undefined) {
      writer.uint32(120).int32(message.imageType);
    }
    writer.uint32(130).fork();
    for (const v of message.fov) {
      writer.float(v);
    }
    writer.join();
    if (message.model !== undefined) {
      writer.uint32(138).string(message.model);
    }
    if (message.hasLowQuality !== undefined) {
      writer.uint32(144).bool(message.hasLowQuality);
    }
    if (message.hasLRF !== undefined) {
      writer.uint32(152).bool(message.hasLRF);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OrthoImage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOrthoImage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.longitude = reader.double();
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.latitude = reader.double();
          continue;
        }
        case 4: {
          if (tag !== 37) {
            break;
          }

          message.altitude = reader.float();
          continue;
        }
        case 5: {
          if (tag !== 45) {
            break;
          }

          message.height = reader.float();
          continue;
        }
        case 6: {
          if (tag !== 53) {
            break;
          }

          message.pitch = reader.float();
          continue;
        }
        case 7: {
          if (tag !== 61) {
            break;
          }

          message.yaw = reader.float();
          continue;
        }
        case 8: {
          if (tag !== 69) {
            break;
          }

          message.roll = reader.float();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.takenAt = reader.uint32();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.make = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 93) {
            break;
          }

          message.focalLength = reader.float();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.size = reader.uint32();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.imageHeight = reader.uint32();
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.imageWidth = reader.uint32();
          continue;
        }
        case 15: {
          if (tag !== 120) {
            break;
          }

          message.imageType = reader.int32();
          continue;
        }
        case 16: {
          if (tag === 133) {
            message.fov.push(reader.float());

            continue;
          }

          if (tag === 130) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.fov.push(reader.float());
            }

            continue;
          }

          break;
        }
        case 17: {
          if (tag !== 138) {
            break;
          }

          message.model = reader.string();
          continue;
        }
        case 18: {
          if (tag !== 144) {
            break;
          }

          message.hasLowQuality = reader.bool();
          continue;
        }
        case 19: {
          if (tag !== 152) {
            break;
          }

          message.hasLRF = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OrthoImage {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      longitude: isSet(object.longitude) ? globalThis.Number(object.longitude) : 0,
      latitude: isSet(object.latitude) ? globalThis.Number(object.latitude) : 0,
      altitude: isSet(object.altitude) ? globalThis.Number(object.altitude) : undefined,
      height: isSet(object.height) ? globalThis.Number(object.height) : undefined,
      pitch: isSet(object.pitch) ? globalThis.Number(object.pitch) : undefined,
      yaw: isSet(object.yaw) ? globalThis.Number(object.yaw) : undefined,
      roll: isSet(object.roll) ? globalThis.Number(object.roll) : undefined,
      takenAt: isSet(object.takenAt) ? globalThis.Number(object.takenAt) : undefined,
      make: isSet(object.make) ? globalThis.String(object.make) : undefined,
      focalLength: isSet(object.focalLength) ? globalThis.Number(object.focalLength) : undefined,
      size: isSet(object.size) ? globalThis.Number(object.size) : undefined,
      imageHeight: isSet(object.imageHeight) ? globalThis.Number(object.imageHeight) : undefined,
      imageWidth: isSet(object.imageWidth) ? globalThis.Number(object.imageWidth) : undefined,
      imageType: isSet(object.imageType) ? globalThis.Number(object.imageType) : undefined,
      fov: globalThis.Array.isArray(object?.fov) ? object.fov.map((e: any) => globalThis.Number(e)) : [],
      model: isSet(object.model) ? globalThis.String(object.model) : undefined,
      hasLowQuality: isSet(object.hasLowQuality) ? globalThis.Boolean(object.hasLowQuality) : undefined,
      hasLRF: isSet(object.hasLRF) ? globalThis.Boolean(object.hasLRF) : undefined,
    };
  },

  toJSON(message: OrthoImage): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.longitude !== 0) {
      obj.longitude = message.longitude;
    }
    if (message.latitude !== 0) {
      obj.latitude = message.latitude;
    }
    if (message.altitude !== undefined) {
      obj.altitude = message.altitude;
    }
    if (message.height !== undefined) {
      obj.height = message.height;
    }
    if (message.pitch !== undefined) {
      obj.pitch = message.pitch;
    }
    if (message.yaw !== undefined) {
      obj.yaw = message.yaw;
    }
    if (message.roll !== undefined) {
      obj.roll = message.roll;
    }
    if (message.takenAt !== undefined) {
      obj.takenAt = Math.round(message.takenAt);
    }
    if (message.make !== undefined) {
      obj.make = message.make;
    }
    if (message.focalLength !== undefined) {
      obj.focalLength = message.focalLength;
    }
    if (message.size !== undefined) {
      obj.size = Math.round(message.size);
    }
    if (message.imageHeight !== undefined) {
      obj.imageHeight = Math.round(message.imageHeight);
    }
    if (message.imageWidth !== undefined) {
      obj.imageWidth = Math.round(message.imageWidth);
    }
    if (message.imageType !== undefined) {
      obj.imageType = Math.round(message.imageType);
    }
    if (message.fov?.length) {
      obj.fov = message.fov;
    }
    if (message.model !== undefined) {
      obj.model = message.model;
    }
    if (message.hasLowQuality !== undefined) {
      obj.hasLowQuality = message.hasLowQuality;
    }
    if (message.hasLRF !== undefined) {
      obj.hasLRF = message.hasLRF;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OrthoImage>, I>>(base?: I): OrthoImage {
    return OrthoImage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OrthoImage>, I>>(object: I): OrthoImage {
    const message = createBaseOrthoImage();
    message.id = object.id ?? "";
    message.longitude = object.longitude ?? 0;
    message.latitude = object.latitude ?? 0;
    message.altitude = object.altitude ?? undefined;
    message.height = object.height ?? undefined;
    message.pitch = object.pitch ?? undefined;
    message.yaw = object.yaw ?? undefined;
    message.roll = object.roll ?? undefined;
    message.takenAt = object.takenAt ?? undefined;
    message.make = object.make ?? undefined;
    message.focalLength = object.focalLength ?? undefined;
    message.size = object.size ?? undefined;
    message.imageHeight = object.imageHeight ?? undefined;
    message.imageWidth = object.imageWidth ?? undefined;
    message.imageType = object.imageType ?? undefined;
    message.fov = object.fov?.map((e) => e) || [];
    message.model = object.model ?? undefined;
    message.hasLowQuality = object.hasLowQuality ?? undefined;
    message.hasLRF = object.hasLRF ?? undefined;
    return message;
  },
};

function createBaseOrthoImageBatch(): OrthoImageBatch {
  return { entities: [] };
}

export const OrthoImageBatch: MessageFns<OrthoImageBatch> = {
  encode(message: OrthoImageBatch, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.entities) {
      OrthoImage.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OrthoImageBatch {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOrthoImageBatch();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.entities.push(OrthoImage.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OrthoImageBatch {
    return {
      entities: globalThis.Array.isArray(object?.entities)
        ? object.entities.map((e: any) => OrthoImage.fromJSON(e))
        : [],
    };
  },

  toJSON(message: OrthoImageBatch): unknown {
    const obj: any = {};
    if (message.entities?.length) {
      obj.entities = message.entities.map((e) => OrthoImage.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OrthoImageBatch>, I>>(base?: I): OrthoImageBatch {
    return OrthoImageBatch.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OrthoImageBatch>, I>>(object: I): OrthoImageBatch {
    const message = createBaseOrthoImageBatch();
    message.entities = object.entities?.map((e) => OrthoImage.fromPartial(e)) || [];
    return message;
  },
};

function createBaseOrthoJob(): OrthoJob {
  return {
    createdAt: 0,
    deletedAt: undefined,
    status: 0,
    maxZoom: undefined,
    extraFeatures: undefined,
    progress: undefined,
    updatedAt: undefined,
    area: undefined,
    minZoom: undefined,
    error: undefined,
    scanArea: [],
    processingMode: undefined,
  };
}

export const OrthoJob: MessageFns<OrthoJob> = {
  encode(message: OrthoJob, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.createdAt !== 0) {
      writer.uint32(8).uint32(message.createdAt);
    }
    if (message.deletedAt !== undefined) {
      writer.uint32(16).uint32(message.deletedAt);
    }
    if (message.status !== 0) {
      writer.uint32(24).int32(message.status);
    }
    if (message.maxZoom !== undefined) {
      writer.uint32(32).int32(message.maxZoom);
    }
    if (message.extraFeatures !== undefined) {
      writer.uint32(42).string(message.extraFeatures);
    }
    if (message.progress !== undefined) {
      writer.uint32(48).int32(message.progress);
    }
    if (message.updatedAt !== undefined) {
      writer.uint32(56).uint32(message.updatedAt);
    }
    if (message.area !== undefined) {
      writer.uint32(69).float(message.area);
    }
    if (message.minZoom !== undefined) {
      writer.uint32(72).int32(message.minZoom);
    }
    if (message.error !== undefined) {
      writer.uint32(80).int32(message.error);
    }
    for (const v of message.scanArea) {
      Coordinate.encode(v!, writer.uint32(90).fork()).join();
    }
    if (message.processingMode !== undefined) {
      writer.uint32(96).int32(message.processingMode);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OrthoJob {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOrthoJob();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.createdAt = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.deletedAt = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.status = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.maxZoom = reader.int32();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.extraFeatures = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.progress = reader.int32();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.updatedAt = reader.uint32();
          continue;
        }
        case 8: {
          if (tag !== 69) {
            break;
          }

          message.area = reader.float();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.minZoom = reader.int32();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.error = reader.int32();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.scanArea.push(Coordinate.decode(reader, reader.uint32()));
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.processingMode = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OrthoJob {
    return {
      createdAt: isSet(object.createdAt) ? globalThis.Number(object.createdAt) : 0,
      deletedAt: isSet(object.deletedAt) ? globalThis.Number(object.deletedAt) : undefined,
      status: isSet(object.status) ? globalThis.Number(object.status) : 0,
      maxZoom: isSet(object.maxZoom) ? globalThis.Number(object.maxZoom) : undefined,
      extraFeatures: isSet(object.extraFeatures) ? globalThis.String(object.extraFeatures) : undefined,
      progress: isSet(object.progress) ? globalThis.Number(object.progress) : undefined,
      updatedAt: isSet(object.updatedAt) ? globalThis.Number(object.updatedAt) : undefined,
      area: isSet(object.area) ? globalThis.Number(object.area) : undefined,
      minZoom: isSet(object.minZoom) ? globalThis.Number(object.minZoom) : undefined,
      error: isSet(object.error) ? globalThis.Number(object.error) : undefined,
      scanArea: globalThis.Array.isArray(object?.scanArea)
        ? object.scanArea.map((e: any) => Coordinate.fromJSON(e))
        : [],
      processingMode: isSet(object.processingMode) ? globalThis.Number(object.processingMode) : undefined,
    };
  },

  toJSON(message: OrthoJob): unknown {
    const obj: any = {};
    if (message.createdAt !== 0) {
      obj.createdAt = Math.round(message.createdAt);
    }
    if (message.deletedAt !== undefined) {
      obj.deletedAt = Math.round(message.deletedAt);
    }
    if (message.status !== 0) {
      obj.status = Math.round(message.status);
    }
    if (message.maxZoom !== undefined) {
      obj.maxZoom = Math.round(message.maxZoom);
    }
    if (message.extraFeatures !== undefined) {
      obj.extraFeatures = message.extraFeatures;
    }
    if (message.progress !== undefined) {
      obj.progress = Math.round(message.progress);
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = Math.round(message.updatedAt);
    }
    if (message.area !== undefined) {
      obj.area = message.area;
    }
    if (message.minZoom !== undefined) {
      obj.minZoom = Math.round(message.minZoom);
    }
    if (message.error !== undefined) {
      obj.error = Math.round(message.error);
    }
    if (message.scanArea?.length) {
      obj.scanArea = message.scanArea.map((e) => Coordinate.toJSON(e));
    }
    if (message.processingMode !== undefined) {
      obj.processingMode = Math.round(message.processingMode);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OrthoJob>, I>>(base?: I): OrthoJob {
    return OrthoJob.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OrthoJob>, I>>(object: I): OrthoJob {
    const message = createBaseOrthoJob();
    message.createdAt = object.createdAt ?? 0;
    message.deletedAt = object.deletedAt ?? undefined;
    message.status = object.status ?? 0;
    message.maxZoom = object.maxZoom ?? undefined;
    message.extraFeatures = object.extraFeatures ?? undefined;
    message.progress = object.progress ?? undefined;
    message.updatedAt = object.updatedAt ?? undefined;
    message.area = object.area ?? undefined;
    message.minZoom = object.minZoom ?? undefined;
    message.error = object.error ?? undefined;
    message.scanArea = object.scanArea?.map((e) => Coordinate.fromPartial(e)) || [];
    message.processingMode = object.processingMode ?? undefined;
    return message;
  },
};

function createBaseOrthoMask(): OrthoMask {
  return {
    createdAt: 0,
    createdBy: undefined,
    enabled: false,
    flightId: "",
    id: "",
    parentId: undefined,
    polygon: undefined,
  };
}

export const OrthoMask: MessageFns<OrthoMask> = {
  encode(message: OrthoMask, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.createdAt !== 0) {
      writer.uint32(8).uint32(message.createdAt);
    }
    if (message.createdBy !== undefined) {
      Author.encode(message.createdBy, writer.uint32(18).fork()).join();
    }
    if (message.enabled !== false) {
      writer.uint32(24).bool(message.enabled);
    }
    if (message.flightId !== "") {
      writer.uint32(34).string(message.flightId);
    }
    if (message.id !== "") {
      writer.uint32(42).string(message.id);
    }
    if (message.parentId !== undefined) {
      writer.uint32(50).string(message.parentId);
    }
    if (message.polygon !== undefined) {
      Polygon.encode(message.polygon, writer.uint32(58).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OrthoMask {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOrthoMask();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.createdAt = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.createdBy = Author.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.enabled = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.flightId = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.parentId = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.polygon = Polygon.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OrthoMask {
    return {
      createdAt: isSet(object.createdAt) ? globalThis.Number(object.createdAt) : 0,
      createdBy: isSet(object.createdBy) ? Author.fromJSON(object.createdBy) : undefined,
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
      flightId: isSet(object.flightId) ? globalThis.String(object.flightId) : "",
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      parentId: isSet(object.parentId) ? globalThis.String(object.parentId) : undefined,
      polygon: isSet(object.polygon) ? Polygon.fromJSON(object.polygon) : undefined,
    };
  },

  toJSON(message: OrthoMask): unknown {
    const obj: any = {};
    if (message.createdAt !== 0) {
      obj.createdAt = Math.round(message.createdAt);
    }
    if (message.createdBy !== undefined) {
      obj.createdBy = Author.toJSON(message.createdBy);
    }
    if (message.enabled !== false) {
      obj.enabled = message.enabled;
    }
    if (message.flightId !== "") {
      obj.flightId = message.flightId;
    }
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.parentId !== undefined) {
      obj.parentId = message.parentId;
    }
    if (message.polygon !== undefined) {
      obj.polygon = Polygon.toJSON(message.polygon);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OrthoMask>, I>>(base?: I): OrthoMask {
    return OrthoMask.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OrthoMask>, I>>(object: I): OrthoMask {
    const message = createBaseOrthoMask();
    message.createdAt = object.createdAt ?? 0;
    message.createdBy = (object.createdBy !== undefined && object.createdBy !== null)
      ? Author.fromPartial(object.createdBy)
      : undefined;
    message.enabled = object.enabled ?? false;
    message.flightId = object.flightId ?? "";
    message.id = object.id ?? "";
    message.parentId = object.parentId ?? undefined;
    message.polygon = (object.polygon !== undefined && object.polygon !== null)
      ? Polygon.fromPartial(object.polygon)
      : undefined;
    return message;
  },
};

function createBasePDFJob(): PDFJob {
  return {
    createdAt: 0,
    deletedAt: undefined,
    status: 0,
    id: "",
    name: "",
    hasPreview: undefined,
    index: "",
    parentId: undefined,
    pages: undefined,
    createdBy: undefined,
    progress: undefined,
    updatedAt: undefined,
    hasEmbeddedNovaContext: undefined,
    corners: [],
  };
}

export const PDFJob: MessageFns<PDFJob> = {
  encode(message: PDFJob, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.createdAt !== 0) {
      writer.uint32(8).uint32(message.createdAt);
    }
    if (message.deletedAt !== undefined) {
      writer.uint32(16).uint32(message.deletedAt);
    }
    if (message.status !== 0) {
      writer.uint32(24).int32(message.status);
    }
    if (message.id !== "") {
      writer.uint32(34).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(42).string(message.name);
    }
    if (message.hasPreview !== undefined) {
      writer.uint32(48).bool(message.hasPreview);
    }
    if (message.index !== "") {
      writer.uint32(58).string(message.index);
    }
    if (message.parentId !== undefined) {
      writer.uint32(66).string(message.parentId);
    }
    if (message.pages !== undefined) {
      writer.uint32(72).int32(message.pages);
    }
    if (message.createdBy !== undefined) {
      Author.encode(message.createdBy, writer.uint32(82).fork()).join();
    }
    if (message.progress !== undefined) {
      writer.uint32(88).int32(message.progress);
    }
    if (message.updatedAt !== undefined) {
      writer.uint32(96).uint32(message.updatedAt);
    }
    if (message.hasEmbeddedNovaContext !== undefined) {
      writer.uint32(104).bool(message.hasEmbeddedNovaContext);
    }
    for (const v of message.corners) {
      Coordinate.encode(v!, writer.uint32(114).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PDFJob {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePDFJob();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.createdAt = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.deletedAt = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.status = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.hasPreview = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.index = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.parentId = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.pages = reader.int32();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.createdBy = Author.decode(reader, reader.uint32());
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.progress = reader.int32();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.updatedAt = reader.uint32();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.hasEmbeddedNovaContext = reader.bool();
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.corners.push(Coordinate.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PDFJob {
    return {
      createdAt: isSet(object.createdAt) ? globalThis.Number(object.createdAt) : 0,
      deletedAt: isSet(object.deletedAt) ? globalThis.Number(object.deletedAt) : undefined,
      status: isSet(object.status) ? globalThis.Number(object.status) : 0,
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      hasPreview: isSet(object.hasPreview) ? globalThis.Boolean(object.hasPreview) : undefined,
      index: isSet(object.index) ? globalThis.String(object.index) : "",
      parentId: isSet(object.parentId) ? globalThis.String(object.parentId) : undefined,
      pages: isSet(object.pages) ? globalThis.Number(object.pages) : undefined,
      createdBy: isSet(object.createdBy) ? Author.fromJSON(object.createdBy) : undefined,
      progress: isSet(object.progress) ? globalThis.Number(object.progress) : undefined,
      updatedAt: isSet(object.updatedAt) ? globalThis.Number(object.updatedAt) : undefined,
      hasEmbeddedNovaContext: isSet(object.hasEmbeddedNovaContext)
        ? globalThis.Boolean(object.hasEmbeddedNovaContext)
        : undefined,
      corners: globalThis.Array.isArray(object?.corners) ? object.corners.map((e: any) => Coordinate.fromJSON(e)) : [],
    };
  },

  toJSON(message: PDFJob): unknown {
    const obj: any = {};
    if (message.createdAt !== 0) {
      obj.createdAt = Math.round(message.createdAt);
    }
    if (message.deletedAt !== undefined) {
      obj.deletedAt = Math.round(message.deletedAt);
    }
    if (message.status !== 0) {
      obj.status = Math.round(message.status);
    }
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.hasPreview !== undefined) {
      obj.hasPreview = message.hasPreview;
    }
    if (message.index !== "") {
      obj.index = message.index;
    }
    if (message.parentId !== undefined) {
      obj.parentId = message.parentId;
    }
    if (message.pages !== undefined) {
      obj.pages = Math.round(message.pages);
    }
    if (message.createdBy !== undefined) {
      obj.createdBy = Author.toJSON(message.createdBy);
    }
    if (message.progress !== undefined) {
      obj.progress = Math.round(message.progress);
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = Math.round(message.updatedAt);
    }
    if (message.hasEmbeddedNovaContext !== undefined) {
      obj.hasEmbeddedNovaContext = message.hasEmbeddedNovaContext;
    }
    if (message.corners?.length) {
      obj.corners = message.corners.map((e) => Coordinate.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PDFJob>, I>>(base?: I): PDFJob {
    return PDFJob.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PDFJob>, I>>(object: I): PDFJob {
    const message = createBasePDFJob();
    message.createdAt = object.createdAt ?? 0;
    message.deletedAt = object.deletedAt ?? undefined;
    message.status = object.status ?? 0;
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.hasPreview = object.hasPreview ?? undefined;
    message.index = object.index ?? "";
    message.parentId = object.parentId ?? undefined;
    message.pages = object.pages ?? undefined;
    message.createdBy = (object.createdBy !== undefined && object.createdBy !== null)
      ? Author.fromPartial(object.createdBy)
      : undefined;
    message.progress = object.progress ?? undefined;
    message.updatedAt = object.updatedAt ?? undefined;
    message.hasEmbeddedNovaContext = object.hasEmbeddedNovaContext ?? undefined;
    message.corners = object.corners?.map((e) => Coordinate.fromPartial(e)) || [];
    return message;
  },
};

function createBasePDFRaster(): PDFRaster {
  return {
    id: "",
    createdAt: 0,
    name: "",
    index: "",
    parentId: undefined,
    filename: "",
    corners: [],
    createdBy: undefined,
    archivedTimestamp: undefined,
    tiled: undefined,
  };
}

export const PDFRaster: MessageFns<PDFRaster> = {
  encode(message: PDFRaster, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.createdAt !== 0) {
      writer.uint32(16).uint32(message.createdAt);
    }
    if (message.name !== "") {
      writer.uint32(26).string(message.name);
    }
    if (message.index !== "") {
      writer.uint32(34).string(message.index);
    }
    if (message.parentId !== undefined) {
      writer.uint32(42).string(message.parentId);
    }
    if (message.filename !== "") {
      writer.uint32(50).string(message.filename);
    }
    for (const v of message.corners) {
      Coordinate.encode(v!, writer.uint32(58).fork()).join();
    }
    if (message.createdBy !== undefined) {
      Author.encode(message.createdBy, writer.uint32(66).fork()).join();
    }
    if (message.archivedTimestamp !== undefined) {
      writer.uint32(72).uint32(message.archivedTimestamp);
    }
    if (message.tiled !== undefined) {
      writer.uint32(80).bool(message.tiled);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PDFRaster {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePDFRaster();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.createdAt = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.index = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.parentId = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.filename = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.corners.push(Coordinate.decode(reader, reader.uint32()));
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.createdBy = Author.decode(reader, reader.uint32());
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.archivedTimestamp = reader.uint32();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.tiled = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PDFRaster {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      createdAt: isSet(object.createdAt) ? globalThis.Number(object.createdAt) : 0,
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      index: isSet(object.index) ? globalThis.String(object.index) : "",
      parentId: isSet(object.parentId) ? globalThis.String(object.parentId) : undefined,
      filename: isSet(object.filename) ? globalThis.String(object.filename) : "",
      corners: globalThis.Array.isArray(object?.corners) ? object.corners.map((e: any) => Coordinate.fromJSON(e)) : [],
      createdBy: isSet(object.createdBy) ? Author.fromJSON(object.createdBy) : undefined,
      archivedTimestamp: isSet(object.archivedTimestamp) ? globalThis.Number(object.archivedTimestamp) : undefined,
      tiled: isSet(object.tiled) ? globalThis.Boolean(object.tiled) : undefined,
    };
  },

  toJSON(message: PDFRaster): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.createdAt !== 0) {
      obj.createdAt = Math.round(message.createdAt);
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.index !== "") {
      obj.index = message.index;
    }
    if (message.parentId !== undefined) {
      obj.parentId = message.parentId;
    }
    if (message.filename !== "") {
      obj.filename = message.filename;
    }
    if (message.corners?.length) {
      obj.corners = message.corners.map((e) => Coordinate.toJSON(e));
    }
    if (message.createdBy !== undefined) {
      obj.createdBy = Author.toJSON(message.createdBy);
    }
    if (message.archivedTimestamp !== undefined) {
      obj.archivedTimestamp = Math.round(message.archivedTimestamp);
    }
    if (message.tiled !== undefined) {
      obj.tiled = message.tiled;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PDFRaster>, I>>(base?: I): PDFRaster {
    return PDFRaster.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PDFRaster>, I>>(object: I): PDFRaster {
    const message = createBasePDFRaster();
    message.id = object.id ?? "";
    message.createdAt = object.createdAt ?? 0;
    message.name = object.name ?? "";
    message.index = object.index ?? "";
    message.parentId = object.parentId ?? undefined;
    message.filename = object.filename ?? "";
    message.corners = object.corners?.map((e) => Coordinate.fromPartial(e)) || [];
    message.createdBy = (object.createdBy !== undefined && object.createdBy !== null)
      ? Author.fromPartial(object.createdBy)
      : undefined;
    message.archivedTimestamp = object.archivedTimestamp ?? undefined;
    message.tiled = object.tiled ?? undefined;
    return message;
  },
};

function createBasePanoramaFlight(): PanoramaFlight {
  return {
    id: "",
    createdAt: 0,
    visible: false,
    name: "",
    index: "",
    parentId: undefined,
    images: [],
    createdBy: undefined,
    demoId: undefined,
    locked: undefined,
    archivedTimestamp: undefined,
  };
}

export const PanoramaFlight: MessageFns<PanoramaFlight> = {
  encode(message: PanoramaFlight, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.createdAt !== 0) {
      writer.uint32(16).uint32(message.createdAt);
    }
    if (message.visible !== false) {
      writer.uint32(24).bool(message.visible);
    }
    if (message.name !== "") {
      writer.uint32(34).string(message.name);
    }
    if (message.index !== "") {
      writer.uint32(42).string(message.index);
    }
    if (message.parentId !== undefined) {
      writer.uint32(50).string(message.parentId);
    }
    for (const v of message.images) {
      PanoramaImage.encode(v!, writer.uint32(58).fork()).join();
    }
    if (message.createdBy !== undefined) {
      Author.encode(message.createdBy, writer.uint32(66).fork()).join();
    }
    if (message.demoId !== undefined) {
      writer.uint32(74).string(message.demoId);
    }
    if (message.locked !== undefined) {
      writer.uint32(80).bool(message.locked);
    }
    if (message.archivedTimestamp !== undefined) {
      writer.uint32(88).uint32(message.archivedTimestamp);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PanoramaFlight {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePanoramaFlight();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.createdAt = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.visible = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.index = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.parentId = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.images.push(PanoramaImage.decode(reader, reader.uint32()));
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.createdBy = Author.decode(reader, reader.uint32());
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.demoId = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.locked = reader.bool();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.archivedTimestamp = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PanoramaFlight {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      createdAt: isSet(object.createdAt) ? globalThis.Number(object.createdAt) : 0,
      visible: isSet(object.visible) ? globalThis.Boolean(object.visible) : false,
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      index: isSet(object.index) ? globalThis.String(object.index) : "",
      parentId: isSet(object.parentId) ? globalThis.String(object.parentId) : undefined,
      images: globalThis.Array.isArray(object?.images) ? object.images.map((e: any) => PanoramaImage.fromJSON(e)) : [],
      createdBy: isSet(object.createdBy) ? Author.fromJSON(object.createdBy) : undefined,
      demoId: isSet(object.demoId) ? globalThis.String(object.demoId) : undefined,
      locked: isSet(object.locked) ? globalThis.Boolean(object.locked) : undefined,
      archivedTimestamp: isSet(object.archivedTimestamp) ? globalThis.Number(object.archivedTimestamp) : undefined,
    };
  },

  toJSON(message: PanoramaFlight): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.createdAt !== 0) {
      obj.createdAt = Math.round(message.createdAt);
    }
    if (message.visible !== false) {
      obj.visible = message.visible;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.index !== "") {
      obj.index = message.index;
    }
    if (message.parentId !== undefined) {
      obj.parentId = message.parentId;
    }
    if (message.images?.length) {
      obj.images = message.images.map((e) => PanoramaImage.toJSON(e));
    }
    if (message.createdBy !== undefined) {
      obj.createdBy = Author.toJSON(message.createdBy);
    }
    if (message.demoId !== undefined) {
      obj.demoId = message.demoId;
    }
    if (message.locked !== undefined) {
      obj.locked = message.locked;
    }
    if (message.archivedTimestamp !== undefined) {
      obj.archivedTimestamp = Math.round(message.archivedTimestamp);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PanoramaFlight>, I>>(base?: I): PanoramaFlight {
    return PanoramaFlight.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PanoramaFlight>, I>>(object: I): PanoramaFlight {
    const message = createBasePanoramaFlight();
    message.id = object.id ?? "";
    message.createdAt = object.createdAt ?? 0;
    message.visible = object.visible ?? false;
    message.name = object.name ?? "";
    message.index = object.index ?? "";
    message.parentId = object.parentId ?? undefined;
    message.images = object.images?.map((e) => PanoramaImage.fromPartial(e)) || [];
    message.createdBy = (object.createdBy !== undefined && object.createdBy !== null)
      ? Author.fromPartial(object.createdBy)
      : undefined;
    message.demoId = object.demoId ?? undefined;
    message.locked = object.locked ?? undefined;
    message.archivedTimestamp = object.archivedTimestamp ?? undefined;
    return message;
  },
};

function createBasePanoramaImage(): PanoramaImage {
  return {
    id: "",
    longitude: undefined,
    latitude: undefined,
    altitude: undefined,
    pitch: undefined,
    yaw: undefined,
    roll: undefined,
    takenAt: 0,
    flightPitch: undefined,
    flightYaw: undefined,
    flightRoll: undefined,
    hasLowQuality: undefined,
  };
}

export const PanoramaImage: MessageFns<PanoramaImage> = {
  encode(message: PanoramaImage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.longitude !== undefined) {
      writer.uint32(17).double(message.longitude);
    }
    if (message.latitude !== undefined) {
      writer.uint32(25).double(message.latitude);
    }
    if (message.altitude !== undefined) {
      writer.uint32(37).float(message.altitude);
    }
    if (message.pitch !== undefined) {
      writer.uint32(45).float(message.pitch);
    }
    if (message.yaw !== undefined) {
      writer.uint32(53).float(message.yaw);
    }
    if (message.roll !== undefined) {
      writer.uint32(61).float(message.roll);
    }
    if (message.takenAt !== 0) {
      writer.uint32(64).uint32(message.takenAt);
    }
    if (message.flightPitch !== undefined) {
      writer.uint32(77).float(message.flightPitch);
    }
    if (message.flightYaw !== undefined) {
      writer.uint32(85).float(message.flightYaw);
    }
    if (message.flightRoll !== undefined) {
      writer.uint32(93).float(message.flightRoll);
    }
    if (message.hasLowQuality !== undefined) {
      writer.uint32(96).bool(message.hasLowQuality);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PanoramaImage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePanoramaImage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.longitude = reader.double();
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.latitude = reader.double();
          continue;
        }
        case 4: {
          if (tag !== 37) {
            break;
          }

          message.altitude = reader.float();
          continue;
        }
        case 5: {
          if (tag !== 45) {
            break;
          }

          message.pitch = reader.float();
          continue;
        }
        case 6: {
          if (tag !== 53) {
            break;
          }

          message.yaw = reader.float();
          continue;
        }
        case 7: {
          if (tag !== 61) {
            break;
          }

          message.roll = reader.float();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.takenAt = reader.uint32();
          continue;
        }
        case 9: {
          if (tag !== 77) {
            break;
          }

          message.flightPitch = reader.float();
          continue;
        }
        case 10: {
          if (tag !== 85) {
            break;
          }

          message.flightYaw = reader.float();
          continue;
        }
        case 11: {
          if (tag !== 93) {
            break;
          }

          message.flightRoll = reader.float();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.hasLowQuality = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PanoramaImage {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      longitude: isSet(object.longitude) ? globalThis.Number(object.longitude) : undefined,
      latitude: isSet(object.latitude) ? globalThis.Number(object.latitude) : undefined,
      altitude: isSet(object.altitude) ? globalThis.Number(object.altitude) : undefined,
      pitch: isSet(object.pitch) ? globalThis.Number(object.pitch) : undefined,
      yaw: isSet(object.yaw) ? globalThis.Number(object.yaw) : undefined,
      roll: isSet(object.roll) ? globalThis.Number(object.roll) : undefined,
      takenAt: isSet(object.takenAt) ? globalThis.Number(object.takenAt) : 0,
      flightPitch: isSet(object.flightPitch) ? globalThis.Number(object.flightPitch) : undefined,
      flightYaw: isSet(object.flightYaw) ? globalThis.Number(object.flightYaw) : undefined,
      flightRoll: isSet(object.flightRoll) ? globalThis.Number(object.flightRoll) : undefined,
      hasLowQuality: isSet(object.hasLowQuality) ? globalThis.Boolean(object.hasLowQuality) : undefined,
    };
  },

  toJSON(message: PanoramaImage): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.longitude !== undefined) {
      obj.longitude = message.longitude;
    }
    if (message.latitude !== undefined) {
      obj.latitude = message.latitude;
    }
    if (message.altitude !== undefined) {
      obj.altitude = message.altitude;
    }
    if (message.pitch !== undefined) {
      obj.pitch = message.pitch;
    }
    if (message.yaw !== undefined) {
      obj.yaw = message.yaw;
    }
    if (message.roll !== undefined) {
      obj.roll = message.roll;
    }
    if (message.takenAt !== 0) {
      obj.takenAt = Math.round(message.takenAt);
    }
    if (message.flightPitch !== undefined) {
      obj.flightPitch = message.flightPitch;
    }
    if (message.flightYaw !== undefined) {
      obj.flightYaw = message.flightYaw;
    }
    if (message.flightRoll !== undefined) {
      obj.flightRoll = message.flightRoll;
    }
    if (message.hasLowQuality !== undefined) {
      obj.hasLowQuality = message.hasLowQuality;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PanoramaImage>, I>>(base?: I): PanoramaImage {
    return PanoramaImage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PanoramaImage>, I>>(object: I): PanoramaImage {
    const message = createBasePanoramaImage();
    message.id = object.id ?? "";
    message.longitude = object.longitude ?? undefined;
    message.latitude = object.latitude ?? undefined;
    message.altitude = object.altitude ?? undefined;
    message.pitch = object.pitch ?? undefined;
    message.yaw = object.yaw ?? undefined;
    message.roll = object.roll ?? undefined;
    message.takenAt = object.takenAt ?? 0;
    message.flightPitch = object.flightPitch ?? undefined;
    message.flightYaw = object.flightYaw ?? undefined;
    message.flightRoll = object.flightRoll ?? undefined;
    message.hasLowQuality = object.hasLowQuality ?? undefined;
    return message;
  },
};

function createBasePerimeter(): Perimeter {
  return {
    id: "",
    createdAt: 0,
    visible: false,
    name: "",
    index: "",
    parentId: undefined,
    polygons: [],
    createdBy: undefined,
    outline: undefined,
    width: undefined,
    stroke: undefined,
    buffers: undefined,
    demoId: undefined,
    locked: undefined,
    archivedTimestamp: undefined,
  };
}

export const Perimeter: MessageFns<Perimeter> = {
  encode(message: Perimeter, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.createdAt !== 0) {
      writer.uint32(16).uint32(message.createdAt);
    }
    if (message.visible !== false) {
      writer.uint32(24).bool(message.visible);
    }
    if (message.name !== "") {
      writer.uint32(34).string(message.name);
    }
    if (message.index !== "") {
      writer.uint32(42).string(message.index);
    }
    if (message.parentId !== undefined) {
      writer.uint32(50).string(message.parentId);
    }
    for (const v of message.polygons) {
      Polygon.encode(v!, writer.uint32(58).fork()).join();
    }
    if (message.createdBy !== undefined) {
      Author.encode(message.createdBy, writer.uint32(66).fork()).join();
    }
    if (message.outline !== undefined) {
      writer.uint32(72).uint32(message.outline);
    }
    if (message.width !== undefined) {
      writer.uint32(80).int32(message.width);
    }
    if (message.stroke !== undefined) {
      writer.uint32(88).int32(message.stroke);
    }
    if (message.buffers !== undefined) {
      PerimeterBuffer.encode(message.buffers, writer.uint32(98).fork()).join();
    }
    if (message.demoId !== undefined) {
      writer.uint32(106).string(message.demoId);
    }
    if (message.locked !== undefined) {
      writer.uint32(112).bool(message.locked);
    }
    if (message.archivedTimestamp !== undefined) {
      writer.uint32(120).uint32(message.archivedTimestamp);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Perimeter {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePerimeter();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.createdAt = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.visible = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.index = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.parentId = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.polygons.push(Polygon.decode(reader, reader.uint32()));
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.createdBy = Author.decode(reader, reader.uint32());
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.outline = reader.uint32();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.width = reader.int32();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.stroke = reader.int32();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.buffers = PerimeterBuffer.decode(reader, reader.uint32());
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.demoId = reader.string();
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.locked = reader.bool();
          continue;
        }
        case 15: {
          if (tag !== 120) {
            break;
          }

          message.archivedTimestamp = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Perimeter {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      createdAt: isSet(object.createdAt) ? globalThis.Number(object.createdAt) : 0,
      visible: isSet(object.visible) ? globalThis.Boolean(object.visible) : false,
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      index: isSet(object.index) ? globalThis.String(object.index) : "",
      parentId: isSet(object.parentId) ? globalThis.String(object.parentId) : undefined,
      polygons: globalThis.Array.isArray(object?.polygons) ? object.polygons.map((e: any) => Polygon.fromJSON(e)) : [],
      createdBy: isSet(object.createdBy) ? Author.fromJSON(object.createdBy) : undefined,
      outline: isSet(object.outline) ? globalThis.Number(object.outline) : undefined,
      width: isSet(object.width) ? globalThis.Number(object.width) : undefined,
      stroke: isSet(object.stroke) ? globalThis.Number(object.stroke) : undefined,
      buffers: isSet(object.buffers) ? PerimeterBuffer.fromJSON(object.buffers) : undefined,
      demoId: isSet(object.demoId) ? globalThis.String(object.demoId) : undefined,
      locked: isSet(object.locked) ? globalThis.Boolean(object.locked) : undefined,
      archivedTimestamp: isSet(object.archivedTimestamp) ? globalThis.Number(object.archivedTimestamp) : undefined,
    };
  },

  toJSON(message: Perimeter): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.createdAt !== 0) {
      obj.createdAt = Math.round(message.createdAt);
    }
    if (message.visible !== false) {
      obj.visible = message.visible;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.index !== "") {
      obj.index = message.index;
    }
    if (message.parentId !== undefined) {
      obj.parentId = message.parentId;
    }
    if (message.polygons?.length) {
      obj.polygons = message.polygons.map((e) => Polygon.toJSON(e));
    }
    if (message.createdBy !== undefined) {
      obj.createdBy = Author.toJSON(message.createdBy);
    }
    if (message.outline !== undefined) {
      obj.outline = Math.round(message.outline);
    }
    if (message.width !== undefined) {
      obj.width = Math.round(message.width);
    }
    if (message.stroke !== undefined) {
      obj.stroke = Math.round(message.stroke);
    }
    if (message.buffers !== undefined) {
      obj.buffers = PerimeterBuffer.toJSON(message.buffers);
    }
    if (message.demoId !== undefined) {
      obj.demoId = message.demoId;
    }
    if (message.locked !== undefined) {
      obj.locked = message.locked;
    }
    if (message.archivedTimestamp !== undefined) {
      obj.archivedTimestamp = Math.round(message.archivedTimestamp);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Perimeter>, I>>(base?: I): Perimeter {
    return Perimeter.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Perimeter>, I>>(object: I): Perimeter {
    const message = createBasePerimeter();
    message.id = object.id ?? "";
    message.createdAt = object.createdAt ?? 0;
    message.visible = object.visible ?? false;
    message.name = object.name ?? "";
    message.index = object.index ?? "";
    message.parentId = object.parentId ?? undefined;
    message.polygons = object.polygons?.map((e) => Polygon.fromPartial(e)) || [];
    message.createdBy = (object.createdBy !== undefined && object.createdBy !== null)
      ? Author.fromPartial(object.createdBy)
      : undefined;
    message.outline = object.outline ?? undefined;
    message.width = object.width ?? undefined;
    message.stroke = object.stroke ?? undefined;
    message.buffers = (object.buffers !== undefined && object.buffers !== null)
      ? PerimeterBuffer.fromPartial(object.buffers)
      : undefined;
    message.demoId = object.demoId ?? undefined;
    message.locked = object.locked ?? undefined;
    message.archivedTimestamp = object.archivedTimestamp ?? undefined;
    return message;
  },
};

function createBasePerimeterBuffer(): PerimeterBuffer {
  return { range: [], unit: "" };
}

export const PerimeterBuffer: MessageFns<PerimeterBuffer> = {
  encode(message: PerimeterBuffer, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.range) {
      BufferRange.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.unit !== "") {
      writer.uint32(18).string(message.unit);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PerimeterBuffer {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePerimeterBuffer();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.range.push(BufferRange.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.unit = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PerimeterBuffer {
    return {
      range: globalThis.Array.isArray(object?.range) ? object.range.map((e: any) => BufferRange.fromJSON(e)) : [],
      unit: isSet(object.unit) ? globalThis.String(object.unit) : "",
    };
  },

  toJSON(message: PerimeterBuffer): unknown {
    const obj: any = {};
    if (message.range?.length) {
      obj.range = message.range.map((e) => BufferRange.toJSON(e));
    }
    if (message.unit !== "") {
      obj.unit = message.unit;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PerimeterBuffer>, I>>(base?: I): PerimeterBuffer {
    return PerimeterBuffer.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PerimeterBuffer>, I>>(object: I): PerimeterBuffer {
    const message = createBasePerimeterBuffer();
    message.range = object.range?.map((e) => BufferRange.fromPartial(e)) || [];
    message.unit = object.unit ?? "";
    return message;
  },
};

function createBasePerimeterDistance(): PerimeterDistance {
  return { range: [], unit: "" };
}

export const PerimeterDistance: MessageFns<PerimeterDistance> = {
  encode(message: PerimeterDistance, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.range) {
      Range.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.unit !== "") {
      writer.uint32(18).string(message.unit);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PerimeterDistance {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePerimeterDistance();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.range.push(Range.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.unit = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PerimeterDistance {
    return {
      range: globalThis.Array.isArray(object?.range) ? object.range.map((e: any) => Range.fromJSON(e)) : [],
      unit: isSet(object.unit) ? globalThis.String(object.unit) : "",
    };
  },

  toJSON(message: PerimeterDistance): unknown {
    const obj: any = {};
    if (message.range?.length) {
      obj.range = message.range.map((e) => Range.toJSON(e));
    }
    if (message.unit !== "") {
      obj.unit = message.unit;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PerimeterDistance>, I>>(base?: I): PerimeterDistance {
    return PerimeterDistance.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PerimeterDistance>, I>>(object: I): PerimeterDistance {
    const message = createBasePerimeterDistance();
    message.range = object.range?.map((e) => Range.fromPartial(e)) || [];
    message.unit = object.unit ?? "";
    return message;
  },
};

function createBasePolygon(): Polygon {
  return { coordinates: [] };
}

export const Polygon: MessageFns<Polygon> = {
  encode(message: Polygon, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.coordinates) {
      Coordinate.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Polygon {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePolygon();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.coordinates.push(Coordinate.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Polygon {
    return {
      coordinates: globalThis.Array.isArray(object?.coordinates)
        ? object.coordinates.map((e: any) => Coordinate.fromJSON(e))
        : [],
    };
  },

  toJSON(message: Polygon): unknown {
    const obj: any = {};
    if (message.coordinates?.length) {
      obj.coordinates = message.coordinates.map((e) => Coordinate.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Polygon>, I>>(base?: I): Polygon {
    return Polygon.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Polygon>, I>>(object: I): Polygon {
    const message = createBasePolygon();
    message.coordinates = object.coordinates?.map((e) => Coordinate.fromPartial(e)) || [];
    return message;
  },
};

function createBaseProject(): Project {
  return {
    infraredFlights: [],
    orthoFlights: [],
    videoFlights: [],
    videoColorFinderFlights: [],
    imageColorFinderFlights: [],
    panoramaFlights: [],
    icons: [],
    lines: [],
    texts: [],
    perimeters: [],
    PDFs: [],
    groups: [],
    PDFRasters: [],
    lastUpdated: "",
    liveVideoFlights: [],
    mergedFlights: [],
    rulers: [],
    orthoMasks: [],
    satelliteFlights: [],
    mapComments: [],
    userLocationShares: [],
  };
}

export const Project: MessageFns<Project> = {
  encode(message: Project, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.infraredFlights) {
      InfraredFlight.encode(v!, writer.uint32(10).fork()).join();
    }
    for (const v of message.orthoFlights) {
      OrthoFlight.encode(v!, writer.uint32(18).fork()).join();
    }
    for (const v of message.videoFlights) {
      VideoFlight.encode(v!, writer.uint32(26).fork()).join();
    }
    for (const v of message.videoColorFinderFlights) {
      VideoColorFinderFlight.encode(v!, writer.uint32(34).fork()).join();
    }
    for (const v of message.imageColorFinderFlights) {
      ImageColorFinderFlight.encode(v!, writer.uint32(42).fork()).join();
    }
    for (const v of message.panoramaFlights) {
      PanoramaFlight.encode(v!, writer.uint32(50).fork()).join();
    }
    for (const v of message.icons) {
      Icon.encode(v!, writer.uint32(58).fork()).join();
    }
    for (const v of message.lines) {
      Line.encode(v!, writer.uint32(66).fork()).join();
    }
    for (const v of message.texts) {
      Text.encode(v!, writer.uint32(74).fork()).join();
    }
    for (const v of message.perimeters) {
      Perimeter.encode(v!, writer.uint32(82).fork()).join();
    }
    for (const v of message.PDFs) {
      PDFJob.encode(v!, writer.uint32(90).fork()).join();
    }
    for (const v of message.groups) {
      Group.encode(v!, writer.uint32(98).fork()).join();
    }
    for (const v of message.PDFRasters) {
      PDFRaster.encode(v!, writer.uint32(106).fork()).join();
    }
    if (message.lastUpdated !== "") {
      writer.uint32(114).string(message.lastUpdated);
    }
    for (const v of message.liveVideoFlights) {
      LiveVideoFlight.encode(v!, writer.uint32(122).fork()).join();
    }
    for (const v of message.mergedFlights) {
      MergedFlight.encode(v!, writer.uint32(130).fork()).join();
    }
    for (const v of message.rulers) {
      Ruler.encode(v!, writer.uint32(138).fork()).join();
    }
    for (const v of message.orthoMasks) {
      OrthoMask.encode(v!, writer.uint32(146).fork()).join();
    }
    for (const v of message.satelliteFlights) {
      SatelliteFlight.encode(v!, writer.uint32(154).fork()).join();
    }
    for (const v of message.mapComments) {
      MapComment.encode(v!, writer.uint32(162).fork()).join();
    }
    for (const v of message.userLocationShares) {
      UserLocationShare.encode(v!, writer.uint32(170).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Project {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProject();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.infraredFlights.push(InfraredFlight.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.orthoFlights.push(OrthoFlight.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.videoFlights.push(VideoFlight.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.videoColorFinderFlights.push(VideoColorFinderFlight.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.imageColorFinderFlights.push(ImageColorFinderFlight.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.panoramaFlights.push(PanoramaFlight.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.icons.push(Icon.decode(reader, reader.uint32()));
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.lines.push(Line.decode(reader, reader.uint32()));
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.texts.push(Text.decode(reader, reader.uint32()));
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.perimeters.push(Perimeter.decode(reader, reader.uint32()));
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.PDFs.push(PDFJob.decode(reader, reader.uint32()));
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.groups.push(Group.decode(reader, reader.uint32()));
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.PDFRasters.push(PDFRaster.decode(reader, reader.uint32()));
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.lastUpdated = reader.string();
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.liveVideoFlights.push(LiveVideoFlight.decode(reader, reader.uint32()));
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.mergedFlights.push(MergedFlight.decode(reader, reader.uint32()));
          continue;
        }
        case 17: {
          if (tag !== 138) {
            break;
          }

          message.rulers.push(Ruler.decode(reader, reader.uint32()));
          continue;
        }
        case 18: {
          if (tag !== 146) {
            break;
          }

          message.orthoMasks.push(OrthoMask.decode(reader, reader.uint32()));
          continue;
        }
        case 19: {
          if (tag !== 154) {
            break;
          }

          message.satelliteFlights.push(SatelliteFlight.decode(reader, reader.uint32()));
          continue;
        }
        case 20: {
          if (tag !== 162) {
            break;
          }

          message.mapComments.push(MapComment.decode(reader, reader.uint32()));
          continue;
        }
        case 21: {
          if (tag !== 170) {
            break;
          }

          message.userLocationShares.push(UserLocationShare.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Project {
    return {
      infraredFlights: globalThis.Array.isArray(object?.infraredFlights)
        ? object.infraredFlights.map((e: any) => InfraredFlight.fromJSON(e))
        : [],
      orthoFlights: globalThis.Array.isArray(object?.orthoFlights)
        ? object.orthoFlights.map((e: any) => OrthoFlight.fromJSON(e))
        : [],
      videoFlights: globalThis.Array.isArray(object?.videoFlights)
        ? object.videoFlights.map((e: any) => VideoFlight.fromJSON(e))
        : [],
      videoColorFinderFlights: globalThis.Array.isArray(object?.videoColorFinderFlights)
        ? object.videoColorFinderFlights.map((e: any) => VideoColorFinderFlight.fromJSON(e))
        : [],
      imageColorFinderFlights: globalThis.Array.isArray(object?.imageColorFinderFlights)
        ? object.imageColorFinderFlights.map((e: any) => ImageColorFinderFlight.fromJSON(e))
        : [],
      panoramaFlights: globalThis.Array.isArray(object?.panoramaFlights)
        ? object.panoramaFlights.map((e: any) => PanoramaFlight.fromJSON(e))
        : [],
      icons: globalThis.Array.isArray(object?.icons)
        ? object.icons.map((e: any) => Icon.fromJSON(e))
        : [],
      lines: globalThis.Array.isArray(object?.lines) ? object.lines.map((e: any) => Line.fromJSON(e)) : [],
      texts: globalThis.Array.isArray(object?.texts) ? object.texts.map((e: any) => Text.fromJSON(e)) : [],
      perimeters: globalThis.Array.isArray(object?.perimeters)
        ? object.perimeters.map((e: any) => Perimeter.fromJSON(e))
        : [],
      PDFs: globalThis.Array.isArray(object?.PDFs)
        ? object.PDFs.map((e: any) => PDFJob.fromJSON(e))
        : [],
      groups: globalThis.Array.isArray(object?.groups) ? object.groups.map((e: any) => Group.fromJSON(e)) : [],
      PDFRasters: globalThis.Array.isArray(object?.PDFRasters)
        ? object.PDFRasters.map((e: any) => PDFRaster.fromJSON(e))
        : [],
      lastUpdated: isSet(object.lastUpdated) ? globalThis.String(object.lastUpdated) : "",
      liveVideoFlights: globalThis.Array.isArray(object?.liveVideoFlights)
        ? object.liveVideoFlights.map((e: any) => LiveVideoFlight.fromJSON(e))
        : [],
      mergedFlights: globalThis.Array.isArray(object?.mergedFlights)
        ? object.mergedFlights.map((e: any) => MergedFlight.fromJSON(e))
        : [],
      rulers: globalThis.Array.isArray(object?.rulers)
        ? object.rulers.map((e: any) => Ruler.fromJSON(e))
        : [],
      orthoMasks: globalThis.Array.isArray(object?.orthoMasks)
        ? object.orthoMasks.map((e: any) => OrthoMask.fromJSON(e))
        : [],
      satelliteFlights: globalThis.Array.isArray(object?.satelliteFlights)
        ? object.satelliteFlights.map((e: any) => SatelliteFlight.fromJSON(e))
        : [],
      mapComments: globalThis.Array.isArray(object?.mapComments)
        ? object.mapComments.map((e: any) => MapComment.fromJSON(e))
        : [],
      userLocationShares: globalThis.Array.isArray(object?.userLocationShares)
        ? object.userLocationShares.map((e: any) => UserLocationShare.fromJSON(e))
        : [],
    };
  },

  toJSON(message: Project): unknown {
    const obj: any = {};
    if (message.infraredFlights?.length) {
      obj.infraredFlights = message.infraredFlights.map((e) => InfraredFlight.toJSON(e));
    }
    if (message.orthoFlights?.length) {
      obj.orthoFlights = message.orthoFlights.map((e) => OrthoFlight.toJSON(e));
    }
    if (message.videoFlights?.length) {
      obj.videoFlights = message.videoFlights.map((e) => VideoFlight.toJSON(e));
    }
    if (message.videoColorFinderFlights?.length) {
      obj.videoColorFinderFlights = message.videoColorFinderFlights.map((e) => VideoColorFinderFlight.toJSON(e));
    }
    if (message.imageColorFinderFlights?.length) {
      obj.imageColorFinderFlights = message.imageColorFinderFlights.map((e) => ImageColorFinderFlight.toJSON(e));
    }
    if (message.panoramaFlights?.length) {
      obj.panoramaFlights = message.panoramaFlights.map((e) => PanoramaFlight.toJSON(e));
    }
    if (message.icons?.length) {
      obj.icons = message.icons.map((e) => Icon.toJSON(e));
    }
    if (message.lines?.length) {
      obj.lines = message.lines.map((e) => Line.toJSON(e));
    }
    if (message.texts?.length) {
      obj.texts = message.texts.map((e) => Text.toJSON(e));
    }
    if (message.perimeters?.length) {
      obj.perimeters = message.perimeters.map((e) => Perimeter.toJSON(e));
    }
    if (message.PDFs?.length) {
      obj.PDFs = message.PDFs.map((e) => PDFJob.toJSON(e));
    }
    if (message.groups?.length) {
      obj.groups = message.groups.map((e) => Group.toJSON(e));
    }
    if (message.PDFRasters?.length) {
      obj.PDFRasters = message.PDFRasters.map((e) => PDFRaster.toJSON(e));
    }
    if (message.lastUpdated !== "") {
      obj.lastUpdated = message.lastUpdated;
    }
    if (message.liveVideoFlights?.length) {
      obj.liveVideoFlights = message.liveVideoFlights.map((e) => LiveVideoFlight.toJSON(e));
    }
    if (message.mergedFlights?.length) {
      obj.mergedFlights = message.mergedFlights.map((e) => MergedFlight.toJSON(e));
    }
    if (message.rulers?.length) {
      obj.rulers = message.rulers.map((e) => Ruler.toJSON(e));
    }
    if (message.orthoMasks?.length) {
      obj.orthoMasks = message.orthoMasks.map((e) => OrthoMask.toJSON(e));
    }
    if (message.satelliteFlights?.length) {
      obj.satelliteFlights = message.satelliteFlights.map((e) => SatelliteFlight.toJSON(e));
    }
    if (message.mapComments?.length) {
      obj.mapComments = message.mapComments.map((e) => MapComment.toJSON(e));
    }
    if (message.userLocationShares?.length) {
      obj.userLocationShares = message.userLocationShares.map((e) => UserLocationShare.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Project>, I>>(base?: I): Project {
    return Project.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Project>, I>>(object: I): Project {
    const message = createBaseProject();
    message.infraredFlights = object.infraredFlights?.map((e) => InfraredFlight.fromPartial(e)) || [];
    message.orthoFlights = object.orthoFlights?.map((e) => OrthoFlight.fromPartial(e)) || [];
    message.videoFlights = object.videoFlights?.map((e) => VideoFlight.fromPartial(e)) || [];
    message.videoColorFinderFlights =
      object.videoColorFinderFlights?.map((e) => VideoColorFinderFlight.fromPartial(e)) || [];
    message.imageColorFinderFlights =
      object.imageColorFinderFlights?.map((e) => ImageColorFinderFlight.fromPartial(e)) || [];
    message.panoramaFlights = object.panoramaFlights?.map((e) => PanoramaFlight.fromPartial(e)) || [];
    message.icons = object.icons?.map((e) => Icon.fromPartial(e)) || [];
    message.lines = object.lines?.map((e) => Line.fromPartial(e)) || [];
    message.texts = object.texts?.map((e) => Text.fromPartial(e)) || [];
    message.perimeters = object.perimeters?.map((e) => Perimeter.fromPartial(e)) || [];
    message.PDFs = object.PDFs?.map((e) => PDFJob.fromPartial(e)) || [];
    message.groups = object.groups?.map((e) => Group.fromPartial(e)) || [];
    message.PDFRasters = object.PDFRasters?.map((e) => PDFRaster.fromPartial(e)) || [];
    message.lastUpdated = object.lastUpdated ?? "";
    message.liveVideoFlights = object.liveVideoFlights?.map((e) => LiveVideoFlight.fromPartial(e)) || [];
    message.mergedFlights = object.mergedFlights?.map((e) => MergedFlight.fromPartial(e)) || [];
    message.rulers = object.rulers?.map((e) => Ruler.fromPartial(e)) || [];
    message.orthoMasks = object.orthoMasks?.map((e) => OrthoMask.fromPartial(e)) || [];
    message.satelliteFlights = object.satelliteFlights?.map((e) => SatelliteFlight.fromPartial(e)) || [];
    message.mapComments = object.mapComments?.map((e) => MapComment.fromPartial(e)) || [];
    message.userLocationShares = object.userLocationShares?.map((e) => UserLocationShare.fromPartial(e)) || [];
    return message;
  },
};

function createBaseRange(): Range {
  return { distance: 0, color: 0 };
}

export const Range: MessageFns<Range> = {
  encode(message: Range, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.distance !== 0) {
      writer.uint32(13).float(message.distance);
    }
    if (message.color !== 0) {
      writer.uint32(16).uint32(message.color);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Range {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRange();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 13) {
            break;
          }

          message.distance = reader.float();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.color = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Range {
    return {
      distance: isSet(object.distance) ? globalThis.Number(object.distance) : 0,
      color: isSet(object.color) ? globalThis.Number(object.color) : 0,
    };
  },

  toJSON(message: Range): unknown {
    const obj: any = {};
    if (message.distance !== 0) {
      obj.distance = message.distance;
    }
    if (message.color !== 0) {
      obj.color = Math.round(message.color);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Range>, I>>(base?: I): Range {
    return Range.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Range>, I>>(object: I): Range {
    const message = createBaseRange();
    message.distance = object.distance ?? 0;
    message.color = object.color ?? 0;
    return message;
  },
};

function createBaseRuler(): Ruler {
  return {
    areaUnit: "",
    coordinates: [],
    createdAt: 0,
    createdBy: undefined,
    distanceUnit: "",
    geometryType: 0,
    id: "",
    index: "",
    name: "",
    parentId: undefined,
    visible: false,
    demoId: undefined,
    locked: undefined,
    archivedTimestamp: undefined,
  };
}

export const Ruler: MessageFns<Ruler> = {
  encode(message: Ruler, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.areaUnit !== "") {
      writer.uint32(10).string(message.areaUnit);
    }
    for (const v of message.coordinates) {
      Coordinate.encode(v!, writer.uint32(18).fork()).join();
    }
    if (message.createdAt !== 0) {
      writer.uint32(24).uint32(message.createdAt);
    }
    if (message.createdBy !== undefined) {
      Author.encode(message.createdBy, writer.uint32(34).fork()).join();
    }
    if (message.distanceUnit !== "") {
      writer.uint32(42).string(message.distanceUnit);
    }
    if (message.geometryType !== 0) {
      writer.uint32(48).int32(message.geometryType);
    }
    if (message.id !== "") {
      writer.uint32(58).string(message.id);
    }
    if (message.index !== "") {
      writer.uint32(66).string(message.index);
    }
    if (message.name !== "") {
      writer.uint32(74).string(message.name);
    }
    if (message.parentId !== undefined) {
      writer.uint32(82).string(message.parentId);
    }
    if (message.visible !== false) {
      writer.uint32(88).bool(message.visible);
    }
    if (message.demoId !== undefined) {
      writer.uint32(98).string(message.demoId);
    }
    if (message.locked !== undefined) {
      writer.uint32(104).bool(message.locked);
    }
    if (message.archivedTimestamp !== undefined) {
      writer.uint32(112).uint32(message.archivedTimestamp);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Ruler {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRuler();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.areaUnit = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.coordinates.push(Coordinate.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.createdAt = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.createdBy = Author.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.distanceUnit = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.geometryType = reader.int32();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.index = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.parentId = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.visible = reader.bool();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.demoId = reader.string();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.locked = reader.bool();
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.archivedTimestamp = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Ruler {
    return {
      areaUnit: isSet(object.areaUnit) ? globalThis.String(object.areaUnit) : "",
      coordinates: globalThis.Array.isArray(object?.coordinates)
        ? object.coordinates.map((e: any) => Coordinate.fromJSON(e))
        : [],
      createdAt: isSet(object.createdAt) ? globalThis.Number(object.createdAt) : 0,
      createdBy: isSet(object.createdBy) ? Author.fromJSON(object.createdBy) : undefined,
      distanceUnit: isSet(object.distanceUnit) ? globalThis.String(object.distanceUnit) : "",
      geometryType: isSet(object.geometryType) ? globalThis.Number(object.geometryType) : 0,
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      index: isSet(object.index) ? globalThis.String(object.index) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      parentId: isSet(object.parentId) ? globalThis.String(object.parentId) : undefined,
      visible: isSet(object.visible) ? globalThis.Boolean(object.visible) : false,
      demoId: isSet(object.demoId) ? globalThis.String(object.demoId) : undefined,
      locked: isSet(object.locked) ? globalThis.Boolean(object.locked) : undefined,
      archivedTimestamp: isSet(object.archivedTimestamp) ? globalThis.Number(object.archivedTimestamp) : undefined,
    };
  },

  toJSON(message: Ruler): unknown {
    const obj: any = {};
    if (message.areaUnit !== "") {
      obj.areaUnit = message.areaUnit;
    }
    if (message.coordinates?.length) {
      obj.coordinates = message.coordinates.map((e) => Coordinate.toJSON(e));
    }
    if (message.createdAt !== 0) {
      obj.createdAt = Math.round(message.createdAt);
    }
    if (message.createdBy !== undefined) {
      obj.createdBy = Author.toJSON(message.createdBy);
    }
    if (message.distanceUnit !== "") {
      obj.distanceUnit = message.distanceUnit;
    }
    if (message.geometryType !== 0) {
      obj.geometryType = Math.round(message.geometryType);
    }
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.index !== "") {
      obj.index = message.index;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.parentId !== undefined) {
      obj.parentId = message.parentId;
    }
    if (message.visible !== false) {
      obj.visible = message.visible;
    }
    if (message.demoId !== undefined) {
      obj.demoId = message.demoId;
    }
    if (message.locked !== undefined) {
      obj.locked = message.locked;
    }
    if (message.archivedTimestamp !== undefined) {
      obj.archivedTimestamp = Math.round(message.archivedTimestamp);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Ruler>, I>>(base?: I): Ruler {
    return Ruler.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Ruler>, I>>(object: I): Ruler {
    const message = createBaseRuler();
    message.areaUnit = object.areaUnit ?? "";
    message.coordinates = object.coordinates?.map((e) => Coordinate.fromPartial(e)) || [];
    message.createdAt = object.createdAt ?? 0;
    message.createdBy = (object.createdBy !== undefined && object.createdBy !== null)
      ? Author.fromPartial(object.createdBy)
      : undefined;
    message.distanceUnit = object.distanceUnit ?? "";
    message.geometryType = object.geometryType ?? 0;
    message.id = object.id ?? "";
    message.index = object.index ?? "";
    message.name = object.name ?? "";
    message.parentId = object.parentId ?? undefined;
    message.visible = object.visible ?? false;
    message.demoId = object.demoId ?? undefined;
    message.locked = object.locked ?? undefined;
    message.archivedTimestamp = object.archivedTimestamp ?? undefined;
    return message;
  },
};

function createBaseSatelliteFlight(): SatelliteFlight {
  return {
    archivedTimestamp: undefined,
    createdAt: 0,
    createdBy: undefined,
    demoId: undefined,
    id: "",
    index: "",
    job: undefined,
    locked: undefined,
    name: "",
    parentId: undefined,
    region: [],
    sensorType: undefined,
    visible: false,
    cloudFree: undefined,
    temporalBias: undefined,
    dehaze: undefined,
    mosaic: [],
    temporalAnchor: undefined,
  };
}

export const SatelliteFlight: MessageFns<SatelliteFlight> = {
  encode(message: SatelliteFlight, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.archivedTimestamp !== undefined) {
      writer.uint32(8).uint32(message.archivedTimestamp);
    }
    if (message.createdAt !== 0) {
      writer.uint32(16).uint32(message.createdAt);
    }
    if (message.createdBy !== undefined) {
      Author.encode(message.createdBy, writer.uint32(26).fork()).join();
    }
    if (message.demoId !== undefined) {
      writer.uint32(34).string(message.demoId);
    }
    if (message.id !== "") {
      writer.uint32(42).string(message.id);
    }
    if (message.index !== "") {
      writer.uint32(50).string(message.index);
    }
    if (message.job !== undefined) {
      SatelliteJob.encode(message.job, writer.uint32(58).fork()).join();
    }
    if (message.locked !== undefined) {
      writer.uint32(64).bool(message.locked);
    }
    if (message.name !== "") {
      writer.uint32(74).string(message.name);
    }
    if (message.parentId !== undefined) {
      writer.uint32(82).string(message.parentId);
    }
    for (const v of message.region) {
      Coordinate.encode(v!, writer.uint32(90).fork()).join();
    }
    if (message.sensorType !== undefined) {
      writer.uint32(96).int32(message.sensorType);
    }
    if (message.visible !== false) {
      writer.uint32(104).bool(message.visible);
    }
    if (message.cloudFree !== undefined) {
      writer.uint32(112).bool(message.cloudFree);
    }
    if (message.temporalBias !== undefined) {
      writer.uint32(122).string(message.temporalBias);
    }
    if (message.dehaze !== undefined) {
      writer.uint32(128).bool(message.dehaze);
    }
    for (const v of message.mosaic) {
      SatelliteMosaic.encode(v!, writer.uint32(138).fork()).join();
    }
    if (message.temporalAnchor !== undefined) {
      writer.uint32(144).uint32(message.temporalAnchor);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SatelliteFlight {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSatelliteFlight();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.archivedTimestamp = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.createdAt = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.createdBy = Author.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.demoId = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.index = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.job = SatelliteJob.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.locked = reader.bool();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.parentId = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.region.push(Coordinate.decode(reader, reader.uint32()));
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.sensorType = reader.int32();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.visible = reader.bool();
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.cloudFree = reader.bool();
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.temporalBias = reader.string();
          continue;
        }
        case 16: {
          if (tag !== 128) {
            break;
          }

          message.dehaze = reader.bool();
          continue;
        }
        case 17: {
          if (tag !== 138) {
            break;
          }

          message.mosaic.push(SatelliteMosaic.decode(reader, reader.uint32()));
          continue;
        }
        case 18: {
          if (tag !== 144) {
            break;
          }

          message.temporalAnchor = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SatelliteFlight {
    return {
      archivedTimestamp: isSet(object.archivedTimestamp) ? globalThis.Number(object.archivedTimestamp) : undefined,
      createdAt: isSet(object.createdAt) ? globalThis.Number(object.createdAt) : 0,
      createdBy: isSet(object.createdBy) ? Author.fromJSON(object.createdBy) : undefined,
      demoId: isSet(object.demoId) ? globalThis.String(object.demoId) : undefined,
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      index: isSet(object.index) ? globalThis.String(object.index) : "",
      job: isSet(object.job) ? SatelliteJob.fromJSON(object.job) : undefined,
      locked: isSet(object.locked) ? globalThis.Boolean(object.locked) : undefined,
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      parentId: isSet(object.parentId) ? globalThis.String(object.parentId) : undefined,
      region: globalThis.Array.isArray(object?.region) ? object.region.map((e: any) => Coordinate.fromJSON(e)) : [],
      sensorType: isSet(object.sensorType) ? globalThis.Number(object.sensorType) : undefined,
      visible: isSet(object.visible) ? globalThis.Boolean(object.visible) : false,
      cloudFree: isSet(object.cloudFree) ? globalThis.Boolean(object.cloudFree) : undefined,
      temporalBias: isSet(object.temporalBias) ? globalThis.String(object.temporalBias) : undefined,
      dehaze: isSet(object.dehaze) ? globalThis.Boolean(object.dehaze) : undefined,
      mosaic: globalThis.Array.isArray(object?.mosaic)
        ? object.mosaic.map((e: any) => SatelliteMosaic.fromJSON(e))
        : [],
      temporalAnchor: isSet(object.temporalAnchor) ? globalThis.Number(object.temporalAnchor) : undefined,
    };
  },

  toJSON(message: SatelliteFlight): unknown {
    const obj: any = {};
    if (message.archivedTimestamp !== undefined) {
      obj.archivedTimestamp = Math.round(message.archivedTimestamp);
    }
    if (message.createdAt !== 0) {
      obj.createdAt = Math.round(message.createdAt);
    }
    if (message.createdBy !== undefined) {
      obj.createdBy = Author.toJSON(message.createdBy);
    }
    if (message.demoId !== undefined) {
      obj.demoId = message.demoId;
    }
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.index !== "") {
      obj.index = message.index;
    }
    if (message.job !== undefined) {
      obj.job = SatelliteJob.toJSON(message.job);
    }
    if (message.locked !== undefined) {
      obj.locked = message.locked;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.parentId !== undefined) {
      obj.parentId = message.parentId;
    }
    if (message.region?.length) {
      obj.region = message.region.map((e) => Coordinate.toJSON(e));
    }
    if (message.sensorType !== undefined) {
      obj.sensorType = Math.round(message.sensorType);
    }
    if (message.visible !== false) {
      obj.visible = message.visible;
    }
    if (message.cloudFree !== undefined) {
      obj.cloudFree = message.cloudFree;
    }
    if (message.temporalBias !== undefined) {
      obj.temporalBias = message.temporalBias;
    }
    if (message.dehaze !== undefined) {
      obj.dehaze = message.dehaze;
    }
    if (message.mosaic?.length) {
      obj.mosaic = message.mosaic.map((e) => SatelliteMosaic.toJSON(e));
    }
    if (message.temporalAnchor !== undefined) {
      obj.temporalAnchor = Math.round(message.temporalAnchor);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SatelliteFlight>, I>>(base?: I): SatelliteFlight {
    return SatelliteFlight.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SatelliteFlight>, I>>(object: I): SatelliteFlight {
    const message = createBaseSatelliteFlight();
    message.archivedTimestamp = object.archivedTimestamp ?? undefined;
    message.createdAt = object.createdAt ?? 0;
    message.createdBy = (object.createdBy !== undefined && object.createdBy !== null)
      ? Author.fromPartial(object.createdBy)
      : undefined;
    message.demoId = object.demoId ?? undefined;
    message.id = object.id ?? "";
    message.index = object.index ?? "";
    message.job = (object.job !== undefined && object.job !== null) ? SatelliteJob.fromPartial(object.job) : undefined;
    message.locked = object.locked ?? undefined;
    message.name = object.name ?? "";
    message.parentId = object.parentId ?? undefined;
    message.region = object.region?.map((e) => Coordinate.fromPartial(e)) || [];
    message.sensorType = object.sensorType ?? undefined;
    message.visible = object.visible ?? false;
    message.cloudFree = object.cloudFree ?? undefined;
    message.temporalBias = object.temporalBias ?? undefined;
    message.dehaze = object.dehaze ?? undefined;
    message.mosaic = object.mosaic?.map((e) => SatelliteMosaic.fromPartial(e)) || [];
    message.temporalAnchor = object.temporalAnchor ?? undefined;
    return message;
  },
};

function createBaseSatelliteJob(): SatelliteJob {
  return { createdAt: 0, deletedAt: undefined, error: undefined, progress: undefined, status: 0, updatedAt: undefined };
}

export const SatelliteJob: MessageFns<SatelliteJob> = {
  encode(message: SatelliteJob, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.createdAt !== 0) {
      writer.uint32(8).uint32(message.createdAt);
    }
    if (message.deletedAt !== undefined) {
      writer.uint32(16).uint32(message.deletedAt);
    }
    if (message.error !== undefined) {
      writer.uint32(24).int32(message.error);
    }
    if (message.progress !== undefined) {
      writer.uint32(32).int32(message.progress);
    }
    if (message.status !== 0) {
      writer.uint32(40).int32(message.status);
    }
    if (message.updatedAt !== undefined) {
      writer.uint32(48).uint32(message.updatedAt);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SatelliteJob {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSatelliteJob();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.createdAt = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.deletedAt = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.error = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.progress = reader.int32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.status = reader.int32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.updatedAt = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SatelliteJob {
    return {
      createdAt: isSet(object.createdAt) ? globalThis.Number(object.createdAt) : 0,
      deletedAt: isSet(object.deletedAt) ? globalThis.Number(object.deletedAt) : undefined,
      error: isSet(object.error) ? globalThis.Number(object.error) : undefined,
      progress: isSet(object.progress) ? globalThis.Number(object.progress) : undefined,
      status: isSet(object.status) ? globalThis.Number(object.status) : 0,
      updatedAt: isSet(object.updatedAt) ? globalThis.Number(object.updatedAt) : undefined,
    };
  },

  toJSON(message: SatelliteJob): unknown {
    const obj: any = {};
    if (message.createdAt !== 0) {
      obj.createdAt = Math.round(message.createdAt);
    }
    if (message.deletedAt !== undefined) {
      obj.deletedAt = Math.round(message.deletedAt);
    }
    if (message.error !== undefined) {
      obj.error = Math.round(message.error);
    }
    if (message.progress !== undefined) {
      obj.progress = Math.round(message.progress);
    }
    if (message.status !== 0) {
      obj.status = Math.round(message.status);
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = Math.round(message.updatedAt);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SatelliteJob>, I>>(base?: I): SatelliteJob {
    return SatelliteJob.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SatelliteJob>, I>>(object: I): SatelliteJob {
    const message = createBaseSatelliteJob();
    message.createdAt = object.createdAt ?? 0;
    message.deletedAt = object.deletedAt ?? undefined;
    message.error = object.error ?? undefined;
    message.progress = object.progress ?? undefined;
    message.status = object.status ?? 0;
    message.updatedAt = object.updatedAt ?? undefined;
    return message;
  },
};

function createBaseSatelliteMosaic(): SatelliteMosaic {
  return { cogOrtho: undefined, processingOptions: [] };
}

export const SatelliteMosaic: MessageFns<SatelliteMosaic> = {
  encode(message: SatelliteMosaic, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.cogOrtho !== undefined) {
      CogOrtho.encode(message.cogOrtho, writer.uint32(10).fork()).join();
    }
    for (const v of message.processingOptions) {
      writer.uint32(18).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SatelliteMosaic {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSatelliteMosaic();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.cogOrtho = CogOrtho.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.processingOptions.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SatelliteMosaic {
    return {
      cogOrtho: isSet(object.cogOrtho) ? CogOrtho.fromJSON(object.cogOrtho) : undefined,
      processingOptions: globalThis.Array.isArray(object?.processingOptions)
        ? object.processingOptions.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: SatelliteMosaic): unknown {
    const obj: any = {};
    if (message.cogOrtho !== undefined) {
      obj.cogOrtho = CogOrtho.toJSON(message.cogOrtho);
    }
    if (message.processingOptions?.length) {
      obj.processingOptions = message.processingOptions;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SatelliteMosaic>, I>>(base?: I): SatelliteMosaic {
    return SatelliteMosaic.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SatelliteMosaic>, I>>(object: I): SatelliteMosaic {
    const message = createBaseSatelliteMosaic();
    message.cogOrtho = (object.cogOrtho !== undefined && object.cogOrtho !== null)
      ? CogOrtho.fromPartial(object.cogOrtho)
      : undefined;
    message.processingOptions = object.processingOptions?.map((e) => e) || [];
    return message;
  },
};

function createBaseText(): Text {
  return {
    id: "",
    createdAt: 0,
    visible: false,
    name: "",
    index: "",
    parentId: undefined,
    longitude: 0,
    latitude: 0,
    text: "",
    rotation: 0,
    baseFontSize: 0,
    fontSize: 0,
    color: 0,
    bold: false,
    createdBy: undefined,
    demoId: undefined,
    outlineColor: undefined,
    outlineWidth: undefined,
    locked: undefined,
    archivedTimestamp: undefined,
  };
}

export const Text: MessageFns<Text> = {
  encode(message: Text, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.createdAt !== 0) {
      writer.uint32(16).uint32(message.createdAt);
    }
    if (message.visible !== false) {
      writer.uint32(24).bool(message.visible);
    }
    if (message.name !== "") {
      writer.uint32(34).string(message.name);
    }
    if (message.index !== "") {
      writer.uint32(42).string(message.index);
    }
    if (message.parentId !== undefined) {
      writer.uint32(50).string(message.parentId);
    }
    if (message.longitude !== 0) {
      writer.uint32(57).double(message.longitude);
    }
    if (message.latitude !== 0) {
      writer.uint32(65).double(message.latitude);
    }
    if (message.text !== "") {
      writer.uint32(74).string(message.text);
    }
    if (message.rotation !== 0) {
      writer.uint32(80).int32(message.rotation);
    }
    if (message.baseFontSize !== 0) {
      writer.uint32(88).int32(message.baseFontSize);
    }
    if (message.fontSize !== 0) {
      writer.uint32(96).int32(message.fontSize);
    }
    if (message.color !== 0) {
      writer.uint32(104).uint32(message.color);
    }
    if (message.bold !== false) {
      writer.uint32(112).bool(message.bold);
    }
    if (message.createdBy !== undefined) {
      Author.encode(message.createdBy, writer.uint32(122).fork()).join();
    }
    if (message.demoId !== undefined) {
      writer.uint32(130).string(message.demoId);
    }
    if (message.outlineColor !== undefined) {
      writer.uint32(136).uint32(message.outlineColor);
    }
    if (message.outlineWidth !== undefined) {
      writer.uint32(144).int32(message.outlineWidth);
    }
    if (message.locked !== undefined) {
      writer.uint32(152).bool(message.locked);
    }
    if (message.archivedTimestamp !== undefined) {
      writer.uint32(160).uint32(message.archivedTimestamp);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Text {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseText();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.createdAt = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.visible = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.index = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.parentId = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 57) {
            break;
          }

          message.longitude = reader.double();
          continue;
        }
        case 8: {
          if (tag !== 65) {
            break;
          }

          message.latitude = reader.double();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.text = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.rotation = reader.int32();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.baseFontSize = reader.int32();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.fontSize = reader.int32();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.color = reader.uint32();
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.bold = reader.bool();
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.createdBy = Author.decode(reader, reader.uint32());
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.demoId = reader.string();
          continue;
        }
        case 17: {
          if (tag !== 136) {
            break;
          }

          message.outlineColor = reader.uint32();
          continue;
        }
        case 18: {
          if (tag !== 144) {
            break;
          }

          message.outlineWidth = reader.int32();
          continue;
        }
        case 19: {
          if (tag !== 152) {
            break;
          }

          message.locked = reader.bool();
          continue;
        }
        case 20: {
          if (tag !== 160) {
            break;
          }

          message.archivedTimestamp = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Text {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      createdAt: isSet(object.createdAt) ? globalThis.Number(object.createdAt) : 0,
      visible: isSet(object.visible) ? globalThis.Boolean(object.visible) : false,
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      index: isSet(object.index) ? globalThis.String(object.index) : "",
      parentId: isSet(object.parentId) ? globalThis.String(object.parentId) : undefined,
      longitude: isSet(object.longitude) ? globalThis.Number(object.longitude) : 0,
      latitude: isSet(object.latitude) ? globalThis.Number(object.latitude) : 0,
      text: isSet(object.text) ? globalThis.String(object.text) : "",
      rotation: isSet(object.rotation) ? globalThis.Number(object.rotation) : 0,
      baseFontSize: isSet(object.baseFontSize) ? globalThis.Number(object.baseFontSize) : 0,
      fontSize: isSet(object.fontSize) ? globalThis.Number(object.fontSize) : 0,
      color: isSet(object.color) ? globalThis.Number(object.color) : 0,
      bold: isSet(object.bold) ? globalThis.Boolean(object.bold) : false,
      createdBy: isSet(object.createdBy) ? Author.fromJSON(object.createdBy) : undefined,
      demoId: isSet(object.demoId) ? globalThis.String(object.demoId) : undefined,
      outlineColor: isSet(object.outlineColor) ? globalThis.Number(object.outlineColor) : undefined,
      outlineWidth: isSet(object.outlineWidth) ? globalThis.Number(object.outlineWidth) : undefined,
      locked: isSet(object.locked) ? globalThis.Boolean(object.locked) : undefined,
      archivedTimestamp: isSet(object.archivedTimestamp) ? globalThis.Number(object.archivedTimestamp) : undefined,
    };
  },

  toJSON(message: Text): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.createdAt !== 0) {
      obj.createdAt = Math.round(message.createdAt);
    }
    if (message.visible !== false) {
      obj.visible = message.visible;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.index !== "") {
      obj.index = message.index;
    }
    if (message.parentId !== undefined) {
      obj.parentId = message.parentId;
    }
    if (message.longitude !== 0) {
      obj.longitude = message.longitude;
    }
    if (message.latitude !== 0) {
      obj.latitude = message.latitude;
    }
    if (message.text !== "") {
      obj.text = message.text;
    }
    if (message.rotation !== 0) {
      obj.rotation = Math.round(message.rotation);
    }
    if (message.baseFontSize !== 0) {
      obj.baseFontSize = Math.round(message.baseFontSize);
    }
    if (message.fontSize !== 0) {
      obj.fontSize = Math.round(message.fontSize);
    }
    if (message.color !== 0) {
      obj.color = Math.round(message.color);
    }
    if (message.bold !== false) {
      obj.bold = message.bold;
    }
    if (message.createdBy !== undefined) {
      obj.createdBy = Author.toJSON(message.createdBy);
    }
    if (message.demoId !== undefined) {
      obj.demoId = message.demoId;
    }
    if (message.outlineColor !== undefined) {
      obj.outlineColor = Math.round(message.outlineColor);
    }
    if (message.outlineWidth !== undefined) {
      obj.outlineWidth = Math.round(message.outlineWidth);
    }
    if (message.locked !== undefined) {
      obj.locked = message.locked;
    }
    if (message.archivedTimestamp !== undefined) {
      obj.archivedTimestamp = Math.round(message.archivedTimestamp);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Text>, I>>(base?: I): Text {
    return Text.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Text>, I>>(object: I): Text {
    const message = createBaseText();
    message.id = object.id ?? "";
    message.createdAt = object.createdAt ?? 0;
    message.visible = object.visible ?? false;
    message.name = object.name ?? "";
    message.index = object.index ?? "";
    message.parentId = object.parentId ?? undefined;
    message.longitude = object.longitude ?? 0;
    message.latitude = object.latitude ?? 0;
    message.text = object.text ?? "";
    message.rotation = object.rotation ?? 0;
    message.baseFontSize = object.baseFontSize ?? 0;
    message.fontSize = object.fontSize ?? 0;
    message.color = object.color ?? 0;
    message.bold = object.bold ?? false;
    message.createdBy = (object.createdBy !== undefined && object.createdBy !== null)
      ? Author.fromPartial(object.createdBy)
      : undefined;
    message.demoId = object.demoId ?? undefined;
    message.outlineColor = object.outlineColor ?? undefined;
    message.outlineWidth = object.outlineWidth ?? undefined;
    message.locked = object.locked ?? undefined;
    message.archivedTimestamp = object.archivedTimestamp ?? undefined;
    return message;
  },
};

function createBaseUserLocationShare(): UserLocationShare {
  return {
    archivedTimestamp: undefined,
    createdAt: 0,
    createdBy: undefined,
    demoId: undefined,
    id: "",
    index: "",
    initialCoordinate: undefined,
    live: false,
    locked: undefined,
    name: "",
    parentId: undefined,
    visible: false,
    endedAt: undefined,
  };
}

export const UserLocationShare: MessageFns<UserLocationShare> = {
  encode(message: UserLocationShare, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.archivedTimestamp !== undefined) {
      writer.uint32(8).uint32(message.archivedTimestamp);
    }
    if (message.createdAt !== 0) {
      writer.uint32(16).uint32(message.createdAt);
    }
    if (message.createdBy !== undefined) {
      Author.encode(message.createdBy, writer.uint32(26).fork()).join();
    }
    if (message.demoId !== undefined) {
      writer.uint32(34).string(message.demoId);
    }
    if (message.id !== "") {
      writer.uint32(42).string(message.id);
    }
    if (message.index !== "") {
      writer.uint32(50).string(message.index);
    }
    if (message.initialCoordinate !== undefined) {
      Coordinate.encode(message.initialCoordinate, writer.uint32(58).fork()).join();
    }
    if (message.live !== false) {
      writer.uint32(64).bool(message.live);
    }
    if (message.locked !== undefined) {
      writer.uint32(72).bool(message.locked);
    }
    if (message.name !== "") {
      writer.uint32(82).string(message.name);
    }
    if (message.parentId !== undefined) {
      writer.uint32(90).string(message.parentId);
    }
    if (message.visible !== false) {
      writer.uint32(96).bool(message.visible);
    }
    if (message.endedAt !== undefined) {
      writer.uint32(104).uint32(message.endedAt);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UserLocationShare {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUserLocationShare();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.archivedTimestamp = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.createdAt = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.createdBy = Author.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.demoId = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.index = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.initialCoordinate = Coordinate.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.live = reader.bool();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.locked = reader.bool();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.parentId = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.visible = reader.bool();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.endedAt = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UserLocationShare {
    return {
      archivedTimestamp: isSet(object.archivedTimestamp) ? globalThis.Number(object.archivedTimestamp) : undefined,
      createdAt: isSet(object.createdAt) ? globalThis.Number(object.createdAt) : 0,
      createdBy: isSet(object.createdBy) ? Author.fromJSON(object.createdBy) : undefined,
      demoId: isSet(object.demoId) ? globalThis.String(object.demoId) : undefined,
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      index: isSet(object.index) ? globalThis.String(object.index) : "",
      initialCoordinate: isSet(object.initialCoordinate) ? Coordinate.fromJSON(object.initialCoordinate) : undefined,
      live: isSet(object.live) ? globalThis.Boolean(object.live) : false,
      locked: isSet(object.locked) ? globalThis.Boolean(object.locked) : undefined,
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      parentId: isSet(object.parentId) ? globalThis.String(object.parentId) : undefined,
      visible: isSet(object.visible) ? globalThis.Boolean(object.visible) : false,
      endedAt: isSet(object.endedAt) ? globalThis.Number(object.endedAt) : undefined,
    };
  },

  toJSON(message: UserLocationShare): unknown {
    const obj: any = {};
    if (message.archivedTimestamp !== undefined) {
      obj.archivedTimestamp = Math.round(message.archivedTimestamp);
    }
    if (message.createdAt !== 0) {
      obj.createdAt = Math.round(message.createdAt);
    }
    if (message.createdBy !== undefined) {
      obj.createdBy = Author.toJSON(message.createdBy);
    }
    if (message.demoId !== undefined) {
      obj.demoId = message.demoId;
    }
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.index !== "") {
      obj.index = message.index;
    }
    if (message.initialCoordinate !== undefined) {
      obj.initialCoordinate = Coordinate.toJSON(message.initialCoordinate);
    }
    if (message.live !== false) {
      obj.live = message.live;
    }
    if (message.locked !== undefined) {
      obj.locked = message.locked;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.parentId !== undefined) {
      obj.parentId = message.parentId;
    }
    if (message.visible !== false) {
      obj.visible = message.visible;
    }
    if (message.endedAt !== undefined) {
      obj.endedAt = Math.round(message.endedAt);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UserLocationShare>, I>>(base?: I): UserLocationShare {
    return UserLocationShare.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UserLocationShare>, I>>(object: I): UserLocationShare {
    const message = createBaseUserLocationShare();
    message.archivedTimestamp = object.archivedTimestamp ?? undefined;
    message.createdAt = object.createdAt ?? 0;
    message.createdBy = (object.createdBy !== undefined && object.createdBy !== null)
      ? Author.fromPartial(object.createdBy)
      : undefined;
    message.demoId = object.demoId ?? undefined;
    message.id = object.id ?? "";
    message.index = object.index ?? "";
    message.initialCoordinate = (object.initialCoordinate !== undefined && object.initialCoordinate !== null)
      ? Coordinate.fromPartial(object.initialCoordinate)
      : undefined;
    message.live = object.live ?? false;
    message.locked = object.locked ?? undefined;
    message.name = object.name ?? "";
    message.parentId = object.parentId ?? undefined;
    message.visible = object.visible ?? false;
    message.endedAt = object.endedAt ?? undefined;
    return message;
  },
};

function createBaseVideoColorFinderFlight(): VideoColorFinderFlight {
  return {
    id: "",
    createdAt: 0,
    visible: false,
    name: "",
    index: "",
    parentId: undefined,
    job: undefined,
    createdBy: undefined,
    isCreatedFromVideo: undefined,
    referenceVideoId: undefined,
    demoId: undefined,
    locked: undefined,
    archivedTimestamp: undefined,
    startingPosition: undefined,
  };
}

export const VideoColorFinderFlight: MessageFns<VideoColorFinderFlight> = {
  encode(message: VideoColorFinderFlight, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.createdAt !== 0) {
      writer.uint32(16).uint32(message.createdAt);
    }
    if (message.visible !== false) {
      writer.uint32(24).bool(message.visible);
    }
    if (message.name !== "") {
      writer.uint32(34).string(message.name);
    }
    if (message.index !== "") {
      writer.uint32(42).string(message.index);
    }
    if (message.parentId !== undefined) {
      writer.uint32(50).string(message.parentId);
    }
    if (message.job !== undefined) {
      VideoColorFinderJob.encode(message.job, writer.uint32(58).fork()).join();
    }
    if (message.createdBy !== undefined) {
      Author.encode(message.createdBy, writer.uint32(66).fork()).join();
    }
    if (message.isCreatedFromVideo !== undefined) {
      writer.uint32(72).bool(message.isCreatedFromVideo);
    }
    if (message.referenceVideoId !== undefined) {
      writer.uint32(82).string(message.referenceVideoId);
    }
    if (message.demoId !== undefined) {
      writer.uint32(90).string(message.demoId);
    }
    if (message.locked !== undefined) {
      writer.uint32(96).bool(message.locked);
    }
    if (message.archivedTimestamp !== undefined) {
      writer.uint32(104).uint32(message.archivedTimestamp);
    }
    if (message.startingPosition !== undefined) {
      Coordinate.encode(message.startingPosition, writer.uint32(114).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VideoColorFinderFlight {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVideoColorFinderFlight();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.createdAt = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.visible = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.index = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.parentId = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.job = VideoColorFinderJob.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.createdBy = Author.decode(reader, reader.uint32());
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.isCreatedFromVideo = reader.bool();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.referenceVideoId = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.demoId = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.locked = reader.bool();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.archivedTimestamp = reader.uint32();
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.startingPosition = Coordinate.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VideoColorFinderFlight {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      createdAt: isSet(object.createdAt) ? globalThis.Number(object.createdAt) : 0,
      visible: isSet(object.visible) ? globalThis.Boolean(object.visible) : false,
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      index: isSet(object.index) ? globalThis.String(object.index) : "",
      parentId: isSet(object.parentId) ? globalThis.String(object.parentId) : undefined,
      job: isSet(object.job) ? VideoColorFinderJob.fromJSON(object.job) : undefined,
      createdBy: isSet(object.createdBy) ? Author.fromJSON(object.createdBy) : undefined,
      isCreatedFromVideo: isSet(object.isCreatedFromVideo) ? globalThis.Boolean(object.isCreatedFromVideo) : undefined,
      referenceVideoId: isSet(object.referenceVideoId) ? globalThis.String(object.referenceVideoId) : undefined,
      demoId: isSet(object.demoId) ? globalThis.String(object.demoId) : undefined,
      locked: isSet(object.locked) ? globalThis.Boolean(object.locked) : undefined,
      archivedTimestamp: isSet(object.archivedTimestamp) ? globalThis.Number(object.archivedTimestamp) : undefined,
      startingPosition: isSet(object.startingPosition) ? Coordinate.fromJSON(object.startingPosition) : undefined,
    };
  },

  toJSON(message: VideoColorFinderFlight): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.createdAt !== 0) {
      obj.createdAt = Math.round(message.createdAt);
    }
    if (message.visible !== false) {
      obj.visible = message.visible;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.index !== "") {
      obj.index = message.index;
    }
    if (message.parentId !== undefined) {
      obj.parentId = message.parentId;
    }
    if (message.job !== undefined) {
      obj.job = VideoColorFinderJob.toJSON(message.job);
    }
    if (message.createdBy !== undefined) {
      obj.createdBy = Author.toJSON(message.createdBy);
    }
    if (message.isCreatedFromVideo !== undefined) {
      obj.isCreatedFromVideo = message.isCreatedFromVideo;
    }
    if (message.referenceVideoId !== undefined) {
      obj.referenceVideoId = message.referenceVideoId;
    }
    if (message.demoId !== undefined) {
      obj.demoId = message.demoId;
    }
    if (message.locked !== undefined) {
      obj.locked = message.locked;
    }
    if (message.archivedTimestamp !== undefined) {
      obj.archivedTimestamp = Math.round(message.archivedTimestamp);
    }
    if (message.startingPosition !== undefined) {
      obj.startingPosition = Coordinate.toJSON(message.startingPosition);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<VideoColorFinderFlight>, I>>(base?: I): VideoColorFinderFlight {
    return VideoColorFinderFlight.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VideoColorFinderFlight>, I>>(object: I): VideoColorFinderFlight {
    const message = createBaseVideoColorFinderFlight();
    message.id = object.id ?? "";
    message.createdAt = object.createdAt ?? 0;
    message.visible = object.visible ?? false;
    message.name = object.name ?? "";
    message.index = object.index ?? "";
    message.parentId = object.parentId ?? undefined;
    message.job = (object.job !== undefined && object.job !== null)
      ? VideoColorFinderJob.fromPartial(object.job)
      : undefined;
    message.createdBy = (object.createdBy !== undefined && object.createdBy !== null)
      ? Author.fromPartial(object.createdBy)
      : undefined;
    message.isCreatedFromVideo = object.isCreatedFromVideo ?? undefined;
    message.referenceVideoId = object.referenceVideoId ?? undefined;
    message.demoId = object.demoId ?? undefined;
    message.locked = object.locked ?? undefined;
    message.archivedTimestamp = object.archivedTimestamp ?? undefined;
    message.startingPosition = (object.startingPosition !== undefined && object.startingPosition !== null)
      ? Coordinate.fromPartial(object.startingPosition)
      : undefined;
    return message;
  },
};

function createBaseVideoColorFinderJob(): VideoColorFinderJob {
  return {
    createdAt: 0,
    deletedAt: undefined,
    status: 0,
    metadataPath: undefined,
    srtPath: undefined,
    videoPath: "",
    resolutions: [],
    colordataPath: "",
    cumulativeColorIndex: undefined,
    numFrames: undefined,
    anomalyPath: undefined,
  };
}

export const VideoColorFinderJob: MessageFns<VideoColorFinderJob> = {
  encode(message: VideoColorFinderJob, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.createdAt !== 0) {
      writer.uint32(8).uint32(message.createdAt);
    }
    if (message.deletedAt !== undefined) {
      writer.uint32(16).uint32(message.deletedAt);
    }
    if (message.status !== 0) {
      writer.uint32(24).int32(message.status);
    }
    if (message.metadataPath !== undefined) {
      writer.uint32(34).string(message.metadataPath);
    }
    if (message.srtPath !== undefined) {
      writer.uint32(42).string(message.srtPath);
    }
    if (message.videoPath !== "") {
      writer.uint32(50).string(message.videoPath);
    }
    for (const v of message.resolutions) {
      writer.uint32(58).string(v!);
    }
    if (message.colordataPath !== "") {
      writer.uint32(66).string(message.colordataPath);
    }
    if (message.cumulativeColorIndex !== undefined) {
      writer.uint32(74).bytes(message.cumulativeColorIndex);
    }
    if (message.numFrames !== undefined) {
      writer.uint32(80).int32(message.numFrames);
    }
    if (message.anomalyPath !== undefined) {
      writer.uint32(90).string(message.anomalyPath);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VideoColorFinderJob {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVideoColorFinderJob();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.createdAt = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.deletedAt = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.status = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.metadataPath = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.srtPath = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.videoPath = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.resolutions.push(reader.string());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.colordataPath = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.cumulativeColorIndex = reader.bytes();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.numFrames = reader.int32();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.anomalyPath = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VideoColorFinderJob {
    return {
      createdAt: isSet(object.createdAt) ? globalThis.Number(object.createdAt) : 0,
      deletedAt: isSet(object.deletedAt) ? globalThis.Number(object.deletedAt) : undefined,
      status: isSet(object.status) ? globalThis.Number(object.status) : 0,
      metadataPath: isSet(object.metadataPath) ? globalThis.String(object.metadataPath) : undefined,
      srtPath: isSet(object.srtPath) ? globalThis.String(object.srtPath) : undefined,
      videoPath: isSet(object.videoPath) ? globalThis.String(object.videoPath) : "",
      resolutions: globalThis.Array.isArray(object?.resolutions)
        ? object.resolutions.map((e: any) => globalThis.String(e))
        : [],
      colordataPath: isSet(object.colordataPath) ? globalThis.String(object.colordataPath) : "",
      cumulativeColorIndex: isSet(object.cumulativeColorIndex)
        ? bytesFromBase64(object.cumulativeColorIndex)
        : undefined,
      numFrames: isSet(object.numFrames) ? globalThis.Number(object.numFrames) : undefined,
      anomalyPath: isSet(object.anomalyPath) ? globalThis.String(object.anomalyPath) : undefined,
    };
  },

  toJSON(message: VideoColorFinderJob): unknown {
    const obj: any = {};
    if (message.createdAt !== 0) {
      obj.createdAt = Math.round(message.createdAt);
    }
    if (message.deletedAt !== undefined) {
      obj.deletedAt = Math.round(message.deletedAt);
    }
    if (message.status !== 0) {
      obj.status = Math.round(message.status);
    }
    if (message.metadataPath !== undefined) {
      obj.metadataPath = message.metadataPath;
    }
    if (message.srtPath !== undefined) {
      obj.srtPath = message.srtPath;
    }
    if (message.videoPath !== "") {
      obj.videoPath = message.videoPath;
    }
    if (message.resolutions?.length) {
      obj.resolutions = message.resolutions;
    }
    if (message.colordataPath !== "") {
      obj.colordataPath = message.colordataPath;
    }
    if (message.cumulativeColorIndex !== undefined) {
      obj.cumulativeColorIndex = base64FromBytes(message.cumulativeColorIndex);
    }
    if (message.numFrames !== undefined) {
      obj.numFrames = Math.round(message.numFrames);
    }
    if (message.anomalyPath !== undefined) {
      obj.anomalyPath = message.anomalyPath;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<VideoColorFinderJob>, I>>(base?: I): VideoColorFinderJob {
    return VideoColorFinderJob.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VideoColorFinderJob>, I>>(object: I): VideoColorFinderJob {
    const message = createBaseVideoColorFinderJob();
    message.createdAt = object.createdAt ?? 0;
    message.deletedAt = object.deletedAt ?? undefined;
    message.status = object.status ?? 0;
    message.metadataPath = object.metadataPath ?? undefined;
    message.srtPath = object.srtPath ?? undefined;
    message.videoPath = object.videoPath ?? "";
    message.resolutions = object.resolutions?.map((e) => e) || [];
    message.colordataPath = object.colordataPath ?? "";
    message.cumulativeColorIndex = object.cumulativeColorIndex ?? undefined;
    message.numFrames = object.numFrames ?? undefined;
    message.anomalyPath = object.anomalyPath ?? undefined;
    return message;
  },
};

function createBaseVideoFlight(): VideoFlight {
  return {
    id: "",
    createdAt: 0,
    visible: false,
    name: "",
    index: "",
    parentId: undefined,
    job: undefined,
    createdBy: undefined,
    demoId: undefined,
    startingPosition: undefined,
    locked: undefined,
    archivedTimestamp: undefined,
  };
}

export const VideoFlight: MessageFns<VideoFlight> = {
  encode(message: VideoFlight, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.createdAt !== 0) {
      writer.uint32(16).uint32(message.createdAt);
    }
    if (message.visible !== false) {
      writer.uint32(24).bool(message.visible);
    }
    if (message.name !== "") {
      writer.uint32(34).string(message.name);
    }
    if (message.index !== "") {
      writer.uint32(42).string(message.index);
    }
    if (message.parentId !== undefined) {
      writer.uint32(50).string(message.parentId);
    }
    if (message.job !== undefined) {
      VideoJob.encode(message.job, writer.uint32(58).fork()).join();
    }
    if (message.createdBy !== undefined) {
      Author.encode(message.createdBy, writer.uint32(66).fork()).join();
    }
    if (message.demoId !== undefined) {
      writer.uint32(74).string(message.demoId);
    }
    if (message.startingPosition !== undefined) {
      Coordinate.encode(message.startingPosition, writer.uint32(82).fork()).join();
    }
    if (message.locked !== undefined) {
      writer.uint32(88).bool(message.locked);
    }
    if (message.archivedTimestamp !== undefined) {
      writer.uint32(96).uint32(message.archivedTimestamp);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VideoFlight {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVideoFlight();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.createdAt = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.visible = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.index = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.parentId = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.job = VideoJob.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.createdBy = Author.decode(reader, reader.uint32());
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.demoId = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.startingPosition = Coordinate.decode(reader, reader.uint32());
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.locked = reader.bool();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.archivedTimestamp = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VideoFlight {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      createdAt: isSet(object.createdAt) ? globalThis.Number(object.createdAt) : 0,
      visible: isSet(object.visible) ? globalThis.Boolean(object.visible) : false,
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      index: isSet(object.index) ? globalThis.String(object.index) : "",
      parentId: isSet(object.parentId) ? globalThis.String(object.parentId) : undefined,
      job: isSet(object.job) ? VideoJob.fromJSON(object.job) : undefined,
      createdBy: isSet(object.createdBy) ? Author.fromJSON(object.createdBy) : undefined,
      demoId: isSet(object.demoId) ? globalThis.String(object.demoId) : undefined,
      startingPosition: isSet(object.startingPosition) ? Coordinate.fromJSON(object.startingPosition) : undefined,
      locked: isSet(object.locked) ? globalThis.Boolean(object.locked) : undefined,
      archivedTimestamp: isSet(object.archivedTimestamp) ? globalThis.Number(object.archivedTimestamp) : undefined,
    };
  },

  toJSON(message: VideoFlight): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.createdAt !== 0) {
      obj.createdAt = Math.round(message.createdAt);
    }
    if (message.visible !== false) {
      obj.visible = message.visible;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.index !== "") {
      obj.index = message.index;
    }
    if (message.parentId !== undefined) {
      obj.parentId = message.parentId;
    }
    if (message.job !== undefined) {
      obj.job = VideoJob.toJSON(message.job);
    }
    if (message.createdBy !== undefined) {
      obj.createdBy = Author.toJSON(message.createdBy);
    }
    if (message.demoId !== undefined) {
      obj.demoId = message.demoId;
    }
    if (message.startingPosition !== undefined) {
      obj.startingPosition = Coordinate.toJSON(message.startingPosition);
    }
    if (message.locked !== undefined) {
      obj.locked = message.locked;
    }
    if (message.archivedTimestamp !== undefined) {
      obj.archivedTimestamp = Math.round(message.archivedTimestamp);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<VideoFlight>, I>>(base?: I): VideoFlight {
    return VideoFlight.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VideoFlight>, I>>(object: I): VideoFlight {
    const message = createBaseVideoFlight();
    message.id = object.id ?? "";
    message.createdAt = object.createdAt ?? 0;
    message.visible = object.visible ?? false;
    message.name = object.name ?? "";
    message.index = object.index ?? "";
    message.parentId = object.parentId ?? undefined;
    message.job = (object.job !== undefined && object.job !== null) ? VideoJob.fromPartial(object.job) : undefined;
    message.createdBy = (object.createdBy !== undefined && object.createdBy !== null)
      ? Author.fromPartial(object.createdBy)
      : undefined;
    message.demoId = object.demoId ?? undefined;
    message.startingPosition = (object.startingPosition !== undefined && object.startingPosition !== null)
      ? Coordinate.fromPartial(object.startingPosition)
      : undefined;
    message.locked = object.locked ?? undefined;
    message.archivedTimestamp = object.archivedTimestamp ?? undefined;
    return message;
  },
};

function createBaseVideoJob(): VideoJob {
  return {
    createdAt: 0,
    deletedAt: undefined,
    status: 0,
    metadataPath: undefined,
    srtPath: undefined,
    videoPath: "",
    resolutions: [],
  };
}

export const VideoJob: MessageFns<VideoJob> = {
  encode(message: VideoJob, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.createdAt !== 0) {
      writer.uint32(8).uint32(message.createdAt);
    }
    if (message.deletedAt !== undefined) {
      writer.uint32(16).uint32(message.deletedAt);
    }
    if (message.status !== 0) {
      writer.uint32(24).int32(message.status);
    }
    if (message.metadataPath !== undefined) {
      writer.uint32(34).string(message.metadataPath);
    }
    if (message.srtPath !== undefined) {
      writer.uint32(42).string(message.srtPath);
    }
    if (message.videoPath !== "") {
      writer.uint32(50).string(message.videoPath);
    }
    for (const v of message.resolutions) {
      writer.uint32(58).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VideoJob {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVideoJob();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.createdAt = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.deletedAt = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.status = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.metadataPath = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.srtPath = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.videoPath = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.resolutions.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VideoJob {
    return {
      createdAt: isSet(object.createdAt) ? globalThis.Number(object.createdAt) : 0,
      deletedAt: isSet(object.deletedAt) ? globalThis.Number(object.deletedAt) : undefined,
      status: isSet(object.status) ? globalThis.Number(object.status) : 0,
      metadataPath: isSet(object.metadataPath) ? globalThis.String(object.metadataPath) : undefined,
      srtPath: isSet(object.srtPath) ? globalThis.String(object.srtPath) : undefined,
      videoPath: isSet(object.videoPath) ? globalThis.String(object.videoPath) : "",
      resolutions: globalThis.Array.isArray(object?.resolutions)
        ? object.resolutions.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: VideoJob): unknown {
    const obj: any = {};
    if (message.createdAt !== 0) {
      obj.createdAt = Math.round(message.createdAt);
    }
    if (message.deletedAt !== undefined) {
      obj.deletedAt = Math.round(message.deletedAt);
    }
    if (message.status !== 0) {
      obj.status = Math.round(message.status);
    }
    if (message.metadataPath !== undefined) {
      obj.metadataPath = message.metadataPath;
    }
    if (message.srtPath !== undefined) {
      obj.srtPath = message.srtPath;
    }
    if (message.videoPath !== "") {
      obj.videoPath = message.videoPath;
    }
    if (message.resolutions?.length) {
      obj.resolutions = message.resolutions;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<VideoJob>, I>>(base?: I): VideoJob {
    return VideoJob.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VideoJob>, I>>(object: I): VideoJob {
    const message = createBaseVideoJob();
    message.createdAt = object.createdAt ?? 0;
    message.deletedAt = object.deletedAt ?? undefined;
    message.status = object.status ?? 0;
    message.metadataPath = object.metadataPath ?? undefined;
    message.srtPath = object.srtPath ?? undefined;
    message.videoPath = object.videoPath ?? "";
    message.resolutions = object.resolutions?.map((e) => e) || [];
    return message;
  },
};

function bytesFromBase64(b64: string): Uint8Array {
  if ((globalThis as any).Buffer) {
    return Uint8Array.from((globalThis as any).Buffer.from(b64, "base64"));
  } else {
    const bin = globalThis.atob(b64);
    const arr = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; ++i) {
      arr[i] = bin.charCodeAt(i);
    }
    return arr;
  }
}

function base64FromBytes(arr: Uint8Array): string {
  if ((globalThis as any).Buffer) {
    return (globalThis as any).Buffer.from(arr).toString("base64");
  } else {
    const bin: string[] = [];
    arr.forEach((byte) => {
      bin.push(globalThis.String.fromCharCode(byte));
    });
    return globalThis.btoa(bin.join(""));
  }
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
